// import React, { useState, useEffect } from "react";
// import {
//   Container, Box, Tabs, Tab, Typography, Card, CardContent,
//   Grid, TextField, FormControl, InputLabel, Select, MenuItem,
//   Button, Snackbar, Alert, Paper, Table, TableBody, TableCell,
//   TableContainer, TableHead, TableRow, Chip, IconButton,
//   Tooltip, TablePagination, CircularProgress,
//   Dialog, DialogTitle, DialogContent, DialogActions,
//   Stepper, Step, StepLabel, Stack
// } from "@mui/material";
// import {
//   Search as SearchIcon,
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   Visibility as ViewIcon,
//   Refresh as RefreshIcon,
//   Business as BusinessIcon,
//   Home as HomeIcon,
//   Store as StoreIcon,
//   Agriculture as LandIcon,
//   Add as AddIcon,
//   Factory as FactoryIcon,
//   AttachMoney as MoneyIcon,
//   Description as DescriptionIcon,
//   Save as SaveIcon,
//   MeetingRoom as MeetingRoomIcon,
//   Apartment as ApartmentIcon,
//   Shop as ShopIcon,
//   Cancel as CancelIcon,
//   Upload as UploadIcon,
//   Close as CloseIcon
// } from "@mui/icons-material";
// import { Link } from "react-router-dom";

// import { ExecutePostWithParams, GetDataFromApiWithParams, GetDataFromApiWithParamsAndGetResponse, UpdateAndGetResponse } from "../../../../services/api/ExecuteApiRequests";
// import useDecodedUser from "../../../../services/hooks/useDecodedUser";
// import "./agreement.css";

// // ------------------------------------------------------------
// // 1. Agreement Type Definitions
// // ------------------------------------------------------------
// const agreementTypes = [
//   { id: "Shed Land", label: "Shed Rental", icon: <BusinessIcon /> },
//   { id: "Leased Land", label: "Leased Land", icon: <LandIcon /> },
//   { id: "Residential", label: "Residential", icon: <HomeIcon /> },
//   { id: "Commercial", label: "Commercial / One Stop Services", icon: <StoreIcon /> }
// ];

// // Steps for Shed/Leased Land Wizard
// const shedLandSteps = [
//   "Basic Information",
//   "Investment & Contract Details",
//   "Production & Capacity",
//   "Market & Disposal",
//   "Financial & Contractual Details",
//   "Summary & Description"
// ];

// // Steps for Residential Wizard
// const residentialSteps = [
//   "Location & Room Information",
//   "Financial & Date Details"
// ];

// // Steps for Commercial Wizard
// const commercialSteps = [
//   "Service & Location Information",
//   "Financial & Contract Details"
// ];

// // Base fields common to ALL types
// const baseFields = {
//   agreement_id: "",
//   tenant_id: "",
//   investor_name: "",
//   park_id: "",
//   park_name: "",
//   upin: [],
//   current_status: "ACTIVE",
//   contract_issue: "",
//   contract_renewal: "",
//   handover_date: "",
//   mou_signed: "",
//   mou_attachment: null,
//   description: ""
// };

// // ===== SHED (Full industrial terms - all 6 steps) =====
// const shedFields = {
//   ownership_type: "Shed Rent",
//   upin: [],
//   agreement_id: "",
//   investment_type: "",
//   contract_issue: "",
//   contract_renewal: "",
//   contract_period: "",
//   handover_date: "",
//   production_commencement_date: "",
//   production_capacity: "",
//   export_capacity: "",
//   employee_capacity: "",
//   market_destination: "",
//   intl_brands_link: "",
//   disposal_method: "",
//   monthly_rent: 0,
//   area_sqm: 0,
//   area_as_per_contract_in_m2: "",
//   security: 0,
//   advance_payment: 0,
//   annual_mngmnt_service_fee: 1.5,
//   payment_mode: "usd",
//   grace_period_ending_date: "",
//   late_charge_fee: 5,
//   penality_rate: "%",
//   management_fee_per_sqm: 1.5,
//   late_charge_percent: 5,
//   water_rates: "I",
//   stp_charges: 0.801,
//   etp_charges: 0.801,
//   grace_period_months: 3,
//   mou_signed: "",
//   mou_attachment: null,
//   description: ""
// };

// // ===== LEASED LAND (Full industrial terms - all 6 steps) =====
// const leasedLandFields = {
//   ownership_type: "Land Leased",
//   upin: [],
//   agreement_id: "",
//   investment_type: "",
//   contract_issue: "",
//   contract_renewal: "",
//   contract_period: "",
//   handover_date: "",
//   production_commencement_date: "",
//   production_capacity: "",
//   export_capacity: "",
//   employee_capacity: "",
//   market_destination: "",
//   intl_brands_link: "",
//   disposal_method: "",
//   annual_lease_rate: 0,
//   area_sqm: 0,
//   area_as_per_contract_in_m2: "",
//   security: 0,
//   advance_payment: 0,
//   annual_mngmnt_service_fee: 1.5,
//   payment_mode: "usd",
//   grace_period_ending_date: "",
//   late_charge_fee: 5,
//   penality_rate: "%",
//   management_fee_per_sqm: 1.5,
//   late_charge_percent: 5,
//   water_rates: "I",
//   stp_charges: 0.801,
//   etp_charges: 0.801,
//   grace_period_months: 18,
//   mou_signed: "",
//   mou_attachment: null,
//   description: ""
// };

// // ===== RESIDENTIAL (2 Steps - with Building and Room Number) =====
// const residentialFields = {
//   building_number: "",
//   building_name: "",
//   floor_number: "",
//   ownership_type: "Residential",
//   room_details: [],
//   monthly_rent: 0,
//   advance_months: 3,
//   advance_payment: 0,
//   security: 0,
//   contract_issue: "",
//   contract_renewal: "",
//   handover_date: "",
//   upin: [],
//   agreement_id: "",
//   mou_signed: "",
//   mou_attachment: null,
//   description: ""
// };

// // ===== COMMERCIAL / ONE STOP SERVICES (2 Steps) =====
// const commercialFields = {
//   service_type: "",
//   shop_details: [],
//   monthly_rent: 0,
//   total_area_sqm: 0,
//   ownership_type: "Commercial",
//   security: 0,
//   advance_payment: 0,
//   contract_issue: "",
//   contract_renewal: "",
//   handover_date: "",
//   upin: [],
//   agreement_id: "",
//   mou_signed: "",
//   mou_attachment: null,
//   description: ""
// };

// // Investment Options
// const investmentOptions = [
//   "Textile & Apparel",
//   "ICT",
//   "Pharmaceutical",
//   "Agro processing",
//   "Construction",
//   "Food Products and Beverage",
//   "Leather & Leather products",
//   "Chemicals",
//   "Wood Paper & Furniture",
//   "Cement",
//   "Alluminium Product",
//   "Paper Packaging",
//   "Energy Meter",
//   "Pastic pipe and Condit",
//   "Plastic Recycliging for construction materials",
//   "Motor vehicles",
//   "Basic Iron & Steel",
//   "Water-based paint",
//   "Garment Manufacturing",
//   "Machinery",
//   "Plastic & Rubber",
//   "Other"
// ];

// // Room types
// const roomTypes = [
//   { id: "family", name: "Family Room", defaultArea: 73.44, defaultPrice: 14.24 },
//   { id: "suit1", name: "Suit Room Type 1", defaultArea: 48.3, defaultPrice: 14.24 },
//   { id: "suit2", name: "Suit Room Type 2", defaultArea: 77, defaultPrice: 14.24 }
// ];

// // Service Types for Commercial
// const serviceTypes = [
//   "One Stop Shop",
//   "Ethio-Tele",
//   "Retail Shop",
//   "Office Space",
//   "Banking Service",
//   "Restaurant/Café",
//   "Pharmacy",
//   "Other"
// ];

// // Payment Modes
// const paymentModes = [
//   { id: "usd", label: "USD" },
//   { id: "birr", label: "Birr" }
// ];

// // Get initial form data based on type
// const getInitialFormData = (type = "Shed Land") => {
//   let typeSpecific = {};
  
//   switch(type) {
//     case "Shed Land":
//       typeSpecific = shedFields;
//       break;
//     case "Leased Land":
//       typeSpecific = leasedLandFields;
//       break;
//     case "Residential":
//       typeSpecific = residentialFields;
//       break;
//     case "Commercial":
//       typeSpecific = commercialFields;
//       break;
//     default:
//       typeSpecific = shedFields;
//   }
  
//   return {
//     ...baseFields,
//     ...typeSpecific,
//     agreement_type: type
//   };
// };

// // Helper function to safely format numbers
// const safeToFixed = (value, decimals = 2) => {
//   const num = typeof value === 'number' ? value : parseFloat(value);
//   return isNaN(num) ? '0.00' : num.toFixed(decimals);
// };

// // Helper function to format date for input
// const formatDateForInput = (dateValue) => {
//   if (!dateValue || dateValue === 'Not Set' || dateValue === '1900-01-01') return '';
  
//   if (typeof dateValue === 'string' && dateValue.match(/^\d{4}-\d{2}-\d{2}/)) {
//     return dateValue.split('T')[0];
//   }
  
//   if (dateValue instanceof Date) {
//     return dateValue.toISOString().split('T')[0];
//   }
  
//   if (typeof dateValue === 'string' && dateValue.includes('-')) {
//     const parts = dateValue.split('-');
//     if (parts.length === 3) {
//       const day = parseInt(parts[0], 10);
//       const month = parseInt(parts[1], 10);
//       const year = parseInt(parts[2], 10);
//       if (!isNaN(day) && !isNaN(month) && !isNaN(year) && 
//           day >= 1 && day <= 31 && month >= 1 && month <= 12) {
//         return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
//       }
//     }
//   }
  
//   if (typeof dateValue === 'string' && dateValue.includes('/')) {
//     const parts = dateValue.split('/');
//     if (parts.length === 3) {
//       return `${parts[2]}-${String(parts[1]).padStart(2, '0')}-${String(parts[0]).padStart(2, '0')}`;
//     }
//   }
  
//   return '';
// };

// // ------------------------------------------------------------
// // TabPanel component
// // ------------------------------------------------------------
// function TabPanel(props) {
//   const { children, value, index, ...other } = props;
//   return (
//     <div role="tabpanel" hidden={value !== index} {...other}>
//       {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
//     </div>
//   );
// }

// // ------------------------------------------------------------
// // Main Component
// // ------------------------------------------------------------
// export default function AgreementManagement() {
//   const [mainTabValue, setMainTabValue] = useState(0);
//   const [formData, setFormData] = useState(getInitialFormData("Shed Land"));
//   const [isLoading, setIsLoading] = useState(false);
//   const [agreements, setAgreements] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [toast, setToast] = useState({ open: false, message: "", severity: "success" });
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [editingAgreementId, setEditingAgreementId] = useState(null);

//   // Shed/Land wizard step state
//   const [shedLandStep, setShedLandStep] = useState(0);
  
//   // Residential wizard step state
//   const [residentialStep, setResidentialStep] = useState(0);
  
//   // Commercial wizard step state
//   const [commercialStep, setCommercialStep] = useState(0);

//   // Park & Investor & Parcel states
//   const [parks, setParks] = useState([]);
//   const [selectedPark, setSelectedPark] = useState(null);
//   const [investors, setInvestors] = useState([]);
//   const [parcelInPark, setParcelInPark] = useState([]);
//   const [selectedUpins, setSelectedUpins] = useState([]);

//   // Room dialog state for Residential
//   const [roomDialogOpen, setRoomDialogOpen] = useState(false);
//   const [newRoom, setNewRoom] = useState({
//     type: "family",
//     count: 1,
//     area: 73.44,
//     pricePerSqm: 14.24,
//     room_number: ""
//   });
//   const [roomNumberError, setRoomNumberError] = useState(false);
//   const [editingRoomIndex, setEditingRoomIndex] = useState(null);

//   // Shop dialog state for Commercial
//   const [shopDialogOpen, setShopDialogOpen] = useState(false);
//   const [newShop, setNewShop] = useState({
//     building_number: "",
//     shop_number: "",
//     area_sqm: 0,
//     monthly_rent: 0,
//     description: ""
//   });
//   const [shopErrors, setShopErrors] = useState({
//     building_number: false,
//     shop_number: false,
//     area_sqm: false,
//     monthly_rent: false
//   });
//   const [editingShopIndex, setEditingShopIndex] = useState(null);

//   // Search & View tab states
//   const [filterType, setFilterType] = useState("expert_edit");
//   const [shedInPark, setShedInPark] = useState([]);
//   const [loadingAgreements, setLoadingAgreements] = useState(false);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
  
//   // Expert edit agreements state
//   const [expertEditAgreements, setExpertEditAgreements] = useState([]);
//   const [loadingExpertEdit, setLoadingExpertEdit] = useState(false);
  
//   // Rejected agreements state
//   const [rejectedAgreements, setRejectedAgreements] = useState([]);
//   const [loadingRejected, setLoadingRejected] = useState(false);
  
//   // View Details Dialog
//   const [viewDialogOpen, setViewDialogOpen] = useState(false);
//   const [viewingAgreement, setViewingAgreement] = useState(null);

//   const decodedUser = useDecodedUser();
//   const userValuesArray = Object.values(decodedUser || {});

//   // Local state for shed selection in Step 1
//   const [localSelectedShedId, setLocalSelectedShedId] = useState("");

//   // Reset shed selection when park changes
//   useEffect(() => {
//     setLocalSelectedShedId("");
//   }, [selectedPark]);

//   // ---------- Toast Helpers ----------
//   const showToast = (msg, severity = "success") => {
//     setToast({ open: true, message: msg, severity });
//   };

//   const handleToastClose = (event, reason) => {
//     if (reason === 'clickaway') return;
//     setToast({ ...toast, open: false });
//   };

//   // ---------- Fetch Parks ----------
//   const fetchParks = async () => {
//     try {
//       const data = await GetDataFromApiWithParams("parks");
//       setParks(data || []);
//     } catch (error) {
//       console.error("Failed to fetch parks", error);
//     }
//   };

//   // ---------- Fetch Investors ----------
//   const fetchInvestors = async () => {
//     try {
//       const data = await GetDataFromApiWithParams("investors");
//       setInvestors(data || []);
//     } catch (error) {
//       console.error("Failed to fetch investors", error);
//     }
//   };

//   // ---------- Fetch Available Parcels ----------
//   const fetchAvailableParcels = async (parkId) => {
//     if (!parkId) return;
//     try {
//       const res = await GetDataFromApiWithParams(`availableParcelsInPark/${parkId}`);
//       const allParcels = Array.isArray(res) ? res : [];
//       setParcelInPark(allParcels);
//       console.log("Fetched parcels:", allParcels);
//     } catch (error) {
//       console.error("Failed to fetch available parcels", error);
//       setParcelInPark([]);
//     }
//   };

//   // ---------- Fetch Sheds in Park ----------
//   const fetchShedInPark = async (parkId) => {
//     if (!parkId) return;
//     try {
//       const res = await GetDataFromApiWithParams(`availableShedInPark/${parkId}`, { params: { id: parkId } });
//       setShedInPark(Array.isArray(res) ? res : []);
//       console.log("Fetched sheds:", res);
//     } catch (error) {
//       console.error("Failed to fetch sheds", error);
//       setShedInPark([]);
//     }
//   };

//   // ---------- Generate Agreement ID ----------
//   const generateAgreementId = async (parkId) => {
//     if (!parkId) {
//       setFormData(prev => ({ ...prev, agreement_id: "" }));
//       return;
//     }
//     try {
//       const result = await GetDataFromApiWithParamsAndGetResponse(`agreements/${parkId}/getNewId`);
//       if (result?.data?.new_id) {
//         setFormData(prev => ({ ...prev, agreement_id: result.data.new_id }));
//       }
//     } catch (error) {
//       console.error("Failed to generate agreement ID", error);
//     }
//   };

//   // ---------- Handle Park Selection ----------
//   const handleParkChange = async (e) => {
//     const parkId = e.target.value;
//     const park = parks.find(p => p.id === parkId);
//     setSelectedPark(park);
//     setFormData(prev => ({ 
//       ...prev, 
//       park_id: parkId,
//       park_name: park?.name || ""
//     }));
    
//     if (formData.agreement_type === "Shed Land" || formData.agreement_type === "Leased Land") {
//       setSelectedUpins([]);
//       setFormData(prev => ({ ...prev, upin: [] }));
//       setLocalSelectedShedId("");
      
//       // Fetch parcels for both types
//       await fetchAvailableParcels(parkId);
      
//       // Fetch sheds only for Shed Land
//       if (formData.agreement_type === "Shed Land") {
//         await fetchShedInPark(parkId);
//       }
//     }
    
//     if (!isEditMode) {
//       generateAgreementId(parkId);
//     }
//   };

//   // ---------- Handle Investor Selection ----------
//   const handleInvestorChange = (e) => {
//     const investorId = e.target.value;
//     const investor = investors.find(i => i.id === investorId);
//     setFormData(prev => ({ 
//       ...prev, 
//       tenant_id: investorId,
//       investor_name: investor?.company_name || investor?.name || ""
//     }));
//   };

//   // ---------- Handle Shed Selection ----------
//   const handleShedSelection = (shedId) => {
//     setLocalSelectedShedId(shedId);
    
//     // Find the selected shed from shedInPark
//     const selectedShed = shedInPark?.find(shed => shed.shed_id === shedId);
    
//     if (selectedShed && selectedShed.upin) {
//       // Clear existing selections and add the new UPIN
//       const newSelectedUpins = [selectedShed.upin];
//       setSelectedUpins(newSelectedUpins);
//       setFormData(prev => ({ 
//         ...prev, 
//         upin: newSelectedUpins,
//         ownership_type: "Shed Rent"
//       }));
      
//       console.log(`Selected shed: ${shedId} with UPIN: ${selectedShed.upin}`);
//     }
//   };

//   // ---------- Handle Parcel Selection (for Leased Land) ----------
//   const handleParcelSelection = (upin) => {
//     if (!selectedUpins.includes(upin)) {
//       const newSelectedUpins = [...selectedUpins, upin];
//       setSelectedUpins(newSelectedUpins);
//       setFormData(prev => ({ ...prev, upin: newSelectedUpins }));

//       const theParcel = parcelInPark.find(parcel => parcel.upin === upin);
//       if (theParcel?.type === "land") {
//         setFormData(prev => ({ ...prev, ownership_type: "Land Leased" }));
//       }
//     }
//   };

//   // ---------- Handle UPIN Removal ----------
//   const handleRemoveUpin = (upinToRemove) => {
//     const filteredUpins = selectedUpins.filter(upin => upin !== upinToRemove);
//     setSelectedUpins(filteredUpins);
//     setFormData(prev => ({ ...prev, upin: filteredUpins }));
    
//     // Clear selected shed if UPIN is removed and we're in Shed Land mode
//     if (filteredUpins.length === 0 && formData.agreement_type === "Shed Land") {
//       setLocalSelectedShedId("");
//       setFormData(prev => ({ ...prev, ownership_type: "" }));
//     }
//   };

//   // ---------- Agreement Type Change ----------
//   const handleAgreementTypeChange = (e) => {
//     const newType = e.target.value;
//     const newFormData = getInitialFormData(newType);
//     setFormData(newFormData);
//     setSelectedPark(null);
//     setSelectedUpins([]);
//     setParcelInPark([]);
//     setShedInPark([]);
//     setLocalSelectedShedId("");
//     setShedLandStep(0);
//     setResidentialStep(0);
//     setCommercialStep(0);
//     setRoomDialogOpen(false);
//     setShopDialogOpen(false);
//   };

//   // ---------- Generic Field Change ----------
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   // ---------- Calculate Contract Period ----------
//   const getMonthsBetween = (date1, date2) => {
//     if (!date1 || !date2) return 0;
//     const d1 = new Date(date1);
//     const d2 = new Date(date2);
//     let months = (d2.getFullYear() - d1.getFullYear()) * 12;
//     months -= d1.getMonth();
//     months += d2.getMonth();
//     if (d2.getDate() < d1.getDate()) months--;
//     return months <= 0 ? 0 : months;
//   };

//   // ---------- Handle Contract Issue Date Change ----------
//   const handleIssueDateChange = (date) => {
//     setFormData(prev => ({ ...prev, contract_issue: date }));
    
//     if (formData.agreement_type === "Shed Land" || formData.agreement_type === "Leased Land") {
//       if (!formData.grace_period_ending_date) {
//         const gracePeriodMonths = formData.agreement_type === "Shed Land" ? 3 : 18;
//         const graceDate = new Date(date);
//         graceDate.setMonth(graceDate.getMonth() + gracePeriodMonths);
//         setFormData(prev => ({ 
//           ...prev, 
//           contract_issue: date,
//           grace_period_ending_date: graceDate.toISOString().split('T')[0]
//         }));
//       }
//     }
//   };

//   // ---------- Handle Renewal Date Change ----------
//   const handleRenewalDateChange = (date) => {
//     setFormData(prev => ({ ...prev, contract_renewal: date }));
//     if (formData.contract_issue && (formData.agreement_type === "Shed Land" || formData.agreement_type === "Leased Land")) {
//       const period = getMonthsBetween(formData.contract_issue, date);
//       setFormData(prev => ({ ...prev, contract_period: period }));
//     }
//   };

//   // ---------- RESIDENTIAL: Add/Edit Room ----------
//   const handleAddRoom = () => {
//     const totalArea = newRoom.count * newRoom.area;
//     const monthlyRent = totalArea * newRoom.pricePerSqm;
    
//     const roomToAdd = {
//       type: newRoom.type,
//       count: newRoom.count,
//       area: newRoom.area,
//       pricePerSqm: newRoom.pricePerSqm,
//       room_number: newRoom.room_number,
//       totalArea,
//       monthlyRent,
//       id_pk: newRoom.id_pk || Date.now()
//     };
    
//     let updatedRooms;
//     if (editingRoomIndex !== null) {
//       updatedRooms = [...formData.room_details];
//       updatedRooms[editingRoomIndex] = roomToAdd;
//       setEditingRoomIndex(null);
//     } else {
//       updatedRooms = [...(formData.room_details || []), roomToAdd];
//     }
    
//     const totalMonthlyRent = updatedRooms.reduce((sum, room) => sum + room.monthlyRent, 0);
//     const advancePaymentTotal = totalMonthlyRent * (formData.advance_months || 3);
    
//     setFormData(prev => ({
//       ...prev,
//       room_details: updatedRooms,
//       monthly_rent: totalMonthlyRent,
//       advance_payment: advancePaymentTotal
//     }));
    
//     setRoomDialogOpen(false);
//     setRoomNumberError(false);
//     setNewRoom({
//       type: "family",
//       count: 1,
//       area: 73.44,
//       pricePerSqm: 14.24,
//       room_number: ""
//     });
//   };

//   // ---------- RESIDENTIAL: Edit Room ----------
//   const handleEditRoom = (index) => {
//     const room = formData.room_details[index];
//     setNewRoom({
//       type: room.type,
//       count: room.count,
//       area: room.area,
//       pricePerSqm: room.pricePerSqm,
//       room_number: room.room_number,
//       id_pk: room.id_pk
//     });
//     setEditingRoomIndex(index);
//     setRoomDialogOpen(true);
//   };

//   // ---------- RESIDENTIAL: Remove Room ----------
//   const handleRemoveRoom = (index) => {
//     const updatedRooms = [...formData.room_details];
//     updatedRooms.splice(index, 1);
//     const totalMonthlyRent = updatedRooms.reduce((sum, room) => sum + room.monthlyRent, 0);
//     const advancePaymentTotal = totalMonthlyRent * (formData.advance_months || 3);
//     setFormData(prev => ({
//       ...prev,
//       room_details: updatedRooms,
//       monthly_rent: totalMonthlyRent,
//       advance_payment: advancePaymentTotal
//     }));
//   };

//   // ---------- RESIDENTIAL: Update Advance Months ----------
//   const handleAdvanceMonthsChange = (e) => {
//     const months = parseInt(e.target.value) || 3;
//     const advanceTotal = (formData.monthly_rent || 0) * months;
//     setFormData(prev => ({
//       ...prev,
//       advance_months: months,
//       advance_payment: advanceTotal
//     }));
//   };

//   // ---------- COMMERCIAL: Add/Edit Shop ----------
//   const handleAddShop = () => {
//     const errors = {
//       building_number: !newShop.building_number || newShop.building_number.trim() === "",
//       shop_number: !newShop.shop_number || newShop.shop_number.trim() === "",
//       area_sqm: !newShop.area_sqm || newShop.area_sqm <= 0,
//       monthly_rent: !newShop.monthly_rent || newShop.monthly_rent <= 0
//     };
    
//     setShopErrors(errors);
    
//     if (errors.building_number || errors.shop_number || errors.area_sqm || errors.monthly_rent) {
//       showToast("Please fill all required fields correctly", "warning");
//       return;
//     }
    
//     const shopToAdd = {
//       ...newShop,
//       id_pk: newShop.id_pk || Date.now(),
//       monthly_rent: parseFloat(newShop.monthly_rent) || 0,
//       area_sqm: parseFloat(newShop.area_sqm) || 0
//     };
    
//     let updatedShops;
//     if (editingShopIndex !== null) {
//       updatedShops = [...formData.shop_details];
//       updatedShops[editingShopIndex] = shopToAdd;
//       setEditingShopIndex(null);
//     } else {
//       updatedShops = [...(formData.shop_details || []), shopToAdd];
//     }
    
//     const totalMonthlyRent = updatedShops.reduce((sum, shop) => sum + (shop.monthly_rent || 0), 0);
//     const totalArea = updatedShops.reduce((sum, shop) => sum + (shop.area_sqm || 0), 0);
    
//     setFormData(prev => ({
//       ...prev,
//       shop_details: updatedShops,
//       monthly_rent: totalMonthlyRent,
//       total_area_sqm: totalArea
//     }));
    
//     setShopDialogOpen(false);
//     setShopErrors({
//       building_number: false,
//       shop_number: false,
//       area_sqm: false,
//       monthly_rent: false
//     });
//     setNewShop({
//       building_number: "",
//       shop_number: "",
//       area_sqm: 0,
//       monthly_rent: 0,
//       description: ""
//     });
//   };

//   // ---------- COMMERCIAL: Edit Shop ----------
//   const handleEditShop = (index) => {
//     const shop = formData.shop_details[index];
//     setNewShop({
//       building_number: shop.building_number,
//       shop_number: shop.shop_number,
//       area_sqm: shop.area_sqm,
//       monthly_rent: shop.monthly_rent,
//       description: shop.description || "",
//       id_pk: shop.id_pk
//     });
//     setEditingShopIndex(index);
//     setShopDialogOpen(true);
//   };

//   // ---------- COMMERCIAL: Remove Shop ----------
//   const handleRemoveShop = (index) => {
//     const updatedShops = [...formData.shop_details];
//     updatedShops.splice(index, 1);
//     const totalMonthlyRent = updatedShops.reduce((sum, shop) => sum + (shop.monthly_rent || 0), 0);
//     const totalArea = updatedShops.reduce((sum, shop) => sum + (shop.area_sqm || 0), 0);
//     setFormData(prev => ({
//       ...prev,
//       shop_details: updatedShops,
//       monthly_rent: totalMonthlyRent,
//       total_area_sqm: totalArea
//     }));
//   };

//   // ---------- Handle File Attachment ----------
//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setFormData(prev => ({ ...prev, mou_attachment: file }));
//     }
//   };

//   const handleRemoveFile = () => {
//     setFormData(prev => ({ 
//       ...prev, 
//       mou_attachment: null,
//       mou_attachment_existing: null
//     }));
//   };

//   // ---------- Wizard Navigation ----------
//   const handleShedLandNextStep = () => {
//     if (validateShedLandStep(shedLandStep)) {
//       setShedLandStep(prev => prev + 1);
//     } else {
//       showToast("Please fill all required fields before proceeding.", "warning");
//     }
//   };

//   const handleShedLandPrevStep = () => {
//     setShedLandStep(prev => prev - 1);
//   };

//   const handleResidentialNextStep = () => {
//     if (validateResidentialStep(residentialStep)) {
//       setResidentialStep(prev => prev + 1);
//     } else {
//       showToast("Please fill all required fields before proceeding.", "warning");
//     }
//   };

//   const handleResidentialPrevStep = () => {
//     setResidentialStep(prev => prev - 1);
//   };

//   const handleCommercialNextStep = () => {
//     if (validateCommercialStep(commercialStep)) {
//       setCommercialStep(prev => prev + 1);
//     } else {
//       showToast("Please fill all required fields before proceeding.", "warning");
//     }
//   };

//   const handleCommercialPrevStep = () => {
//     setCommercialStep(prev => prev - 1);
//   };

//   // ---------- Validate Steps ----------
//   const validateShedLandStep = (step) => {
//     switch(step) {
//       case 0: 
//         const hasValidSelection = selectedUpins.length > 0;
//         return formData.park_id && formData.tenant_id && hasValidSelection;
//       case 1: return formData.investment_type && formData.contract_issue && formData.contract_renewal;
//       case 2: return formData.production_capacity && formData.export_capacity && formData.employee_capacity;
//       case 3: return formData.market_destination && formData.disposal_method;
//       case 4: return formData.monthly_rent && formData.area_as_per_contract_in_m2 && formData.security;
//       default: return true;
//     }
//   };

//   const validateResidentialStep = (step) => {
//     switch(step) {
//       case 0: return formData.park_id && formData.tenant_id;
//       case 1: return formData.room_details && formData.room_details.length > 0;
//       default: return true;
//     }
//   };

//   const validateCommercialStep = (step) => {
//     switch(step) {
//       case 0: return formData.park_id && formData.tenant_id && formData.service_type && formData.shop_details && formData.shop_details.length > 0;
//       case 1: return formData.contract_issue && formData.contract_renewal;
//       default: return true;
//     }
//   };

//   // ---------- Reset Form ----------
//   const resetForm = () => {
//     setFormData(getInitialFormData("Shed Land"));
//     setSelectedPark(null);
//     setSelectedUpins([]);
//     setShedInPark([]);
//     setLocalSelectedShedId("");
//     setShedLandStep(0);
//     setResidentialStep(0);
//     setCommercialStep(0);
//     setIsEditMode(false);
//     setEditingAgreementId(null);
//     setEditingRoomIndex(null);
//     setEditingShopIndex(null);
//   };

//   // ---------- Fetch Agreements List ----------
//   const fetchAgreements = async () => {
//     setLoadingAgreements(true);
//     try {
//       const data = await GetDataFromApiWithParams("agreements");
//       setAgreements(data || []);
//     } catch (error) {
//       console.error("Failed to fetch agreements", error);
//       showToast("Failed to fetch agreements", "error");
//       setAgreements([]);
//     } finally {
//       setLoadingAgreements(false);
//     }
//   };

//   // ---------- Fetch Agreements for Expert Edit ----------
//   const fetchAgreementsForExpertEdit = async () => {
//     setLoadingExpertEdit(true);
//     try {
//       const data = await GetDataFromApiWithParams("agreements/agreements_for_edit_by_expert");
//       console.log("Expert edit agreements response:", data);
//       setExpertEditAgreements(data || []);
//     } catch (error) {
//       console.error("Failed to fetch agreements for expert edit", error);
//       showToast("Failed to fetch agreements for expert edit", "error");
//       setExpertEditAgreements([]);
//     } finally {
//       setLoadingExpertEdit(false);
//     }
//   };

//   // ---------- Fetch Rejected Agreements ----------
//   const fetchRejectedAgreements = async () => {
//     setLoadingRejected(true);
//     try {
//       const data = await GetDataFromApiWithParams("agreements/rejected");
//       console.log("Rejected agreements:", data);
//       setRejectedAgreements(data || []);
//     } catch (error) {
//       console.error("Failed to fetch rejected agreements", error);
//       showToast("Failed to fetch rejected agreements", "error");
//       setRejectedAgreements([]);
//     } finally {
//       setLoadingRejected(false);
//     }
//   };

//   // ---------- Handle View Mode Change ----------
//   const handleViewModeChange = (event) => {
//     const newMode = event.target.value;
//     setFilterType(newMode);
//     setPage(0);
    
//     if (newMode === "expert_edit") {
//       fetchAgreementsForExpertEdit();
//     }
//   };

//   // ---------- Load Agreement Data into Form for Editing ----------
//   const handleEditClick = async (agreement) => {
//     console.log("=== EDIT CLICK DEBUG ===");
//     console.log("Agreement:", agreement);
    
//     // Determine agreement type
//     let agreementTypeValue = agreement.agreement_type;
//     if (!agreementTypeValue) {
//       if (agreement.ownership_type === 'Shed Rent') agreementTypeValue = 'Shed Land';
//       else if (agreement.ownership_type === 'Land Leased') agreementTypeValue = 'Leased Land';
//       else if (agreement.ownership_type === 'Residential') agreementTypeValue = 'Residential';
//       else if (agreement.ownership_type === 'Commercial') agreementTypeValue = 'Commercial';
//       else agreementTypeValue = 'Shed Land';
//     }
    
//     // Parse upin
//     let parsedUpin = [];
//     if (agreement.upin) {
//       if (Array.isArray(agreement.upin)) {
//         parsedUpin = agreement.upin.filter(u => u && u !== 'N/A' && u !== 'NULL');
//       } else if (typeof agreement.upin === 'string') {
//         if (agreement.upin !== 'N/A' && agreement.upin !== 'NULL') {
//           parsedUpin = [agreement.upin];
//         }
//       }
//     }
    
//     const editFormData = {
//       ...getInitialFormData(agreementTypeValue),
//       agreement_id: agreement.agreement_id || agreement.id,
//       tenant_id: agreement.tenant_id,
//       investor_name: agreement.investor_name,
//       park_id: agreement.park_id,
//       park_name: agreement.park_name,
//       upin: parsedUpin,
//       contract_issue: formatDateForInput(agreement.contract_issued_on),
//       contract_renewal: formatDateForInput(agreement.contract_renewal_date),
//       handover_date: formatDateForInput(agreement.handover_date),
//       mou_signed: formatDateForInput(agreement.moe_signed_on),
//       grace_period_ending_date: formatDateForInput(agreement.grace_period_ending_date),
//       production_commencement_date: formatDateForInput(agreement.production_commencement_date),
//       rehandover_date: formatDateForInput(agreement.rehandover_date),
//       description: agreement.description || "",
//       ownership_type: agreement.ownership_type,
//       investment_type: agreement.investment_type,
//       contract_period: agreement.contract_period_in_months || "",
//       production_capacity: agreement.production_capacity || "",
//       export_capacity: agreement.export_capacity || "",
//       employee_capacity: agreement.employee_capacity || "",
//       market_destination: agreement.market_destination || "",
//       intl_brands_link: agreement.intl_brands_link || "",
//       disposal_method: agreement.disposal_method || "",
//       monthly_rent: agreement.monthly_rent || 0,
//       annual_lease_rate: agreement.annual_lease_rate || 0,
//       area_as_per_contract_in_m2: agreement.area_as_per_contract_in_m2 || agreement.area_for_calculation || "",
//       security: agreement.security || 0,
//       advance_payment: agreement.advance_payment || 0,
//       annual_mngmnt_service_fee: agreement.annual_mngmnt_service_fee || 0,
//       payment_mode: agreement.payment_mode || "usd",
//       late_charge_fee: agreement.late_charge_fee || 5,
//       penality_rate: "%",
//       current_status: agreement.status || agreement.current_status || "ACTIVE",
//       room_details: agreement.room_details || [],
//       building_number: agreement.building_number || "",
//       building_name: agreement.building_name || "",
//       floor_number: agreement.floor_number || "",
//       advance_months: agreement.advance_months || 3,
//       shop_details: agreement.shop_details || [],
//       service_type: agreement.service_type || "",
//       total_area_sqm: agreement.total_area_sqm || "",
//       mou_attachment: agreement.mou_attachment || null,
//       mou_attachment_existing: agreement.mou_attachment || null,
//     };
    
//     setFormData(editFormData);
//     setIsEditMode(true);
//     setEditingAgreementId(agreement.id || agreement.agreement_id);
    
//     if (agreement.park_id) {
//       const park = parks.find(p => p.id === agreement.park_id);
//       setSelectedPark(park);
//       await fetchAvailableParcels(agreement.park_id);
//       if (agreementTypeValue === "Shed Land") {
//         await fetchShedInPark(agreement.park_id);
//       }
//     }
    
//     setSelectedUpins(parsedUpin);
    
//     setShedLandStep(0);
//     setResidentialStep(0);
//     setCommercialStep(0);
//     setMainTabValue(0);
    
//     showToast(`Editing agreement: ${agreement.agreement_id || agreement.id}`, "info");
//   };

//   // ---------- Cancel Edit ----------
//   const handleCancelEdit = () => {
//     resetForm();
//     setMainTabValue(1);
//     showToast("Edit cancelled", "info");
//   };

//   // ---------- View Details ----------
//   const handleViewDetails = (agreement) => {
//     setViewingAgreement(agreement);
//     setViewDialogOpen(true);
//   };

//   // ---------- Filter change handler ----------
//   const handleFilterTypeChange = (event) => {
//     setFilterType(event.target.value);
//     setPage(0);
//   };

//   // ---------- Save Agreement ----------
//   const handleSaveAgreement = async () => {
//     if (!formData.park_id) {
//       showToast("Please select a park", "error");
//       return;
//     }
//     if (!formData.tenant_id) {
//       showToast("Please select an investor", "error");
//       return;
//     }

//     if (formData.agreement_type === "Shed Land" || formData.agreement_type === "Leased Land") {
//       if (selectedUpins.length === 0) {
//         showToast("Please select a shed or parcel", "error");
//         return;
//       }
//       if (shedLandStep < 5) {
//         showToast("Please complete all steps before saving", "warning");
//         setShedLandStep(5);
//         return;
//       }
//     }

//     if (formData.agreement_type === "Residential") {
//       if (!formData.room_details || formData.room_details.length === 0) {
//         showToast("Please add at least one room", "error");
//         return;
//       }
//       if (residentialStep < 1) {
//         showToast("Please complete all steps before saving", "warning");
//         setResidentialStep(1);
//         return;
//       }
//     }

//     if (formData.agreement_type === "Commercial") {
//       if (!formData.service_type) {
//         showToast("Please select service type", "error");
//         return;
//       }
//       if (!formData.shop_details || formData.shop_details.length === 0) {
//         showToast("Please add at least one shop/room", "error");
//         return;
//       }
//       if (commercialStep < 1) {
//         showToast("Please complete all steps before saving", "warning");
//         setCommercialStep(1);
//         return;
//       }
//     }

//     setIsLoading(true);
//     try {
//       if (isEditMode && editingAgreementId) {
//         const formatDateForUpdate = (dateValue) => {
//           if (!dateValue || dateValue === "" || dateValue === "Not Set" || dateValue === "1900-01-01") {
//             return null;
//           }
//           return dateValue;
//         };
        
//         const safeParseFloat = (value) => {
//           if (value === "" || value === null || value === undefined) return 0;
//           return parseFloat(value) || 0;
//         };
        
//         const safeParseInt = (value) => {
//           if (value === "" || value === null || value === undefined) return 0;
//           return parseInt(value) || 0;
//         };
        
//         let upinString = selectedUpins.length > 0 ? selectedUpins.join(',') : 'N/A';
        
//         const marketDestinationArray = formData.market_destination 
//           ? (Array.isArray(formData.market_destination) 
//               ? formData.market_destination 
//               : [formData.market_destination])
//           : [];
        
//         const intlBrandsLinkArray = formData.intl_brands_link 
//           ? (Array.isArray(formData.intl_brands_link) 
//               ? formData.intl_brands_link 
//               : [formData.intl_brands_link])
//           : [];
        
//         const lateChargeJson = JSON.stringify({
//           fee: safeParseFloat(formData.late_charge_fee),
//           rate_type: formData.penality_rate || '%',
//           currency: formData.payment_mode || 'usd'
//         });
        
//         let mouAttachmentValue = null;
//         if (formData.mou_attachment) {
//           if (formData.mou_attachment instanceof File) {
//             mouAttachmentValue = formData.mou_attachment_existing || null;
//           } else if (typeof formData.mou_attachment === 'string') {
//             mouAttachmentValue = formData.mou_attachment;
//           }
//         }
        
//         const updatePayload = {
//           tenant_id: formData.tenant_id || "",
//           upin: upinString,
//           ownership_type: formData.ownership_type || "",
//           investment_type: formData.investment_type || "",
//           contract_issued_on: formatDateForUpdate(formData.contract_issue),
//           contract_renewal_date: formatDateForUpdate(formData.contract_renewal),
//           moe_signed_on: formatDateForUpdate(formData.mou_signed),
//           production_capacity: safeParseFloat(formData.production_capacity),
//           handover_date: formatDateForUpdate(formData.handover_date),
//           rehandover_date: formatDateForUpdate(formData.rehandover_date),
//           production_commencement_date: formatDateForUpdate(formData.production_commencement_date),
//           market_destination: marketDestinationArray,
//           intl_brands_link: intlBrandsLinkArray,
//           disposal_method: formData.disposal_method || null,
//           export_capacity: safeParseFloat(formData.export_capacity),
//           employee_capacity: safeParseInt(formData.employee_capacity),
//           monthly_rent: safeParseFloat(formData.monthly_rent || formData.annual_lease_rate),
//           grace_period_ending_date: formatDateForUpdate(formData.grace_period_ending_date),
//           security: safeParseFloat(formData.security),
//           advance_payment: safeParseFloat(formData.advance_payment),
//           annual_mngmnt_service_fee: safeParseFloat(formData.annual_mngmnt_service_fee),
//           payment_mode: (formData.payment_mode || "usd").toUpperCase(),
//           late_charge_fee: lateChargeJson,
//           contract_period_in_months: safeParseInt(formData.contract_period),
//           description: formData.description || "",
//           park_id: formData.park_id || null,
//           status: "Requested",
//           service_type: formData.service_type || null,
//           total_area_sqm: safeParseFloat(formData.total_area_sqm),
//           building_number: formData.building_number || null,
//           building_name: formData.building_name || null,
//           floor_number: formData.floor_number || null,
//           advance_months: safeParseInt(formData.advance_months),
//           room_details: formData.room_details || [],
//           shop_details: formData.shop_details || [],
//           area_for_calculation: safeParseFloat(formData.area_as_per_contract_in_m2 || formData.total_area_sqm),
//           mou_attachment: mouAttachmentValue,
//         };
        
//         console.log("Update payload:", updatePayload);
        
//         await UpdateAndGetResponse(`agreements/${editingAgreementId}`, updatePayload);
        
//         showToast("Agreement updated successfully", "success");
//         setIsEditMode(false);
//         setEditingAgreementId(null);
        
//         if (filterType === "expert_edit") {
//           fetchAgreementsForExpertEdit();
//         } else {
//           fetchAgreements();
//         }
        
//         fetchRejectedAgreements();
        
//       } else {
//         const payload = { 
//           ...formData, 
//           upin: selectedUpins,
//           recorded_by: userValuesArray[1],
//           current_status: "ACTIVE"
//         };
//         await ExecutePostWithParams("agreements", payload);
//         showToast("Agreement saved successfully", "success");
//         await fetchAgreements();
//       }
      
//       resetForm();
//       setMainTabValue(1);
      
//     } catch (error) {
//       console.error("Error saving agreement:", error);
//       const errorMessage = error.response?.data?.message || 
//                            error.response?.data?.error || 
//                            error.message || 
//                            "Database error occurred";
//       showToast(`Failed to ${isEditMode ? 'update' : 'save'} agreement: ${errorMessage}`, "error");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // ---------- Load initial data ----------
//   useEffect(() => {
//     fetchParks();
//     fetchInvestors();
//     fetchAgreementsForExpertEdit();
//     fetchRejectedAgreements();
//   }, []);

//   // ---------- Sync ownership_type when agreement_type changes ----------
//   useEffect(() => {
//     if (formData.agreement_type) {
//       let newOwnershipType = formData.ownership_type;
//       if (formData.agreement_type === "Shed Land") newOwnershipType = "Shed Rent";
//       else if (formData.agreement_type === "Leased Land") newOwnershipType = "Land Leased";
//       else if (formData.agreement_type === "Commercial") newOwnershipType = "Commercial";
//       else if (formData.agreement_type === "Residential") newOwnershipType = "Residential";
//       if (newOwnershipType !== formData.ownership_type) {
//         setFormData(prev => ({ ...prev, ownership_type: newOwnershipType }));
//       }
//     }
//   }, [formData.agreement_type]);

//   // ========== RENDER COMMON COMPONENTS ==========
  
//   const renderAgreementTypeSelector = () => (
//     <FormControl fullWidth sx={{ mb: 3 }}>
//       <InputLabel id="agreement-type-label">Agreement Type</InputLabel>
//       <Select
//         labelId="agreement-type-label"
//         name="agreement_type"
//         value={formData.agreement_type || "Shed Land"}
//         onChange={handleAgreementTypeChange}
//         label="Agreement Type"
//         disabled={isEditMode}
//       >
//         {agreementTypes.map(type => (
//           <MenuItem key={type.id} value={type.id}>
//             <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//               {type.icon} {type.label}
//             </Box>
//           </MenuItem>
//         ))}
//       </Select>
//     </FormControl>
//   );

//   const renderParkSelector = () => (
//     <FormControl fullWidth required>
//       <InputLabel id="park-select-label">Select Industrial Park</InputLabel>
//       <Select
//         labelId="park-select-label"
//         name="park_id"
//         value={formData.park_id || ""}
//         onChange={handleParkChange}
//         label="Select Industrial Park"
//         disabled={isEditMode}
//       >
//         <MenuItem value="">Select Park</MenuItem>
//         {parks.map((park) => (
//           <MenuItem key={park.id} value={park.id}>
//             {park.name}
//           </MenuItem>
//         ))}
//       </Select>
//     </FormControl>
//   );

//   const renderInvestorSelector = () => (
//     <Grid container spacing={2}>
//       <Grid item xs={9}>
//         <FormControl fullWidth required>
//           <InputLabel id="investor-select-label">Select Investor/Tenant</InputLabel>
//           <Select
//             labelId="investor-select-label"
//             name="tenant_id"
//             value={formData.tenant_id || ""}
//             onChange={handleInvestorChange}
//             label="Select Investor/Tenant"
//           >
//             <MenuItem value="">Select Investor</MenuItem>
//             {investors.map((investor) => (
//               <MenuItem key={investor.id} value={investor.id}>
//                 {investor.company_name || investor.name} - {investor.tin_no || ""}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       </Grid>
//       <Grid item xs={3} display="flex" alignItems="center">
//         <Button 
//           variant="outlined" 
//           component={Link} 
//           to="/registerInvestor" 
//           startIcon={<AddIcon />}
//           fullWidth
//         >
//           Register New
//         </Button>
//       </Grid>
//     </Grid>
//   );

//   // ========== SHED/LAND STEP 1 ==========
//   const renderShedLandStep1 = () => {
//     const isShedRent = formData.agreement_type === "Shed Land";
//     const isLeasedLand = formData.agreement_type === "Leased Land";
//     {console.log("LANDDDDDDDDDDD", parcelInPark)}
//     return (
//       <Grid container spacing={3}>
//         <Grid item xs={12}>
//           <Card variant="outlined">
//             <CardContent>
//               <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <BusinessIcon /> Step 1: Basic Information
//               </Typography>
              
//               <Grid container spacing={2}>
//                 <Grid item xs={12} md={6}>
//                   {renderParkSelector()}
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <TextField
//                     fullWidth
//                     label="Agreement ID"
//                     name="agreement_id"
//                     value={formData?.agreement_id || ""}
//                     onChange={handleChange}
//                     InputProps={{ readOnly: true }}
//                     helperText={selectedPark ? "Auto-generated" : "Select park first"}
//                   />
//                 </Grid>
//               </Grid>
//             </CardContent>
//           </Card>
//         </Grid>

//         <Grid item xs={12}>
//           <Card variant="outlined">
//             <CardContent>
//               <Typography variant="h6" gutterBottom sx={{ color: '#1976d2' }}>
//                 Investor Information
//               </Typography>
//               {renderInvestorSelector()}
//             </CardContent>
//           </Card>
//         </Grid>

//         <Grid item xs={12}>
//           <Card variant="outlined">
//             <CardContent>
//               <Typography variant="h6" gutterBottom sx={{ color: '#1976d2' }}>
//                 {isShedRent ? "Shed Selection" : "Parcel Selection"}
//               </Typography>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} md={6}>
//                   {isShedRent ? (
//                     // Shed Selection Dropdown for Shed Rent
//                     <FormControl fullWidth disabled={!selectedPark || isEditMode}>
//                       <InputLabel id="shed-select-label">Select Shed Number</InputLabel>
//                       <Select
//                         labelId="shed-select-label"
//                         value={localSelectedShedId}
//                         onChange={(e) => handleShedSelection(e.target.value)}
//                         label="Select Shed Number"
//                         disabled={!selectedPark || isEditMode}
//                       >
//                         {shedInPark && shedInPark.length > 0 ? (
//                           [
//                             <MenuItem key="default" value="">-- Select Shed --</MenuItem>,
//                             ...shedInPark.map((shed) => (
//                               <MenuItem key={shed.shed_id} value={shed.shed_id}>
//                                 {shed.shed_number || shed.shed_id} - {shed.shed_size || 0} m²
//                               </MenuItem>
//                             ))
//                           ]
//                         ) : (
//                           <MenuItem disabled value="no-sheds">
//                             {selectedPark ? "No sheds available in this park" : "Select a park first"}
//                           </MenuItem>
//                         )}
//                       </Select>
//                     </FormControl>
//                   ) : (
//                     // Parcel Selection Dropdown for Leased Land
                    
                  

//                   <FormControl fullWidth disabled={!selectedPark || isEditMode}>
//                     <InputLabel id="upin-select-label">Select Parcel (UPIN)</InputLabel>
//                     <Select
//                       labelId="upin-select-label"
//                       value=""
//                       onChange={(e) => handleParcelSelection(e.target.value)}
//                       label="Select Parcel (UPIN)"
//                       disabled={!selectedPark || isEditMode}
//                     >
//                       {parcelInPark.length > 0 ? (
//                         [
//                           <MenuItem key="default" value="">-- Select Parcel --</MenuItem>,
//                           ...parcelInPark
//                             // FILTER OUT parcels that are in the shed list
//                             .filter(parcel => {
//                               // Check if this parcel's upin exists in shedInPark
//                               const isInShedList = shedInPark?.some(shed => shed.upin === parcel.upin);
//                               return !isInShedList; // Only keep parcels NOT in shed list
//                             })
//                             .map((parcel) => (
//                               <MenuItem key={parcel?.upin} value={parcel?.upin}>
//                                 {parcel?.upin}
//                               </MenuItem>
//                             ))
//                         ]
//                       ) : (
//                         <MenuItem disabled value="no-parcels">
//                           {selectedPark ? "No land parcels available in this park" : "Select a park first"}
//                         </MenuItem>
//                       )}
//                     </Select>
//                   </FormControl>
//                   )}
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
//                     {selectedUpins?.length > 0 ? (
//                       selectedUpins.map(upin => (
//                         <Chip
//                           key={upin}
//                           label={`${isShedRent ? 'UPIN: ' : ''}${upin}`}
//                           onDelete={!isEditMode ? () => handleRemoveUpin(upin) : undefined}
//                           color="primary"
//                           variant="outlined"
//                           deleteIcon={!isEditMode ? <DeleteIcon /> : undefined}
//                         />
//                       ))
//                     ) : (
//                       <Typography variant="body2" color="text.secondary">
//                         {isShedRent ? "No shed selected" : "No parcels selected"}
//                       </Typography>
//                     )}
//                   </Box>
//                 </Grid>
//               </Grid>
              
//               <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 2 }}>
//                 {isShedRent 
//                   ? "* Select a shed to automatically assign its UPIN. Tenure Type will be set to 'Shed Rent'."
//                   : "* Select land parcels to assign their UPINs. Tenure Type will be set to 'Land Leased'."}
//               </Typography>
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>
//     );
//   };

//   // ========== SHED/LAND STEP 2 ==========
//   const renderShedLandStep2 = () => (
//     <Grid container spacing={3}>
//       <Grid item xs={12}>
//         <Card variant="outlined">
//           <CardContent>
//             <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
//               <DescriptionIcon /> Step 2: Investment & Contract Details
//             </Typography>
            
//             <Grid container spacing={2}>
//               <Grid item xs={12}>
//                 <FormControl fullWidth>
//                   <InputLabel id="investment-type-label">Investment Type</InputLabel>
//                   <Select
//                     labelId="investment-type-label"
//                     name="investment_type"
//                     value={formData.investment_type || ""}
//                     onChange={handleChange}
//                     label="Investment Type"
//                   >
//                     <MenuItem value="">Select Investment Type</MenuItem>
//                     {investmentOptions.map(option => (
//                       <MenuItem key={option} value={option}>{option}</MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>
              
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   type="date"
//                   label="Contract Issue Date"
//                   name="contract_issue"
//                   value={formatDateForInput(formData.contract_issue)}
//                   onChange={(e) => handleIssueDateChange(e.target.value)}
//                   InputLabelProps={{ shrink: true }}
//                   required
//                 />
//               </Grid>
              
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   type="date"
//                   label="Contract Renewal Date"
//                   name="contract_renewal"
//                   value={formatDateForInput(formData.contract_renewal)}
//                   onChange={(e) => handleRenewalDateChange(e.target.value)}
//                   InputLabelProps={{ shrink: true }}
//                   required
//                 />
//               </Grid>
              
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   type="number"
//                   label="Contract Period (Months)"
//                   name="contract_period"
//                   value={formData.contract_period}
//                   onChange={handleChange}
//                   InputProps={{ readOnly: true }}
//                 />
//               </Grid>
              
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   type="date"
//                   label="Expected Handover Date"
//                   name="handover_date"
//                   value={formatDateForInput(formData.handover_date)}
//                   onChange={handleChange}
//                   InputLabelProps={{ shrink: true }}
//                 />
//               </Grid>
              
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   type="date"
//                   label="Expected Production Commencement Date"
//                   name="production_commencement_date"
//                   value={formatDateForInput(formData.production_commencement_date)}
//                   onChange={handleChange}
//                   InputLabelProps={{ shrink: true }}
//                 />
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>
//       </Grid>
//     </Grid>
//   );

//   // ========== SHED/LAND STEP 3 ==========
//   const renderShedLandStep3 = () => (
//     <Grid container spacing={3}>
//       <Grid item xs={12}>
//         <Card variant="outlined">
//           <CardContent>
//             <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
//               <FactoryIcon /> Step 3: Production, Conditions and Capacity
//             </Typography>
            
//             <Grid container spacing={2}>
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   type="number"
//                   label="Production Capacity (units/year)"
//                   name="production_capacity"
//                   value={formData.production_capacity}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
              
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   type="number"
//                   label="Export Capacity (%)"
//                   name="export_capacity"
//                   value={formData.export_capacity}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
              
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   type="number"
//                   label="Employment Capacity"
//                   name="employee_capacity"
//                   value={formData.employee_capacity}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>
//       </Grid>
//     </Grid>
//   );

//   // ========== SHED/LAND STEP 4 ==========
//   const renderShedLandStep4 = () => (
//     <Grid container spacing={3}>
//       <Grid item xs={12}>
//         <Card variant="outlined">
//           <CardContent>
//             <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
//               <StoreIcon /> Step 4: Market & Disposal
//             </Typography>
            
//             <Grid container spacing={2}>
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   label="Market Destination"
//                   name="market_destination"
//                   value={formData.market_destination}
//                   onChange={handleChange}
//                   placeholder="e.g., Domestic, Export, Europe, USA, etc."
//                   required
//                 />
//               </Grid>
              
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   label="Link to International Brands"
//                   name="intl_brands_link"
//                   value={formData.intl_brands_link}
//                   onChange={handleChange}
//                   placeholder="e.g., Nike, Adidas, H&M, etc."
//                 />
//               </Grid>
              
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   label="Waste Disposal Method"
//                   name="disposal_method"
//                   value={formData.disposal_method}
//                   onChange={handleChange}
//                   placeholder="e.g., Treatment plant, Recycling, External contractor, etc."
//                   required
//                 />
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>
//       </Grid>
//     </Grid>
//   );

//   // ========== SHED/LAND STEP 5 ==========
//   const renderShedLandStep5 = () => (
//     <Grid container spacing={3}>
//       <Grid item xs={12}>
//         <Card variant="outlined">
//           <CardContent>
//             <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
//               <MoneyIcon /> Step 5: Financial & Contractual Details
//             </Typography>
            
//             <Grid container spacing={2}>
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   type="date"
//                   label="Grace Period Ending Date (Rent/Lease start date)"
//                   name="grace_period_ending_date"
//                   value={formatDateForInput(formData.grace_period_ending_date)}
//                   onChange={handleChange}
//                   InputLabelProps={{ shrink: true }}
//                   required
//                 />
//               </Grid>
              
//               <Grid item xs={12} md={6}>
//                 <FormControl fullWidth>
//                   <InputLabel id="payment-mode-label">Payment Method</InputLabel>
//                   <Select
//                     labelId="payment-mode-label"
//                     name="payment_mode"
//                     value={formData.payment_mode || "usd"}
//                     onChange={handleChange}
//                     label="Payment Method"
//                   >
//                     {paymentModes.map(mode => (
//                       <MenuItem key={mode.id} value={mode.id}>{mode.label}</MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>
              
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   type="number"
//                   label={formData.agreement_type === "Shed Land" ? "Monthly Rent " : "Annual Lease Rate (USD)"}
//                   name={formData.agreement_type === "Shed Land" ? "monthly_rent" : "annual_lease_rate"}
//                   value={formData[formData.agreement_type === "Shed Land" ? "monthly_rent" : "annual_lease_rate"]}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
              
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   type="number"
//                   label="Area as per Contract (m²)"
//                   name="area_as_per_contract_in_m2"
//                   value={formData.area_as_per_contract_in_m2}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
              
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   type="number"
//                   label="Security Deposit"
//                   name="security"
//                   value={formData.security}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
              
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   type="number"
//                   label={formData.agreement_type === "Leased Land" ? "Advance Payment" : "Down Payment"}
//                   name="advance_payment"
//                   value={formData.advance_payment}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
              
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   type="number"
//                   label="Annual Management Service Fee / m²"
//                   name="annual_mngmnt_service_fee"
//                   value={formData.annual_mngmnt_service_fee}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
              
//               <Grid item xs={9}>
//                 <TextField
//                   fullWidth
//                   type="number"
//                   label="Late Charge Fee"
//                   name="late_charge_fee"
//                   value={formData.late_charge_fee}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
              
//               <Grid item xs={3}>
//                 <FormControl fullWidth>
//                   <InputLabel id="penality-rate-label">Rate</InputLabel>
//                   <Select
//                     labelId="penality-rate-label"
//                     name="penality_rate"
//                     value={formData.penality_rate || "%"}
//                     onChange={handleChange}
//                     label="Rate"
//                   >
//                     <MenuItem value="%">%</MenuItem>
//                     <MenuItem value="value">Fixed</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>
//       </Grid>
//     </Grid>
//   );

//   // ========== SHED/LAND STEP 6 ==========
//   const renderShedLandStep6 = () => {
//     const monthlyRent = parseFloat(formData.monthly_rent || formData.annual_lease_rate || 0);
//     const area = parseFloat(formData.area_as_per_contract_in_m2 || 0);
//     const managementFee = parseFloat(formData.annual_mngmnt_service_fee || 0);
//     const annualManagementTotal = area * managementFee;
//     const securityDeposit = parseFloat(formData.security || 0);
//     const advancePayment = parseFloat(formData.advance_payment || 0);
    
//     const getUpinDisplay = () => {
//       if (Array.isArray(selectedUpins)) {
//         return selectedUpins.join(', ');
//       }
//       return 'N/A';
//     };
    
//     return (
//       <Grid container spacing={3}>
//         <Grid item xs={12}>
//           <Card variant="outlined">
//             <CardContent>
//               <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <DescriptionIcon /> Step 6: Summary & Description
//               </Typography>
              
//               <Grid container spacing={3}>
//                 <Grid item xs={12} md={6}>
//                   <Card variant="outlined" sx={{ backgroundColor: '#f8f9fa' }}>
//                     <CardContent>
//                       <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1976d2', mb: 2 }}>
//                         Agreement Summary
//                       </Typography>
//                       <Table size="small">
//                         <TableBody>
//                           <TableRow>
//                             <TableCell sx={{ border: 'none', fontWeight: 'bold' }}>Agreement ID:</TableCell>
//                             <TableCell sx={{ border: 'none' }}>{formData.agreement_id || 'N/A'}</TableCell>
//                           </TableRow>
//                           <TableRow>
//                             <TableCell sx={{ border: 'none', fontWeight: 'bold' }}>Park:</TableCell>
//                             <TableCell sx={{ border: 'none' }}>{formData.park_name || formData.park_id}</TableCell>
//                           </TableRow>
//                           <TableRow>
//                             <TableCell sx={{ border: 'none', fontWeight: 'bold' }}>Investor:</TableCell>
//                             <TableCell sx={{ border: 'none' }}>{formData.investor_name || formData.tenant_id}</TableCell>
//                           </TableRow>
//                           <TableRow>
//                             <TableCell sx={{ border: 'none', fontWeight: 'bold' }}>Parcel(s):</TableCell>
//                             <TableCell sx={{ border: 'none' }}>{getUpinDisplay()}</TableCell>
//                           </TableRow>
//                           <TableRow>
//                             <TableCell sx={{ border: 'none', fontWeight: 'bold' }}>Tenure Type:</TableCell>
//                             <TableCell sx={{ border: 'none' }}>{formData.ownership_type === 'Shed Rent' ? 'Shed Rent' : 'Land Lease'}</TableCell>
//                           </TableRow>
//                         </TableBody>
//                       </Table>
//                     </CardContent>
//                   </Card>
//                 </Grid>
                
//                 <Grid item xs={12} md={6}>
//                   <Card variant="outlined" sx={{ backgroundColor: '#f8f9fa' }}>
//                     <CardContent>
//                       <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1976d2', mb: 2 }}>
//                         Financial Summary
//                       </Typography>
//                       <Table size="small">
//                         <TableBody>
//                           <TableRow>
//                             <TableCell sx={{ border: 'none', fontWeight: 'bold' }}>
//                               {formData.agreement_type === 'Shed Land' ? 'Monthly Rent:' : 'Annual Lease:'}
//                             </TableCell>
//                             <TableCell sx={{ border: 'none' }}>${safeToFixed(monthlyRent, 2)}</TableCell>
//                           </TableRow>
//                           <TableRow>
//                             <TableCell sx={{ border: 'none', fontWeight: 'bold' }}>Area (m²):</TableCell>
//                             <TableCell sx={{ border: 'none' }}>{safeToFixed(area, 2)}</TableCell>
//                           </TableRow>
//                           <TableRow>
//                             <TableCell sx={{ border: 'none', fontWeight: 'bold' }}>Annual Management Fee:</TableCell>
//                             <TableCell sx={{ border: 'none' }}>${safeToFixed(annualManagementTotal, 2)}</TableCell>
//                           </TableRow>
//                           <TableRow>
//                             <TableCell sx={{ border: 'none', fontWeight: 'bold' }}>Security Deposit:</TableCell>
//                             <TableCell sx={{ border: 'none' }}>${safeToFixed(securityDeposit, 2)}</TableCell>
//                           </TableRow>
//                           <TableRow>
//                             <TableCell sx={{ border: 'none', fontWeight: 'bold' }}>Advance Payment:</TableCell>
//                             <TableCell sx={{ border: 'none' }}>${safeToFixed(advancePayment, 2)}</TableCell>
//                           </TableRow>
//                         </TableBody>
//                       </Table>
//                     </CardContent>
//                   </Card>
//                 </Grid>
                
//                 <Grid item xs={12}>
//                   <Card variant="outlined" sx={{ backgroundColor: '#f8f9fa' }}>
//                     <CardContent>
//                       <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1976d2', mb: 2 }}>
//                         Contract Dates
//                       </Typography>
//                       <Grid container spacing={2}>
//                         <Grid item xs={12} md={3}>
//                           <Typography variant="caption" color="textSecondary">Issue Date</Typography>
//                           <Typography variant="body2">{formData.contract_issue || 'N/A'}</Typography>
//                         </Grid>
//                         <Grid item xs={12} md={3}>
//                           <Typography variant="caption" color="textSecondary">Renewal Date</Typography>
//                           <Typography variant="body2">{formData.contract_renewal || 'N/A'}</Typography>
//                         </Grid>
//                         <Grid item xs={12} md={3}>
//                           <Typography variant="caption" color="textSecondary">Handover Date</Typography>
//                           <Typography variant="body2">{formData.handover_date || 'N/A'}</Typography>
//                         </Grid>
//                         <Grid item xs={12} md={3}>
//                           <Typography variant="caption" color="textSecondary">Production Start</Typography>
//                           <Typography variant="body2">{formData.production_commencement_date || 'N/A'}</Typography>
//                         </Grid>
//                       </Grid>
//                     </CardContent>
//                   </Card>
//                 </Grid>
                
//                 <Grid item xs={12}>
//                   <TextField
//                     fullWidth
//                     label="Description / Notes"
//                     name="description"
//                     value={formData.description}
//                     onChange={handleChange}
//                     multiline
//                     rows={3}
//                     placeholder="Enter any additional notes or description for this agreement..."
//                   />
//                 </Grid>
                
//                 <Grid item xs={12} md={4}>
//                   <TextField
//                     fullWidth
//                     type="date"
//                     label="MOU Signed On"
//                     name="mou_signed"
//                     value={formatDateForInput(formData.mou_signed)}
//                     onChange={handleChange}
//                     InputLabelProps={{ shrink: true }}
//                   />
//                 </Grid>
                
//                 <Grid item xs={12} md={8}>
//                   <Box>
//                     <Button variant="outlined" component="label" startIcon={<UploadIcon />}>
//                       {formData.mou_attachment ? "Change File" : "Upload MOU Attachment"}
//                       <input type="file" hidden onChange={handleFileChange} />
//                     </Button>
//                     {formData.mou_attachment && (
//                       <Chip 
//                         label={typeof formData.mou_attachment === 'string' ? formData.mou_attachment.split('/').pop() : formData.mou_attachment.name || "Attachment"}
//                         sx={{ ml: 2 }} 
//                         onDelete={handleRemoveFile}
//                         deleteIcon={<CloseIcon />}
//                       />
//                     )}
//                   </Box>
//                   {formData.mou_attachment && typeof formData.mou_attachment === 'string' && (
//                     <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 1 }}>
//                       Current file: {formData.mou_attachment.split('/').pop()}
//                     </Typography>
//                   )}
//                 </Grid>
//               </Grid>
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>
//     );
//   };

//   // ========== RENDER SHED/LAND WIZARD ==========
//   const renderShedLandWizard = () => {
//     const steps = shedLandSteps;
    
//     return (
//       <Box sx={{ width: '100%' }}>
//         <Stepper activeStep={shedLandStep} alternativeLabel sx={{ mb: 4 }}>
//           {steps.map((label, index) => (
//             <Step key={index}>
//               <StepLabel>{label}</StepLabel>
//             </Step>
//           ))}
//         </Stepper>
        
//         <Card variant="outlined" sx={{ p: 3, mb: 3 }}>
//           {shedLandStep === 0 && renderShedLandStep1()}
//           {shedLandStep === 1 && renderShedLandStep2()}
//           {shedLandStep === 2 && renderShedLandStep3()}
//           {shedLandStep === 3 && renderShedLandStep4()}
//           {shedLandStep === 4 && renderShedLandStep5()}
//           {shedLandStep === 5 && renderShedLandStep6()}
          
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
//             <Button
//               variant="contained"
//               onClick={handleShedLandPrevStep}
//               disabled={shedLandStep === 0}
//             >
//               Previous
//             </Button>
            
//             {shedLandStep === steps.length - 1 ? (
//               <Button
//                 variant="contained"
//                 color="primary"
//                 onClick={handleSaveAgreement}
//                 disabled={isLoading}
//                 startIcon={<SaveIcon />}
//               >
//                 {isLoading ? <CircularProgress size={24} /> : (isEditMode ? 'Update Agreement' : 'Save Agreement')}
//               </Button>
//             ) : (
//               <Button
//                 variant="contained"
//                 onClick={handleShedLandNextStep}
//               >
//                 Next
//               </Button>
//             )}
//           </Box>
//         </Card>
//       </Box>
//     );
//   };

//   // ========== RESIDENTIAL STEP 1 ==========
//   const renderResidentialStep1 = () => (
//     <Grid container spacing={3}>
//       <Grid item xs={12}>
//         <Card variant="outlined">
//           <CardContent>
//             <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
//               <ApartmentIcon /> Step 1: Location & Room Information
//             </Typography>
            
//             <Grid container spacing={2}>
//               <Grid item xs={12} md={6}>
//                 {renderParkSelector()}
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   label="Agreement ID"
//                   name="agreement_id"
//                   value={formData.agreement_id}
//                   onChange={handleChange}
//                   InputProps={{ readOnly: true }}
//                   helperText={selectedPark ? "Auto-generated" : "Select park first"}
//                 />
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>
//       </Grid>

//       <Grid item xs={12}>
//         <Card variant="outlined">
//           <CardContent>
//             <Typography variant="h6" gutterBottom sx={{ color: '#1976d2' }}>
//               Investor / Tenant Information
//             </Typography>
//             {renderInvestorSelector()}
//           </CardContent>
//         </Card>
//       </Grid>

//       <Grid item xs={12}>
//         <Card variant="outlined">
//           <CardContent>
//             <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
//               <MeetingRoomIcon /> Room Configuration
//             </Typography>
            
//             <TableContainer component={Paper} sx={{ mb: 2 }}>
//               <Table size="small">
//                 <TableHead>
//                   <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
//                     <TableCell>Room Type</TableCell>
//                     <TableCell align="center">Room Number</TableCell>
//                     <TableCell align="center">No. of Rooms</TableCell>
//                     <TableCell align="center">Area (m²)</TableCell>
//                     <TableCell align="center">Total m²</TableCell>
//                     <TableCell align="center">Price/m²</TableCell>
//                     <TableCell align="center">Monthly Rent</TableCell>
//                     <TableCell align="center">Actions</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {formData.room_details?.length > 0 ? (
//                     formData.room_details.map((room, idx) => (
//                       <TableRow key={idx}>
//                         <TableCell>{room.type}</TableCell>
//                         <TableCell align="center">{room.room_number || '-'}</TableCell>
//                         <TableCell align="center">{room.count}</TableCell>
//                         <TableCell align="center">{safeToFixed(room.area, 2)}</TableCell>
//                         <TableCell align="center">{safeToFixed(room.totalArea, 2)}</TableCell>
//                         <TableCell align="center">${safeToFixed(room.pricePerSqm, 2)}</TableCell>
//                         <TableCell align="center">${safeToFixed(room.monthlyRent, 2)}</TableCell>
//                         <TableCell align="center">
//                           <IconButton size="small" onClick={() => handleEditRoom(idx)} color="primary">
//                             <EditIcon />
//                           </IconButton>
//                           <IconButton size="small" onClick={() => handleRemoveRoom(idx)} color="error">
//                             <DeleteIcon />
//                           </IconButton>
//                         </TableCell>
//                       </TableRow>
//                     ))
//                   ) : (
//                     <TableRow>
//                       <TableCell colSpan={8} align="center" sx={{ py: 3 }}>
//                         <Typography color="textSecondary">No rooms added. Click "Add Room" to configure.</Typography>
//                       </TableCell>
//                     </TableRow>
//                   )}
//                 </TableBody>
//               </Table>
//             </TableContainer>

//             <Button
//               variant="outlined"
//               startIcon={<AddIcon />}
//               onClick={() => {
//                 setEditingRoomIndex(null);
//                 setNewRoom({
//                   type: "family",
//                   count: 1,
//                   area: 73.44,
//                   pricePerSqm: 14.24,
//                   room_number: ""
//                 });
//                 setRoomDialogOpen(true);
//               }}
//               sx={{ mb: 2 }}
//             >
//               Add Room
//             </Button>
//           </CardContent>
//         </Card>
//       </Grid>
//     </Grid>
//   );

//   // ========== RESIDENTIAL STEP 2 ==========
//   const renderResidentialStep2 = () => (
//     <Grid container spacing={3}>
//       <Grid item xs={12}>
//         <Card variant="outlined">
//           <CardContent>
//             <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
//               <MoneyIcon /> Step 2: Financial Details
//             </Typography>
            
//             <Paper sx={{ p: 2, backgroundColor: '#e3f2fd', mb: 2 }}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} md={4}>
//                   <Typography variant="subtitle2" color="textSecondary">
//                     Total Monthly Rent
//                   </Typography>
//                   <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
//                     ${safeToFixed(formData.monthly_rent || 0, 2)}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} md={4}>
//                   <TextField
//                     type="number"
//                     label="Advance Months"
//                     name="advance_months"
//                     value={formData.advance_months || 3}
//                     onChange={handleAdvanceMonthsChange}
//                     size="small"
//                     InputProps={{ inputProps: { min: 1, max: 12 } }}
//                     sx={{ width: '100%' }}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={4}>
//                   <Typography variant="subtitle2" color="textSecondary">
//                     Advance Payment Total
//                   </Typography>
//                   <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
//                     ${safeToFixed(formData.advance_payment || 0, 2)}
//                   </Typography>
//                   <Typography variant="caption" color="textSecondary">
//                     {formData.advance_months || 3} months advance
//                   </Typography>
//                 </Grid>
//               </Grid>
//             </Paper>

//             <Grid container spacing={2}>
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   type="number"
//                   label="Security Deposit"
//                   name="security"
//                   value={formData.security || 0}
//                   onChange={handleChange}
//                 />
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>
//       </Grid>

//       <Grid item xs={12}>
//         <Card variant="outlined">
//           <CardContent>
//             <Typography variant="h6" gutterBottom sx={{ color: '#1976d2' }}>
//               Contract Dates
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   type="date"
//                   label="Contract Start Date"
//                   name="contract_issue"
//                   value={formatDateForInput(formData.contract_issue)}
//                   onChange={(e) => handleIssueDateChange(e.target.value)}
//                   InputLabelProps={{ shrink: true }}
//                 />
//               </Grid>
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   type="date"
//                   label="Contract End Date"
//                   name="contract_renewal"
//                   value={formatDateForInput(formData.contract_renewal)}
//                   onChange={(e) => handleRenewalDateChange(e.target.value)}
//                   InputLabelProps={{ shrink: true }}
//                 />
//               </Grid>
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   type="date"
//                   label="Handover Date"
//                   name="handover_date"
//                   value={formatDateForInput(formData.handover_date)}
//                   onChange={handleChange}
//                   InputLabelProps={{ shrink: true }}
//                 />
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>
//       </Grid>

//       <Grid item xs={12}>
//         <Card variant="outlined">
//           <CardContent>
//             <Typography variant="h6" gutterBottom sx={{ color: '#1976d2' }}>
//               Additional Information
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={12} md={6}>
//                 <Button variant="outlined" component="label" startIcon={<UploadIcon />}>
//                   {formData.mou_attachment ? "Change File" : "Upload Attachment"}
//                   <input type="file" hidden onChange={handleFileChange} />
//                 </Button>
//                 {formData.mou_attachment && (
//                   <Chip 
//                     label={typeof formData.mou_attachment === 'string' ? formData.mou_attachment.split('/').pop() : formData.mou_attachment.name || "Attachment"}
//                     sx={{ ml: 2 }} 
//                     onDelete={handleRemoveFile}
//                     deleteIcon={<CloseIcon />}
//                   />
//                 )}
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   label="Description / Notes"
//                   name="description"
//                   value={formData.description}
//                   onChange={handleChange}
//                   multiline
//                   rows={2}
//                 />
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>
//       </Grid>
//     </Grid>
//   );

//   // ========== RENDER RESIDENTIAL WIZARD ==========
//   const renderResidentialWizard = () => {
//     const steps = residentialSteps;
    
//     return (
//       <Box sx={{ width: '100%' }}>
//         <Stepper activeStep={residentialStep} alternativeLabel sx={{ mb: 4 }}>
//           {steps.map((label, index) => (
//             <Step key={index}>
//               <StepLabel>{label}</StepLabel>
//             </Step>
//           ))}
//         </Stepper>
        
//         <Card variant="outlined" sx={{ p: 3, mb: 3 }}>
//           {residentialStep === 0 && renderResidentialStep1()}
//           {residentialStep === 1 && renderResidentialStep2()}
          
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
//             <Button
//               variant="contained"
//               onClick={handleResidentialPrevStep}
//               disabled={residentialStep === 0}
//             >
//               Previous
//             </Button>
            
//             {residentialStep === steps.length - 1 ? (
//               <Button
//                 variant="contained"
//                 color="primary"
//                 onClick={handleSaveAgreement}
//                 disabled={isLoading}
//                 startIcon={<SaveIcon />}
//               >
//                 {isLoading ? <CircularProgress size={24} /> : (isEditMode ? 'Update Agreement' : 'Save Agreement')}
//               </Button>
//             ) : (
//               <Button
//                 variant="contained"
//                 onClick={handleResidentialNextStep}
//               >
//                 Next
//               </Button>
//             )}
//           </Box>
//         </Card>
//       </Box>
//     );
//   };

//   // ========== COMMERCIAL STEP 1 ==========
//   const renderCommercialStep1 = () => (
//     <Grid container spacing={3}>
//       <Grid item xs={12}>
//         <Card variant="outlined">
//           <CardContent>
//             <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
//               <StoreIcon /> Step 1: Service & Location Information
//             </Typography>
            
//             <Grid container spacing={2}>
//               <Grid item xs={12} md={6}>
//                 {renderParkSelector()}
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   label="Agreement ID"
//                   name="agreement_id"
//                   value={formData.agreement_id}
//                   onChange={handleChange}
//                   InputProps={{ readOnly: true }}
//                   helperText={selectedPark ? "Auto-generated" : "Select park first"}
//                 />
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>
//       </Grid>

//       <Grid item xs={12}>
//         <Card variant="outlined">
//           <CardContent>
//             <Typography variant="h6" gutterBottom sx={{ color: '#1976d2' }}>
//               Investor / Tenant Information
//             </Typography>
//             {renderInvestorSelector()}
//           </CardContent>
//         </Card>
//       </Grid>

//       <Grid item xs={12}>
//         <Card variant="outlined">
//           <CardContent>
//             <Typography variant="h6" gutterBottom sx={{ color: '#1976d2' }}>
//               Service Details
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={12}>
//                 <FormControl fullWidth required>
//                   <InputLabel id="service-type-label">Service Type</InputLabel>
//                   <Select
//                     labelId="service-type-label"
//                     name="service_type"
//                     value={formData.service_type || ""}
//                     onChange={handleChange}
//                     label="Service Type"
//                   >
//                     <MenuItem value="">Select Service Type</MenuItem>
//                     {serviceTypes.map(type => (
//                       <MenuItem key={type} value={type}>{type}</MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>
//       </Grid>

//       <Grid item xs={12}>
//         <Card variant="outlined">
//           <CardContent>
//             <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
//               <ShopIcon /> Shop/Room Configuration
//             </Typography>
            
//             <TableContainer component={Paper} sx={{ mb: 2 }}>
//               <Table size="small">
//                 <TableHead>
//                   <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
//                     <TableCell>Building No.</TableCell>
//                     <TableCell>Shop/Room No.</TableCell>
//                     <TableCell align="center">Area (m²)</TableCell>
//                     <TableCell align="center">Monthly Rent ($)</TableCell>
//                     <TableCell>Description</TableCell>
//                     <TableCell align="center">Actions</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {formData.shop_details && formData.shop_details.length > 0 ? (
//                     formData.shop_details.map((shop, idx) => {
//                       const areaSqm = typeof shop.area_sqm === 'number' ? shop.area_sqm : parseFloat(shop.area_sqm) || 0;
//                       const monthlyRent = typeof shop.monthly_rent === 'number' ? shop.monthly_rent : parseFloat(shop.monthly_rent) || 0;
//                       const buildingNumber = shop.building_number || '';
//                       const shopNumber = shop.shop_number || '';
//                       const description = shop.description || '';
                      
//                       return (
//                         <TableRow key={idx}>
//                           <TableCell>{buildingNumber || '-'}</TableCell>
//                           <TableCell>{shopNumber || '-'}</TableCell>
//                           <TableCell align="center">{safeToFixed(areaSqm, 2)}</TableCell>
//                           <TableCell align="center">${safeToFixed(monthlyRent, 2)}</TableCell>
//                           <TableCell>{description || '-'}</TableCell>
//                           <TableCell align="center">
//                             <IconButton size="small" onClick={() => handleEditShop(idx)} color="primary">
//                               <EditIcon />
//                             </IconButton>
//                             <IconButton size="small" onClick={() => handleRemoveShop(idx)} color="error">
//                               <DeleteIcon />
//                             </IconButton>
//                           </TableCell>
//                         </TableRow>
//                       );
//                     })
//                   ) : (
//                     <TableRow>
//                       <TableCell colSpan={6} align="center" sx={{ py: 3 }}>
//                         <Typography color="textSecondary">No shops/rooms added. Click "Add Shop/Room" to configure.</Typography>
//                       </TableCell>
//                     </TableRow>
//                   )}
//                 </TableBody>
//               </Table>
//             </TableContainer>

//             <Button
//               variant="outlined"
//               startIcon={<AddIcon />}
//               onClick={() => {
//                 setEditingShopIndex(null);
//                 setNewShop({
//                   building_number: "",
//                   shop_number: "",
//                   area_sqm: 0,
//                   monthly_rent: 0,
//                   description: ""
//                 });
//                 setShopDialogOpen(true);
//               }}
//               sx={{ mb: 2 }}
//             >
//               Add Shop/Room
//             </Button>

//             {formData.shop_details && formData.shop_details.length > 0 && (
//               <Paper sx={{ p: 2, backgroundColor: '#e3f2fd', mt: 2 }}>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} md={6}>
//                     <Typography variant="subtitle2" color="textSecondary">
//                       Total Monthly Rent
//                     </Typography>
//                     <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
//                       ${safeToFixed(formData.monthly_rent || 0, 2)}
//                     </Typography>
//                   </Grid>
//                   <Grid item xs={12} md={6}>
//                     <Typography variant="subtitle2" color="textSecondary">
//                       Total Area
//                     </Typography>
//                     <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
//                       {safeToFixed(formData.total_area_sqm || 0, 2)} m²
//                     </Typography>
//                   </Grid>
//                 </Grid>
//               </Paper>
//             )}
//           </CardContent>
//         </Card>
//       </Grid>
//     </Grid>
//   );

//   // ========== COMMERCIAL STEP 2 ==========
//   const renderCommercialStep2 = () => (
//     <Grid container spacing={3}>
//       <Grid item xs={12}>
//         <Card variant="outlined">
//           <CardContent>
//             <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
//               <MoneyIcon /> Step 2: Financial Details
//             </Typography>
            
//             <Grid container spacing={2}>
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   type="number"
//                   label="Monthly Rent "
//                   name="monthly_rent"
//                   value={formData.monthly_rent || 0}
//                   InputProps={{ readOnly: true }}
//                   helperText="Auto-calculated from shop/room totals"
//                 />
//               </Grid>
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   type="number"
//                   label="Security Deposit"
//                   name="security"
//                   value={formData.security || 0}
//                   onChange={handleChange}
//                 />
//               </Grid>
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   type="number"
//                   label="Advance Payment"
//                   name="advance_payment"
//                   value={formData.advance_payment || 0}
//                   onChange={handleChange}
//                 />
//               </Grid>
//             </Grid>

//             <Paper sx={{ p: 2, backgroundColor: '#e3f2fd', mt: 2 }}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} md={4}>
//                   <Typography variant="subtitle2" color="textSecondary">
//                     Total Monthly Rent
//                   </Typography>
//                   <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
//                     ${safeToFixed(formData.monthly_rent || 0, 2)}
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} md={4}>
//                   <Typography variant="subtitle2" color="textSecondary">
//                     Total Area
//                   </Typography>
//                   <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
//                     {safeToFixed(formData.total_area_sqm || 0, 2)} m²
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} md={4}>
//                   <Typography variant="subtitle2" color="textSecondary">
//                     Average Rate per m²
//                   </Typography>
//                   <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
//                     ${formData.total_area_sqm ? safeToFixed((parseFloat(formData.monthly_rent) || 0) / (parseFloat(formData.total_area_sqm) || 1), 2) : '0.00'}
//                   </Typography>
//                 </Grid>
//               </Grid>
//             </Paper>
//           </CardContent>
//         </Card>
//       </Grid>

//       <Grid item xs={12}>
//         <Card variant="outlined">
//           <CardContent>
//             <Typography variant="h6" gutterBottom sx={{ color: '#1976d2' }}>
//               Contract Dates
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   type="date"
//                   label="Contract Start Date"
//                   name="contract_issue"
//                   value={formatDateForInput(formData.contract_issue)}
//                   onChange={(e) => handleIssueDateChange(e.target.value)}
//                   InputLabelProps={{ shrink: true }}
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   type="date"
//                   label="Contract End Date"
//                   name="contract_renewal"
//                   value={formatDateForInput(formData.contract_renewal)}
//                   onChange={(e) => handleRenewalDateChange(e.target.value)}
//                   InputLabelProps={{ shrink: true }}
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12} md={4}>
//                 <TextField
//                   fullWidth
//                   type="date"
//                   label="Handover Date"
//                   name="handover_date"
//                   value={formatDateForInput(formData.handover_date)}
//                   onChange={handleChange}
//                   InputLabelProps={{ shrink: true }}
//                 />
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>
//       </Grid>

//       <Grid item xs={12}>
//         <Card variant="outlined">
//           <CardContent>
//             <Typography variant="h6" gutterBottom sx={{ color: '#1976d2' }}>
//               Additional Information
//             </Typography>
//             <Grid container spacing={2}>
//               <Grid item xs={12} md={6}>
//                 <Button variant="outlined" component="label" startIcon={<UploadIcon />}>
//                   {formData.mou_attachment ? "Change File" : "Upload Attachment"}
//                   <input type="file" hidden onChange={handleFileChange} />
//                 </Button>
//                 {formData.mou_attachment && (
//                   <Chip 
//                     label={typeof formData.mou_attachment === 'string' ? formData.mou_attachment.split('/').pop() : formData.mou_attachment.name || "Attachment"}
//                     sx={{ ml: 2 }} 
//                     onDelete={handleRemoveFile}
//                     deleteIcon={<CloseIcon />}
//                   />
//                 )}
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   label="Description / Notes"
//                   name="description"
//                   value={formData.description}
//                   onChange={handleChange}
//                   multiline
//                   rows={2}
//                 />
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>
//       </Grid>
//     </Grid>
//   );

//   // ========== RENDER COMMERCIAL WIZARD ==========
//   const renderCommercialWizard = () => {
//     const steps = commercialSteps;
    
//     return (
//       <Box sx={{ width: '100%' }}>
//         <Stepper activeStep={commercialStep} alternativeLabel sx={{ mb: 4 }}>
//           {steps.map((label, index) => (
//             <Step key={index}>
//               <StepLabel>{label}</StepLabel>
//             </Step>
//           ))}
//         </Stepper>
        
//         <Card variant="outlined" sx={{ p: 3, mb: 3 }}>
//           {commercialStep === 0 && renderCommercialStep1()}
//           {commercialStep === 1 && renderCommercialStep2()}
          
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
//             <Button
//               variant="contained"
//               onClick={handleCommercialPrevStep}
//               disabled={commercialStep === 0}
//             >
//               Previous
//             </Button>
            
//             {commercialStep === steps.length - 1 ? (
//               <Button
//                 variant="contained"
//                 color="primary"
//                 onClick={handleSaveAgreement}
//                 disabled={isLoading}
//                 startIcon={<SaveIcon />}
//               >
//                 {isLoading ? <CircularProgress size={24} /> : (isEditMode ? 'Update Agreement' : 'Save Agreement')}
//               </Button>
//             ) : (
//               <Button
//                 variant="contained"
//                 onClick={handleCommercialNextStep}
//               >
//                 Next
//               </Button>
//             )}
//           </Box>
//         </Card>
//       </Box>
//     );
//   };

//   // ========== ROOM DIALOG ==========
//   const renderRoomDialog = () => {
//     const validateAndAddRoom = () => {
//       if (!newRoom.room_number || newRoom.room_number.trim() === "") {
//         setRoomNumberError(true);
//         showToast("Please enter room number", "warning");
//         return;
//       }
//       handleAddRoom();
//       setRoomNumberError(false);
//     };
    
//     return (
//       <Dialog open={roomDialogOpen} onClose={() => {
//         setRoomDialogOpen(false);
//         setRoomNumberError(false);
//         setEditingRoomIndex(null);
//       }} maxWidth="sm" fullWidth>
//         <DialogTitle>{editingRoomIndex !== null ? "Edit Room Configuration" : "Add Room Configuration"}</DialogTitle>
//         <DialogContent>
//           <Grid container spacing={2} sx={{ mt: 1 }}>
//             <Grid item xs={12}>
//               <FormControl fullWidth>
//                 <InputLabel>Room Type</InputLabel>
//                 <Select
//                   value={newRoom.type}
//                   onChange={(e) => {
//                     const type = e.target.value;
//                     const roomType = roomTypes.find(r => r.id === type);
//                     setNewRoom({
//                       ...newRoom,
//                       type: type,
//                       area: roomType?.defaultArea || 0,
//                       pricePerSqm: roomType?.defaultPrice || 14.24
//                     });
//                   }}
//                   label="Room Type"
//                 >
//                   {roomTypes.map(room => (
//                     <MenuItem key={room.id} value={room.id}>{room.name}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 required
//                 label="Room Number"
//                 value={newRoom.room_number}
//                 onChange={(e) => {
//                   setNewRoom({...newRoom, room_number: e.target.value});
//                   setRoomNumberError(false);
//                 }}
//                 error={roomNumberError}
//                 helperText={roomNumberError ? "Room number is required" : "Enter room number (e.g., 101, 102)"}
//                 placeholder="e.g. 101"
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 fullWidth
//                 type="number"
//                 label="Number of Rooms"
//                 value={newRoom.count}
//                 onChange={(e) => setNewRoom({...newRoom, count: parseInt(e.target.value) || 1})}
//                 inputProps={{ min: 1 }}
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 fullWidth
//                 type="number"
//                 label="Area per Room (m²)"
//                 value={newRoom.area}
//                 onChange={(e) => setNewRoom({...newRoom, area: parseFloat(e.target.value) || 0})}
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 fullWidth
//                 type="number"
//                 label="Price per m²"
//                 value={newRoom.pricePerSqm}
//                 onChange={(e) => setNewRoom({...newRoom, pricePerSqm: parseFloat(e.target.value) || 0})}
//                 InputProps={{ startAdornment: '$' }}
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <Paper sx={{ p: 2, backgroundColor: '#e3f2fd', height: '100%' }}>
//                 <Typography variant="subtitle2" color="textSecondary">
//                   Monthly Rent
//                 </Typography>
//                 <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
//                   ${safeToFixed(((newRoom.count || 0) * (newRoom.area || 0) * (newRoom.pricePerSqm || 0)), 2)}
//                 </Typography>
//               </Paper>
//             </Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => {
//             setRoomDialogOpen(false);
//             setRoomNumberError(false);
//             setEditingRoomIndex(null);
//           }}>Cancel</Button>
//           <Button onClick={validateAndAddRoom} variant="contained">
//             {editingRoomIndex !== null ? "Update Room" : "Add Room"}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     );
//   };

//   // ========== SHOP DIALOG ==========
//   const renderShopDialog = () => {
//     const validateAndAddShop = () => {
//       const errors = {
//         building_number: !newShop.building_number || newShop.building_number.trim() === "",
//         shop_number: !newShop.shop_number || newShop.shop_number.trim() === "",
//         area_sqm: !newShop.area_sqm || newShop.area_sqm <= 0,
//         monthly_rent: !newShop.monthly_rent || newShop.monthly_rent <= 0
//       };
      
//       setShopErrors(errors);
      
//       if (errors.building_number || errors.shop_number || errors.area_sqm || errors.monthly_rent) {
//         showToast("Please fill all required fields correctly", "warning");
//         return;
//       }
      
//       handleAddShop();
//     };
    
//     return (
//       <Dialog open={shopDialogOpen} onClose={() => {
//         setShopDialogOpen(false);
//         setShopErrors({
//           building_number: false,
//           shop_number: false,
//           area_sqm: false,
//           monthly_rent: false
//         });
//         setEditingShopIndex(null);
//       }} maxWidth="sm" fullWidth>
//         <DialogTitle>{editingShopIndex !== null ? "Edit Shop/Room" : "Add Shop/Room"}</DialogTitle>
//         <DialogContent>
//           <Grid container spacing={2} sx={{ mt: 1 }}>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 fullWidth
//                 required
//                 label="Building Number"
//                 value={newShop.building_number}
//                 onChange={(e) => {
//                   setNewShop({...newShop, building_number: e.target.value});
//                   setShopErrors({...shopErrors, building_number: false});
//                 }}
//                 error={shopErrors.building_number}
//                 helperText={shopErrors.building_number ? "Building number is required" : ""}
//                 placeholder="e.g., BLD-001"
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 fullWidth
//                 required
//                 label="Shop/Room Number"
//                 value={newShop.shop_number}
//                 onChange={(e) => {
//                   setNewShop({...newShop, shop_number: e.target.value});
//                   setShopErrors({...shopErrors, shop_number: false});
//                 }}
//                 error={shopErrors.shop_number}
//                 helperText={shopErrors.shop_number ? "Shop/Room number is required" : ""}
//                 placeholder="e.g., SHOP-101"
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 fullWidth
//                 required
//                 type="number"
//                 label="Area (m²)"
//                 value={newShop.area_sqm}
//                 onChange={(e) => {
//                   setNewShop({...newShop, area_sqm: parseFloat(e.target.value) || 0});
//                   setShopErrors({...shopErrors, area_sqm: false});
//                 }}
//                 error={shopErrors.area_sqm}
//                 helperText={shopErrors.area_sqm ? "Area is required and must be greater than 0" : ""}
//                 inputProps={{ min: 0.01, step: 0.01 }}
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 fullWidth
//                 required
//                 type="number"
//                 label="Monthly Rent "
//                 value={newShop.monthly_rent}
//                 onChange={(e) => {
//                   setNewShop({...newShop, monthly_rent: parseFloat(e.target.value) || 0});
//                   setShopErrors({...shopErrors, monthly_rent: false});
//                 }}
//                 error={shopErrors.monthly_rent}
//                 helperText={shopErrors.monthly_rent ? "Monthly rent is required and must be greater than 0" : ""}
//                 InputProps={{ startAdornment: '$' }}
//                 inputProps={{ min: 0.01, step: 0.01 }}
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 label="Description (Optional)"
//                 value={newShop.description}
//                 onChange={(e) => setNewShop({...newShop, description: e.target.value})}
//                 multiline
//                 rows={2}
//                 placeholder="Additional details about this shop/room"
//               />
//             </Grid>
//             {newShop.area_sqm > 0 && newShop.monthly_rent > 0 && (
//               <Grid item xs={12}>
//                 <Paper sx={{ p: 2, backgroundColor: '#e3f2fd' }}>
//                   <Typography variant="subtitle2" color="textSecondary">
//                     Rate per m²
//                   </Typography>
//                   <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
//                     ${safeToFixed((newShop.monthly_rent / newShop.area_sqm), 2)} / m²
//                   </Typography>
//                 </Paper>
//               </Grid>
//             )}
//           </Grid>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => {
//             setShopDialogOpen(false);
//             setShopErrors({
//               building_number: false,
//               shop_number: false,
//               area_sqm: false,
//               monthly_rent: false
//             });
//             setEditingShopIndex(null);
//           }}>Cancel</Button>
//           <Button onClick={validateAndAddShop} variant="contained">
//             {editingShopIndex !== null ? "Update Shop/Room" : "Add Shop/Room"}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     );
//   };

//   // ========== VIEW DETAILS DIALOG ==========
//   const renderViewDetailsDialog = () => {
//     if (!viewingAgreement) return null;
    
//     return (
//       <Dialog open={viewDialogOpen} onClose={() => setViewDialogOpen(false)} maxWidth="md" fullWidth>
//         <DialogTitle>
//           <Box display="flex" alignItems="center" justifyContent="space-between">
//             <Typography variant="h6">Agreement Details</Typography>
//             <Typography variant="subtitle2" color="textSecondary">ID: {viewingAgreement.agreement_id || viewingAgreement.id}</Typography>
//           </Box>
//         </DialogTitle>
//         <DialogContent dividers>
//           <Grid container spacing={2}>
//             <Grid item xs={12} md={6}><Typography variant="subtitle2" color="primary">Agreement ID</Typography><Typography variant="body2">{viewingAgreement.agreement_id || viewingAgreement.id || '-'}</Typography></Grid>
//             <Grid item xs={12} md={6}><Typography variant="subtitle2" color="primary">Ownership Type</Typography><Typography variant="body2">{viewingAgreement.ownership_type || '-'}</Typography></Grid>
//             <Grid item xs={12} md={6}><Typography variant="subtitle2" color="primary">Investment Type</Typography><Typography variant="body2">{viewingAgreement.investment_type || '-'}</Typography></Grid>
//             <Grid item xs={12} md={6}><Typography variant="subtitle2" color="primary">Park ID</Typography><Typography variant="body2">{viewingAgreement.park_id || '-'}</Typography></Grid>
//             <Grid item xs={12} md={6}><Typography variant="subtitle2" color="primary">Tenant ID</Typography><Typography variant="body2">{viewingAgreement.tenant_id || '-'}</Typography></Grid>
//             <Grid item xs={12}><Typography variant="subtitle2" color="primary">UPIN(s)</Typography><Typography variant="body2">{Array.isArray(viewingAgreement.upin) ? viewingAgreement.upin.join(', ') : viewingAgreement.upin || '-'}</Typography></Grid>
//             <Grid item xs={12} md={6}><Typography variant="subtitle2" color="primary">Contract Issued On</Typography><Typography variant="body2">{viewingAgreement.contract_issued_on || viewingAgreement.contract_issue || '-'}</Typography></Grid>
//             <Grid item xs={12} md={6}><Typography variant="subtitle2" color="primary">Contract Renewal Date</Typography><Typography variant="body2">{viewingAgreement.contract_renewal_date || viewingAgreement.contract_renewal || '-'}</Typography></Grid>
//             <Grid item xs={12} md={6}><Typography variant="subtitle2" color="primary">Contract Period (Months)</Typography><Typography variant="body2">{viewingAgreement.contract_period_in_months || viewingAgreement.contract_period || '-'}</Typography></Grid>
//             <Grid item xs={12} md={6}><Typography variant="subtitle2" color="primary">Handover Date</Typography><Typography variant="body2">{viewingAgreement.handover_date || '-'}</Typography></Grid>
//             <Grid item xs={12}><Typography variant="subtitle2" color="primary">Market Destination</Typography><Typography variant="body2">{viewingAgreement.market_destination || '-'}</Typography></Grid>
//             <Grid item xs={12}><Typography variant="subtitle2" color="primary">International Brands Link</Typography><Typography variant="body2">{viewingAgreement.intl_brands_link || '-'}</Typography></Grid>
//             <Grid item xs={12}><Typography variant="subtitle2" color="primary">Disposal Method</Typography><Typography variant="body2">{viewingAgreement.disposal_method || '-'}</Typography></Grid>
//             <Grid item xs={12} md={4}><Typography variant="subtitle2" color="primary">Production Capacity</Typography><Typography variant="body2">{viewingAgreement.production_capacity || '-'}</Typography></Grid>
//             <Grid item xs={12} md={4}><Typography variant="subtitle2" color="primary">Export Capacity (%)</Typography><Typography variant="body2">{viewingAgreement.export_capacity || '-'}</Typography></Grid>
//             <Grid item xs={12} md={4}><Typography variant="subtitle2" color="primary">Employee Capacity</Typography><Typography variant="body2">{viewingAgreement.employee_capacity || '-'}</Typography></Grid>
//             <Grid item xs={12} md={4}><Typography variant="subtitle2" color="primary">Monthly Rent</Typography><Typography variant="body2">${safeToFixed(viewingAgreement.monthly_rent || 0, 2)}</Typography></Grid>
//             <Grid item xs={12} md={4}><Typography variant="subtitle2" color="primary">Grace Period Ending Date</Typography><Typography variant="body2">{viewingAgreement.grace_period_ending_date || '-'}</Typography></Grid>
//             <Grid item xs={12} md={4}><Typography variant="subtitle2" color="primary">Security Deposit</Typography><Typography variant="body2">${safeToFixed(viewingAgreement.security || 0, 2)}</Typography></Grid>
//             <Grid item xs={12} md={4}><Typography variant="subtitle2" color="primary">Advance Payment</Typography><Typography variant="body2">${safeToFixed(viewingAgreement.advance_payment || 0, 2)}</Typography></Grid>
//             <Grid item xs={12} md={4}><Typography variant="subtitle2" color="primary">Annual Management Service Fee</Typography><Typography variant="body2">${safeToFixed(viewingAgreement.annual_mngmnt_service_fee || 0, 2)}</Typography></Grid>
//             <Grid item xs={12} md={4}><Typography variant="subtitle2" color="primary">Payment Mode</Typography><Typography variant="body2">{viewingAgreement.payment_mode || '-'}</Typography></Grid>
//             <Grid item xs={12}><Typography variant="subtitle2" color="primary">Description</Typography><Typography variant="body2">{viewingAgreement.description || '-'}</Typography></Grid>
//             <Grid item xs={12}><Typography variant="subtitle2" color="primary">Status</Typography><Chip label={viewingAgreement.status || viewingAgreement.current_status || 'PENDING'} color={(viewingAgreement.status === 'active') ? 'success' : 'default'} size="small" /></Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions><Button onClick={() => setViewDialogOpen(false)} variant="contained">Close</Button></DialogActions>
//       </Dialog>
//     );
//   };

//   // ========== TAB 0: EDIT AGREEMENT ==========
//   const renderEditTab = () => (
//     <Box>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//         <Typography variant="h5" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
//           {isEditMode ? "Edit Agreement" : "Register New Agreement"}
//         </Typography>
//         {isEditMode && (
//           <Button variant="outlined" color="error" onClick={handleCancelEdit} startIcon={<CancelIcon />}>
//             Cancel Edit
//           </Button>
//         )}
//       </Box>

//       {renderAgreementTypeSelector()}

//       {(formData.agreement_type === "Shed Land" || formData.agreement_type === "Leased Land") && renderShedLandWizard()}
//       {formData.agreement_type === "Residential" && renderResidentialWizard()}
//       {formData.agreement_type === "Commercial" && renderCommercialWizard()}
//     </Box>
//   );

//   // ========== TAB 1: SEARCH / VIEW ==========
//   const renderSearchTab = () => {
//     const currentAgreements = filterType === "expert_edit" ? expertEditAgreements : agreements;
//     const isLoading = filterType === "expert_edit" ? loadingExpertEdit : loadingAgreements;
    
//     const getFilteredAgreements = () => {
//       let filtered = [...currentAgreements];
      
//       if (filterType === "expert_edit") {
//         if (searchQuery) {
//           const searchLower = searchQuery.toLowerCase();
//           filtered = filtered.filter(agreement =>
//             (agreement.agreement_id || agreement.id || "").toLowerCase().includes(searchLower) ||
//             (agreement.tenant_id || "").toLowerCase().includes(searchLower) ||
//             (agreement.investor_name || "").toLowerCase().includes(searchLower) ||
//             (agreement.park_id || "").toLowerCase().includes(searchLower)
//           );
//         }
//         return filtered;
//       }
      
//       if (filterType !== "all") {
//         filtered = filtered.filter(agreement => {
//           const agreementType = agreement.agreement_type || agreement.ownership_type;
          
//           switch(filterType) {
//             case "shed":
//               return agreementType === 'Shed Land' || agreementType === 'Shed Rent' || 
//                      agreement.ownership_type === 'Shed Rent';
//             case "leased":
//               return agreementType === 'Leased Land' || agreementType === 'Land Leased' ||
//                      agreement.ownership_type === 'Land Leased';
//             case "commercial":
//               return agreementType === 'Commercial' || agreementType === 'commercial' ||
//                      agreement.ownership_type === 'Commercial';
//             case "residential":
//               return agreementType === 'Residential' || agreementType === 'residential' ||
//                      agreement.ownership_type === 'Residential';
//             default:
//               return true;
//           }
//         });
//       }
      
//       if (searchQuery) {
//         const searchLower = searchQuery.toLowerCase();
//         filtered = filtered.filter(agreement =>
//           (agreement.agreement_id || agreement.id || "").toLowerCase().includes(searchLower) ||
//           (agreement.tenant_id || "").toLowerCase().includes(searchLower) ||
//           (agreement.investor_name || "").toLowerCase().includes(searchLower) ||
//           (agreement.park_id || "").toLowerCase().includes(searchLower)
//         );
//       }
      
//       return filtered;
//     };
    
//     const filteredAgreements = getFilteredAgreements();

//     return (
//       <Box>
//         <Typography variant="h5" sx={{ color: '#1976d2', fontWeight: 'bold', mb: 3 }}>
//           Search & View Agreements
//         </Typography>
        
//         <Paper sx={{ p: 3, mb: 3 }}>
//           <Grid container spacing={2} alignItems="center">
//             <Grid item xs={12} md={2}>
//               <FormControl fullWidth size="small">
//                 <InputLabel id="filter-type-label">Agreement Type</InputLabel>
//                 <Select
//                   labelId="filter-type-label"
//                   value={filterType}
//                   onChange={(e) => {
//                     setFilterType(e.target.value);
//                     setPage(0);
//                     if (e.target.value === "expert_edit") {
//                       fetchAgreementsForExpertEdit();
//                     }
//                   }}
//                   label="Agreement Type"
//                 >
//                   <MenuItem value="expert_edit">Pending Verification (Requested/pending_verification)</MenuItem>
//                   <MenuItem value="all">All Active Agreements</MenuItem>
//                   <MenuItem value="shed">Shed Rental</MenuItem>
//                   <MenuItem value="leased">Leased Land</MenuItem>
//                   <MenuItem value="commercial">Commercial / One Stop Services</MenuItem>
//                   <MenuItem value="residential">Residential</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} md={8}>
//               <TextField
//                 fullWidth
//                 size="small"
//                 label="Search by ID, Tenant, Investor, UPIN, Park"
//                 value={searchQuery}
//                 onChange={(e) => setSearchQuery(e.target.value)}
//                 InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1, color: 'action.active' }} /> }}
//               />
//             </Grid>
//             <Grid item xs={12} md={2}>
//               <Stack direction="row" spacing={1}>
//                 <Button 
//                   fullWidth 
//                   variant="contained" 
//                   onClick={() => {
//                     if (filterType === "expert_edit") {
//                       fetchAgreementsForExpertEdit();
//                     } else {
//                       fetchAgreements();
//                     }
//                   }}
//                   disabled={isLoading}
//                 >
//                   {isLoading ? <CircularProgress size={24} /> : "Search"}
//                 </Button>
//                 <Button 
//                   variant="outlined" 
//                   startIcon={<RefreshIcon />} 
//                   onClick={() => { 
//                     setSearchQuery(""); 
//                     if (filterType === "expert_edit") {
//                       fetchAgreementsForExpertEdit();
//                     } else {
//                       fetchAgreements();
//                     }
//                   }}
//                 >
//                   Reset
//                 </Button>
//               </Stack>
//             </Grid>
//           </Grid>
//         </Paper>

//         <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//           <Typography variant="body2" color="textSecondary">
//             Total Agreements: {filteredAgreements.length}
//           </Typography>
//           <Button 
//             size="small" 
//             startIcon={<RefreshIcon />} 
//             onClick={() => {
//               if (filterType === "expert_edit") {
//                 fetchAgreementsForExpertEdit();
//               } else {
//                 fetchAgreements();
//               }
//             }}
//             disabled={isLoading}
//           >
//             Refresh
//           </Button>
//         </Box>

//         <Paper sx={{ width: '100%', overflow: 'auto' }}>
//           <TableContainer sx={{ maxHeight: 600, minWidth: 1200 }}>
//             <Table stickyHeader size="small">
//               <TableHead>
//                 <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
//                   <TableCell sx={{ fontWeight: 'bold', minWidth: 120 }}>ID</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Ownership Type</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Park ID</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold', minWidth: 150 }}>Investor Name</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Contract Issued</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Contract Renewal</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Monthly Rent</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Status</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold', minWidth: 120 }} align="center">Actions</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {isLoading ? (
//                   <TableRow>
//                     <TableCell colSpan={9} align="center" sx={{ py: 5 }}>
//                       <CircularProgress />
//                       <Typography variant="body2" sx={{ mt: 1 }}>Loading...</Typography>
//                     </TableCell>
//                   </TableRow>
//                 ) : filteredAgreements.length === 0 ? (
//                   <TableRow>
//                     <TableCell colSpan={9} align="center" sx={{ py: 5 }}>
//                       <Typography color="textSecondary">No agreements found</Typography>
//                     </TableCell>
//                   </TableRow>
//                 ) : (
//                   filteredAgreements
//                     .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                     .map((agreement) => (
//                       <TableRow key={agreement.id || agreement.agreement_id} hover>
//                         <TableCell>{agreement.agreement_id || agreement.id || '-'}</TableCell>
//                         <TableCell>
//                           <span>{agreement.agreement_type || agreement.ownership_type || 'N/A'}</span>
//                         </TableCell>
//                         <TableCell>{agreement.park_id || '-'}</TableCell>
//                         <TableCell>
//                           <Tooltip title={agreement.investor_name || '-'}>
//                             <Typography noWrap sx={{ maxWidth: 150 }}>
//                               {agreement.investor_name || '-'}
//                             </Typography>
//                           </Tooltip>
//                         </TableCell>
//                         <TableCell>{agreement.contract_issued_on || agreement.contract_issue || '-'}</TableCell>
//                         <TableCell>{agreement.contract_renewal_date || agreement.contract_renewal || '-'}</TableCell>
//                         <TableCell>${safeToFixed(agreement.monthly_rent || 0, 2)}</TableCell>
//                         <TableCell>
//                           <span>{agreement.status || agreement.current_status || 'PENDING'}</span>
//                         </TableCell>
//                         <TableCell align="center">
//                           <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center' }}>
//                             <Tooltip title="Edit">
//                               <IconButton size="small" onClick={() => handleEditClick(agreement)}>
//                                 <EditIcon />
//                               </IconButton>
//                             </Tooltip>
//                             <Tooltip title="View Details">
//                               <IconButton size="small" onClick={() => handleViewDetails(agreement)}>
//                                 <ViewIcon />
//                               </IconButton>
//                             </Tooltip>
//                           </Box>
//                         </TableCell>
//                       </TableRow>
//                     ))
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>
//           <TablePagination 
//             rowsPerPageOptions={[5, 10, 25, 50, 100]} 
//             component="div" 
//             count={filteredAgreements.length} 
//             rowsPerPage={rowsPerPage} 
//             page={page} 
//             onPageChange={(e, newPage) => setPage(newPage)} 
//             onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }} 
//           />
//         </Paper>
        
//         {renderViewDetailsDialog()}
//       </Box>
//     );
//   };

//   // ========== TAB 2: REJECTED AGREEMENTS ==========
//   const renderRejectedTab = () => {
//     const filteredAgreements = rejectedAgreements.filter(agreement => {
//       if (!searchQuery) return true;
//       const searchLower = searchQuery.toLowerCase();
//       return (agreement.agreement_id || agreement.id || "").toLowerCase().includes(searchLower) ||
//              (agreement.tenant_id || "").toLowerCase().includes(searchLower) ||
//              (agreement.investor_name || "").toLowerCase().includes(searchLower) ||
//              (agreement.park_id || "").toLowerCase().includes(searchLower);
//     });

//     return (
//       <Box>
//         <Typography variant="h5" sx={{ color: '#1976d2', fontWeight: 'bold', mb: 3 }}>
//            Rejected Agreements
//         </Typography>
        
//         <Paper sx={{ p: 3, mb: 3 }}>
//           <Grid container spacing={2} alignItems="center">
//             <Grid item xs={12} md={10}>
//               <TextField
//                 fullWidth
//                 size="small"
//                 label="Search by ID, Tenant, Investor, UPIN, Park"
//                 value={searchQuery}
//                 onChange={(e) => setSearchQuery(e.target.value)}
//                 InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1, color: 'action.active' }} /> }}
//               />
//             </Grid>
//             <Grid item xs={12} md={2}>
//               <Stack direction="row" spacing={1}>
//                 <Button 
//                   fullWidth 
//                   variant="contained" 
//                   onClick={fetchRejectedAgreements}
//                   disabled={loadingRejected}
//                 >
//                   {loadingRejected ? <CircularProgress size={24} /> : "Search"}
//                 </Button>
//                 <Button 
//                   variant="outlined" 
//                   startIcon={<RefreshIcon />} 
//                   onClick={() => { 
//                     setSearchQuery(""); 
//                     fetchRejectedAgreements();
//                   }}
//                 >
//                   Reset
//                 </Button>
//               </Stack>
//             </Grid>
//           </Grid>
//         </Paper>

//         <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//           <Typography variant="body2" color="textSecondary">
//             Total Rejected Agreements: {filteredAgreements.length}
//           </Typography>
//           <Button 
//             size="small" 
//             startIcon={<RefreshIcon />} 
//             onClick={fetchRejectedAgreements}
//             disabled={loadingRejected}
//           >
//             Refresh
//           </Button>
//         </Box>

//         <Paper sx={{ width: '100%', overflow: 'auto' }}>
//           <TableContainer sx={{ maxHeight: 600, minWidth: 1400 }}>
//             <Table stickyHeader size="small">
//               <TableHead>
//                 <TableRow sx={{ backgroundColor: '#ffebee' }}>
//                   <TableCell sx={{ fontWeight: 'bold', minWidth: 120 }}>ID</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Ownership Type</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Park ID</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold', minWidth: 150 }}>Investor Name</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Contract Issued</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Contract Renewal</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Monthly Rent</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold', minWidth: 250 }}>Description</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold', minWidth: 120 }}>Status</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold', minWidth: 120 }} align="center">Actions</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {loadingRejected ? (
//                   <TableRow>
//                     <TableCell colSpan={10} align="center" sx={{ py: 5 }}>
//                       <CircularProgress />
//                       <Typography variant="body2" sx={{ mt: 1 }}>Loading rejected agreements...</Typography>
//                     </TableCell>
//                   </TableRow>
//                 ) : filteredAgreements.length === 0 ? (
//                   <TableRow>
//                     <TableCell colSpan={10} align="center" sx={{ py: 5 }}>
//                       <Typography color="textSecondary">No rejected agreements found</Typography>
//                     </TableCell>
//                   </TableRow>
//                 ) : (
//                   filteredAgreements
//                     .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                     .map((agreement) => {
//                       const cleanDescription = (() => {
//                         const desc = agreement.description || '';
//                         const cleanDesc = desc.split(' [REJECTED By Head ON:')[0];
//                         return cleanDesc || '-';
//                       })();
                      
//                       return (
//                         <TableRow key={agreement.id || agreement.agreement_id} hover sx={{ backgroundColor: '#fff5f5' }}>
//                           <TableCell>{agreement.agreement_id || agreement.id || '-'}</TableCell>
//                           <TableCell>
//                             <span>{agreement.agreement_type || agreement.ownership_type || 'N/A'}</span>
//                           </TableCell>
//                           <TableCell>{agreement.park_id || '-'}</TableCell>
//                           <TableCell>
//                             <Tooltip title={agreement.investor_name || '-'}>
//                               <Typography noWrap sx={{ maxWidth: 150 }}>
//                                 {agreement.investor_name || '-'}
//                               </Typography>
//                             </Tooltip>
//                           </TableCell>
//                           <TableCell>{agreement.contract_issued_on || agreement.contract_issue || '-'}</TableCell>
//                           <TableCell>{agreement.contract_renewal_date || agreement.contract_renewal || '-'}</TableCell>
//                           <TableCell>${safeToFixed(agreement.monthly_rent || 0, 2)}</TableCell>
//                           <TableCell>
//                             <Typography sx={{ 
//                               maxWidth: 250, 
//                               whiteSpace: 'normal',
//                               wordBreak: 'break-word'
//                             }}>
//                               {cleanDescription}
//                             </Typography>
//                           </TableCell>
//                           <TableCell>
//                             <span>{agreement.status || agreement.current_status || 'REJECTED'}</span>
//                           </TableCell>
//                           <TableCell align="center">
//                             <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center' }}>
//                               <Tooltip title="View Details">
//                                 <IconButton size="small" onClick={() => handleViewDetails(agreement)}>
//                                   <ViewIcon />
//                                 </IconButton>
//                               </Tooltip>
//                             </Box>
//                           </TableCell>
//                         </TableRow>
//                       );
//                     })
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>
//           <TablePagination 
//             rowsPerPageOptions={[5, 10, 25, 50, 100]} 
//             component="div" 
//             count={filteredAgreements.length} 
//             rowsPerPage={rowsPerPage} 
//             page={page} 
//             onPageChange={(e, newPage) => setPage(newPage)} 
//             onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }} 
//           />
//         </Paper>
        
//         {renderViewDetailsDialog()}
//       </Box>
//     );
//   };

//   const mainTabs = ["Register / Edit Agreement", "Search & View", "Rejected Agreements"];

//   return (
//     <Container maxWidth="xl" className="app">
//       <Snackbar open={toast.open} autoHideDuration={6000} onClose={handleToastClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
//         <Alert onClose={handleToastClose} severity={toast.severity}>{toast.message}</Alert>
//       </Snackbar>

//       <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
//         <Tabs value={mainTabValue} onChange={(e, v) => setMainTabValue(v)} variant="fullWidth">
//           {mainTabs.map((label, i) => <Tab key={i} label={label} />)}
//         </Tabs>
//       </Box>

//       <TabPanel value={mainTabValue} index={0}>{renderEditTab()}</TabPanel>
//       <TabPanel value={mainTabValue} index={1}>{renderSearchTab()}</TabPanel>
//       <TabPanel value={mainTabValue} index={2}>{renderRejectedTab()}</TabPanel>

//       {renderRoomDialog()}
//       {renderShopDialog()}
//     </Container>
//   );
// }
//************************************************************************************** */
import React, { useState, useEffect } from "react";
import {
  Container, Box, Tabs, Tab, Typography, Card, CardContent,
  Grid, TextField, FormControl, InputLabel, Select, MenuItem,
  Button, Snackbar, Alert, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Chip, IconButton,
  Tooltip, TablePagination, CircularProgress,
  Dialog, DialogTitle, DialogContent, DialogActions,
  Stepper, Step, StepLabel, Stack
} from "@mui/material";
import {
  Search as SearchIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  Refresh as RefreshIcon,
  Business as BusinessIcon,
  Home as HomeIcon,
  Store as StoreIcon,
  Agriculture as LandIcon,
  Add as AddIcon,
  Factory as FactoryIcon,
  AttachMoney as MoneyIcon,
  Description as DescriptionIcon,
  Save as SaveIcon,
  MeetingRoom as MeetingRoomIcon,
  Apartment as ApartmentIcon,
  Shop as ShopIcon,
  Cancel as CancelIcon,
  Upload as UploadIcon,
  Close as CloseIcon
} from "@mui/icons-material";
import { Link } from "react-router-dom";

import { ExecutePostWithParams, GetDataFromApiWithParams, GetDataFromApiWithParamsAndGetResponse, UpdateAndGetResponse } from "../../../../services/api/ExecuteApiRequests";
import useDecodedUser from "../../../../services/hooks/useDecodedUser";
import "./agreement.css";

// ------------------------------------------------------------
// 1. Agreement Type Definitions
// ------------------------------------------------------------
const agreementTypes = [
  { id: "Shed Land", label: "Shed Rental", icon: <BusinessIcon /> },
  { id: "Leased Land", label: "Leased Land", icon: <LandIcon /> },
  { id: "Residential", label: "Residential", icon: <HomeIcon /> },
  { id: "Commercial", label: "Commercial / One Stop Services", icon: <StoreIcon /> }
];

// Steps for Shed/Leased Land Wizard
const shedLandSteps = [
  "Basic Information",
  "Investment & Contract Details",
  "Production & Capacity",
  "Market & Disposal",
  "Financial & Contractual Details",
  "Summary & Description"
];

// Steps for Residential Wizard
const residentialSteps = [
  "Location & Room Information",
  "Financial & Date Details"
];

// Steps for Commercial Wizard
const commercialSteps = [
  "Service & Location Information",
  "Financial & Contract Details"
];

// Base fields common to ALL types
const baseFields = {
  agreement_id: "",
  tenant_id: "",
  investor_name: "",
  park_id: "",
  park_name: "",
  upin: [],
  current_status: "ACTIVE",
  contract_issue: "",
  contract_renewal: "",
  handover_date: "",
  mou_signed: "",
  mou_attachment: null,
  description: ""
};

// ===== SHED (Full industrial terms - all 6 steps) =====
const shedFields = {
  ownership_type: "Shed Rent",
  upin: [],
  agreement_id: "",
  investment_type: "",
  contract_issue: "",
  contract_renewal: "",
  contract_period: "",
  handover_date: "",
  production_commencement_date: "",
  production_capacity: "",
  export_capacity: "",
  employee_capacity: "",
  market_destination: "",
  intl_brands_link: "",
  disposal_method: "",
  monthly_rent: 0,
  area_sqm: 0,
  area_as_per_contract_in_m2: "",
  security: 0,
  advance_payment: 0,
  annual_mngmnt_service_fee: 1.5,
  payment_mode: "usd",
  grace_period_ending_date: "",
  late_charge_fee: 5,
  penality_rate: "%",
  management_fee_per_sqm: 1.5,
  late_charge_percent: 5,
  water_rates: "I",
  stp_charges: 0.801,
  etp_charges: 0.801,
  grace_period_months: 3,
  mou_signed: "",
  mou_attachment: null,
  description: ""
};

// ===== LEASED LAND (Full industrial terms - all 6 steps) =====
const leasedLandFields = {
  ownership_type: "Land Leased",
  upin: [],
  agreement_id: "",
  investment_type: "",
  contract_issue: "",
  contract_renewal: "",
  contract_period: "",
  handover_date: "",
  production_commencement_date: "",
  production_capacity: "",
  export_capacity: "",
  employee_capacity: "",
  market_destination: "",
  intl_brands_link: "",
  disposal_method: "",
  annual_lease_rate: 0,
  area_sqm: 0,
  area_as_per_contract_in_m2: "",
  security: 0,
  advance_payment: 0,
  annual_mngmnt_service_fee: 1.5,
  payment_mode: "usd",
  grace_period_ending_date: "",
  late_charge_fee: 5,
  penality_rate: "%",
  management_fee_per_sqm: 1.5,
  late_charge_percent: 5,
  water_rates: "I",
  stp_charges: 0.801,
  etp_charges: 0.801,
  grace_period_months: 18,
  mou_signed: "",
  mou_attachment: null,
  description: ""
};

// ===== RESIDENTIAL (2 Steps - with Building and Room Number) =====
const residentialFields = {
  building_number: "",
  building_name: "",
  floor_number: "",
  ownership_type: "Residential",
  room_details: [],
  monthly_rent: 0,
  advance_months: 3,
  advance_payment: 0,
  security: 0,
  contract_issue: "",
  contract_renewal: "",
  handover_date: "",
  upin: [],
  agreement_id: "",
  mou_signed: "",
  mou_attachment: null,
  description: "",
  payment_mode: "usd"
};

// ===== COMMERCIAL / ONE STOP SERVICES (2 Steps) =====
const commercialFields = {
  service_type: "",
  shop_details: [],
  monthly_rent: 0,
  total_area_sqm: 0,
  ownership_type: "Commercial",
  security: 0,
  advance_payment: 0,
  contract_issue: "",
  contract_renewal: "",
  handover_date: "",
  upin: [],
  agreement_id: "",
  mou_signed: "",
  mou_attachment: null,
  description: "",
  payment_mode: "usd"
};

// Investment Options
const investmentOptions = [
  "Agro processing",
"Alluminium Product",
"Apparel",
"Basic Iron & Steel",
"Bussiness Group",
"Cement",
"Chemicals",
"Coffee Export",
"Construction",
"Energy Meter",
"Farming",
"Food Products and Beverage",
"Garment Manufacturing",
"Global Partner",
"High Tech",
"ICT",
"International Trading",
"Leather & Leather products",
"Logistics",
"Machinery",
"Manufacturing",
"Medical Textile Manufacturing",
"Motor vehicles",
"Paper Packaging",
"Plastic pipe and Condit",
"Pharmaceutical",
"Plastic & Rubber",
"Plastic Recycliging for construction materials",
"Processing",
"Production",
"Solar Manufacturing",
"Textile",
"Textile & Apparel",
"Trading",
"Vehicle",
"Water-based paint",
"Wood Paper & Furniture",
"Other"
];

// Room types
// const roomTypes = [
//   { id: "family", name: "Family Room", defaultArea: 73.44, defaultPrice: 14.24 },
//   { id: "suit1", name: "Suit Room Type 1", defaultArea: 48.3, defaultPrice: 14.24 },
//   { id: "suit2", name: "Suit Room Type 2", defaultArea: 77, defaultPrice: 14.24 },
//   // New rooms added after we recived new Agreements from inv after care dep't
  
//     { id: "threeBedFurnished", name: "Three Bedroom (Furnished rooms)", defaultArea: 60.54, defaultPrice: 14.247 },
//     { id: "oneBedFurnished", name: "One Bedroom (Furnished rooms)", defaultArea: 27.21, defaultPrice: 12.564 },
//     { id: "threeBedUnfurnished", name: "Three Bedroom (Unfurnished rooms)", defaultArea: 60.54, defaultPrice: 10.33 },
//     { id: "oneBedUnfurnished", name: "One Bedroom (Unfurnished rooms)", defaultArea: 27.21, defaultPrice: 8.66 },
//     { id: "dormitories", name: "Dormitories", defaultArea: 23, defaultPrice: 1426 },
//     { id: "studioRooms", name: "Studio Rooms", defaultArea: 23, defaultPrice: 6.26 },
//     { id: "threeBedRoom", name: "Three Bed Room", defaultArea: 60.54, defaultPrice: 10.33 },
//     { id: "dormitoriesRenovatedFurnished", name: "Dormitories (Renovated/Furnished)", defaultArea: 25.93, defaultPrice: 14.247 },
//     { id: "dormitoriesUnfurnished", name: "Dormitories (Unfurnished)", defaultArea: 27, defaultPrice: 8.66 },
//     { id: "studiosUnfurnished", name: "Studios (Unfurnished)", defaultArea: 27, defaultPrice: 6.26 }
  
// ];
const roomTypes = [
  { id: "canteen", name: "Canteen", defaultArea: 73, defaultPrice: 60 },
  { id: "dormitories", name: "Dormitories", defaultArea: 23, defaultPrice: 8.66 },
  { id: "dormitoriesRenovatedFurnished", name: "Dormitories (Renovated/Furnished)", defaultArea: 25.93, defaultPrice: 14.247 },
  { id: "dormitoriesUnfurnished", name: "Dormitories (Unfurnished)", defaultArea: 27, defaultPrice: 8.66 },
  { id: "dormitory", name: "Dormitory", defaultArea: 27, defaultPrice: 7.86 },
  { id: "dormitoryPrice2", name: "Dormitory", defaultArea: 27, defaultPrice: 8.25 },
  { id: "family", name: "Family Room", defaultArea: 73.44, defaultPrice: 14.247 },
  { id: "oneBedroom", name: "One Bedroom", defaultArea: 27.21, defaultPrice: 8.12 },
  { id: "oneBedroomArea2", name: "One Bedroom", defaultArea: 27.1, defaultPrice: 8.12 },
  { id: "oneBedroomPrice2", name: "One Bedroom", defaultArea: 27.21, defaultPrice: 8.53 },
  { id: "oneBedFurnished", name: "One Bedroom (Furnished rooms)", defaultArea: 27.21, defaultPrice: 12.564 },
  { id: "oneBedUnfurnished", name: "One Bedroom (Unfurnished rooms)", defaultArea: 27.21, defaultPrice: 8.96 },
  { id: "studio", name: "Studio", defaultArea: 23, defaultPrice: 5.68 },
  { id: "studioPrice2", name: "Studio", defaultArea: 23, defaultPrice: 15.68 },
  { id: "studioPrice3", name: "Studio", defaultArea: 23, defaultPrice: 5.96 },
  { id: "studioRooms", name: "Studio Rooms", defaultArea: 23, defaultPrice: 6.26 },
  { id: "studiosUnfurnished", name: "Studios (Unfurnished)", defaultArea: 23, defaultPrice: 6.26 },
  { id: "suit1", name: "Suit Room Type 1", defaultArea: 48.3, defaultPrice: 14.247 },
  { id: "suit2", name: "Suit Room Type 2", defaultArea: 24.67, defaultPrice: 14.247 },
  { id: "suitRoomStandard", name: "Suit Room standard", defaultArea: 37.4, defaultPrice: 14.247 },
  { id: "suitRoomStandardTwo", name: "Suit Room standard", defaultArea: 23, defaultPrice: 12.564 },
  { id: "threeBedroom", name: "Three Bedroom", defaultArea: 60.54, defaultPrice: 9.37 },
  { id: "threeBedroomPrice2", name: "Three Bedroom", defaultArea: 60.54, defaultPrice: 9.84 },
  { id: "threeBedFurnished", name: "Three Bedroom (Furnished rooms)", defaultArea: 60.54, defaultPrice: 14.247 },
  { id: "threeBedUnfurnished", name: "Three Bedroom (Unfurnished rooms)", defaultArea: 60.54, defaultPrice: 10.33 },
  { id: "threeBedRoom", name: "Three Bed Room", defaultArea: 60.54, defaultPrice: 10.33 }
];

// Service Types for Commercial
const serviceTypes = [
  "One Stop Shop",
  "Ethio-Tele",
  "Retail Shop",
  "Office Space",
  "Banking Service",
  "Restaurant/Café",
  "Pharmacy",
  "Other"
];

// Payment Modes
const paymentModes = [
  { id: "usd", label: "USD" },
  { id: "birr", label: "Birr" }
];

// Currency Types for Residential and Commercial
const currencyTypes = [
  { id: "usd", label: "USD", symbol: "$" },
  { id: "birr", label: "Birr", symbol: "ETB" }
];

// Get initial form data based on type
const getInitialFormData = (type = "Shed Land") => {
  let typeSpecific = {};
  
  switch(type) {
    case "Shed Land":
      typeSpecific = shedFields;
      break;
    case "Leased Land":
      typeSpecific = leasedLandFields;
      break;
    case "Residential":
      typeSpecific = residentialFields;
      break;
    case "Commercial":
      typeSpecific = commercialFields;
      break;
    default:
      typeSpecific = shedFields;
  }
  
  return {
    ...baseFields,
    ...typeSpecific,
    agreement_type: type
  };
};

// Helper function to safely format numbers
const safeToFixed = (value, decimals = 2) => {
  const num = typeof value === 'number' ? value : parseFloat(value);
  return isNaN(num) ? '0.00' : num.toFixed(decimals);
};

// Helper function to format date for input
const formatDateForInput = (dateValue) => {
  if (!dateValue || dateValue === 'Not Set' || dateValue === '1900-01-01') return '';
  
  if (typeof dateValue === 'string' && dateValue.match(/^\d{4}-\d{2}-\d{2}/)) {
    return dateValue.split('T')[0];
  }
  
  if (dateValue instanceof Date) {
    return dateValue.toISOString().split('T')[0];
  }
  
  if (typeof dateValue === 'string' && dateValue.includes('-')) {
    const parts = dateValue.split('-');
    if (parts.length === 3) {
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10);
      const year = parseInt(parts[2], 10);
      if (!isNaN(day) && !isNaN(month) && !isNaN(year) && 
          day >= 1 && day <= 31 && month >= 1 && month <= 12) {
        return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      }
    }
  }
  
  if (typeof dateValue === 'string' && dateValue.includes('/')) {
    const parts = dateValue.split('/');
    if (parts.length === 3) {
      return `${parts[2]}-${String(parts[1]).padStart(2, '0')}-${String(parts[0]).padStart(2, '0')}`;
    }
  }
  
  return '';
};

// ------------------------------------------------------------
// TabPanel component
// ------------------------------------------------------------
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

// ------------------------------------------------------------
// Main Component
// ------------------------------------------------------------
export default function AgreementManagement() {
  const [mainTabValue, setMainTabValue] = useState(0);
  const [formData, setFormData] = useState(getInitialFormData("Shed Land"));
  const [isLoading, setIsLoading] = useState(false);
  const [agreements, setAgreements] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [toast, setToast] = useState({ open: false, message: "", severity: "success" });
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingAgreementId, setEditingAgreementId] = useState(null);

  // Shed/Land wizard step state
  const [shedLandStep, setShedLandStep] = useState(0);
  
  // Residential wizard step state
  const [residentialStep, setResidentialStep] = useState(0);
  
  // Commercial wizard step state
  const [commercialStep, setCommercialStep] = useState(0);

  // Park & Investor & Parcel states
  const [parks, setParks] = useState([]);
  const [selectedPark, setSelectedPark] = useState(null);
  const [investors, setInvestors] = useState([]);
  const [parcelInPark, setParcelInPark] = useState([]);
  const [selectedUpins, setSelectedUpins] = useState([]);

  // Room dialog state for Residential
  const [roomDialogOpen, setRoomDialogOpen] = useState(false);
  const [newRoom, setNewRoom] = useState({
    type: "family",
    count: 1,
    area: 73.44,
    pricePerSqm: 14.24,
    room_number: ""
  });
  const [roomNumberError, setRoomNumberError] = useState(false);
  const [editingRoomIndex, setEditingRoomIndex] = useState(null);

  // Residential currency state
  const [residentialCurrency, setResidentialCurrency] = useState("usd");

  // Shop dialog state for Commercial
  const [shopDialogOpen, setShopDialogOpen] = useState(false);
  const [newShop, setNewShop] = useState({
    building_number: "",
    shop_number: "",
    area_sqm: 0,
    monthly_rent: 0,
    description: ""
  });
  const [shopErrors, setShopErrors] = useState({
    building_number: false,
    shop_number: false,
    area_sqm: false,
    monthly_rent: false
  });
  const [editingShopIndex, setEditingShopIndex] = useState(null);

  // Commercial currency state
  const [commercialCurrency, setCommercialCurrency] = useState("usd");

  // Search & View tab states
  const [filterType, setFilterType] = useState("expert_edit");
  const [shedInPark, setShedInPark] = useState([]);
  const [loadingAgreements, setLoadingAgreements] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  
  // Expert edit agreements state
  const [expertEditAgreements, setExpertEditAgreements] = useState([]);
  const [loadingExpertEdit, setLoadingExpertEdit] = useState(false);
  
  // Rejected agreements state
  const [rejectedAgreements, setRejectedAgreements] = useState([]);
  const [loadingRejected, setLoadingRejected] = useState(false);
  
  // View Details Dialog
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [viewingAgreement, setViewingAgreement] = useState(null);

  const decodedUser = useDecodedUser();
  const userValuesArray = Object.values(decodedUser || {});

  // Local state for shed selection in Step 1
  const [localSelectedShedId, setLocalSelectedShedId] = useState("");

  //******************************* */ State for "Other" investment type
  const [showOtherInvestment, setShowOtherInvestment] = useState(false);
  const [otherInvestmentValue, setOtherInvestmentValue] = useState("");
//************************************************************ */
  // Reset shed selection when park changes
  useEffect(() => {
    setLocalSelectedShedId("");
  }, [selectedPark]);

  // Sync residentialCurrency when editing
  useEffect(() => {
    if (formData.agreement_type === "Residential" && formData.payment_mode) {
      setResidentialCurrency(formData.payment_mode);
    }
  }, [formData.agreement_type, formData.payment_mode]);

  // Sync commercialCurrency when editing
  useEffect(() => {
    if (formData.agreement_type === "Commercial" && formData.payment_mode) {
      setCommercialCurrency(formData.payment_mode);
    }
  }, [formData.agreement_type, formData.payment_mode]);

  // ---------- Toast Helpers ----------
  const showToast = (msg, severity = "success") => {
    setToast({ open: true, message: msg, severity });
  };

  const handleToastClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setToast({ ...toast, open: false });
  };

  // ---------- Fetch Parks ----------
  const fetchParks = async () => {
    try {
      const data = await GetDataFromApiWithParams("parks");
      setParks(data || []);
    } catch (error) {
      console.error("Failed to fetch parks", error);
    }
  };

  // ---------- Fetch Investors ----------
  const fetchInvestors = async () => {
    try {
      const data = await GetDataFromApiWithParams("investors");
      setInvestors(data || []);
    } catch (error) {
      console.error("Failed to fetch investors", error);
    }
  };

  // ---------- Fetch Available Parcels ----------
  const fetchAvailableParcels = async (parkId) => {
    if (!parkId) return;
    try {
      const res = await GetDataFromApiWithParams(`availableParcelsInPark/${parkId}`);
      const allParcels = Array.isArray(res) ? res : [];
      setParcelInPark(allParcels);
      console.log("Fetched parcels:", allParcels);
    } catch (error) {
      console.error("Failed to fetch available parcels", error);
      setParcelInPark([]);
    }
  };

  // ---------- Fetch Sheds in Park ----------
  const fetchShedInPark = async (parkId) => {
    if (!parkId) return;
    try {
      const res = await GetDataFromApiWithParams(`availableShedInPark/${parkId}`, { params: { id: parkId } });
      setShedInPark(Array.isArray(res) ? res : []);
      console.log("Fetched sheds:", res);
    } catch (error) {
      console.error("Failed to fetch sheds", error);
      setShedInPark([]);
    }
  };

  // ---------- Generate Agreement ID ----------
  const generateAgreementId = async (parkId) => {
    if (!parkId) {
      setFormData(prev => ({ ...prev, agreement_id: "" }));
      return;
    }
    try {
      const result = await GetDataFromApiWithParamsAndGetResponse(`agreements/${parkId}/getNewId`);
      if (result?.data?.new_id) {
        setFormData(prev => ({ ...prev, agreement_id: result.data.new_id }));
      }
    } catch (error) {
      console.error("Failed to generate agreement ID", error);
    }
  };

  // ---------- Handle Park Selection ----------
  const handleParkChange = async (e) => {
    const parkId = e.target.value;
    const park = parks.find(p => p.id === parkId);
    setSelectedPark(park);
    setFormData(prev => ({ 
      ...prev, 
      park_id: parkId,
      park_name: park?.name || ""
    }));
    
    if (formData.agreement_type === "Shed Land" || formData.agreement_type === "Leased Land") {
      setSelectedUpins([]);
      setFormData(prev => ({ ...prev, upin: [] }));
      setLocalSelectedShedId("");
      
      // Fetch parcels for both types
      await fetchAvailableParcels(parkId);
      
      // Fetch sheds only for Shed Land
      if (formData.agreement_type === "Shed Land") {
        await fetchShedInPark(parkId);
      }
    }
    
    if (!isEditMode) {
      generateAgreementId(parkId);
    }
  };

  // ---------- Handle Investor Selection ----------
  const handleInvestorChange = (e) => {
    const investorId = e.target.value;
    const investor = investors.find(i => i.id === investorId);
    setFormData(prev => ({ 
      ...prev, 
      tenant_id: investorId,
      investor_name: investor?.company_name || investor?.name || ""
    }));
  };

  // ---------- Handle Shed Selection ----------
  const handleShedSelection = (shedId) => {
    setLocalSelectedShedId(shedId);
    
    // Find the selected shed from shedInPark
    const selectedShed = shedInPark?.find(shed => shed.shed_id === shedId);
    
    if (selectedShed && selectedShed.upin) {
      // Clear existing selections and add the new UPIN
      // const newSelectedUpins = [selectedShed.upin]; // ************* to selct more than UPIN
      const newSelectedUpins = [...selectedUpins, selectedShed.upin];
      setSelectedUpins(newSelectedUpins);
      setFormData(prev => ({ 
        ...prev, 
        upin: newSelectedUpins,
        ownership_type: "Shed Rent"
      }));
      
      console.log(`Selected shed: ${shedId} with UPIN: ${selectedShed.upin}`);
    }
  };

  // ---------- Handle Parcel Selection (for Leased Land) ----------
  const handleParcelSelection = (upin) => {
    if (!selectedUpins.includes(upin)) {
      const newSelectedUpins = [...selectedUpins, upin];
      setSelectedUpins(newSelectedUpins);
      setFormData(prev => ({ ...prev, upin: newSelectedUpins }));

      const theParcel = parcelInPark.find(parcel => parcel.upin === upin);
      if (theParcel?.type === "land") {
        setFormData(prev => ({ ...prev, ownership_type: "Land Leased" }));
      }
    }
  };

  // ---------- Handle UPIN Removal ----------
  const handleRemoveUpin = (upinToRemove) => {
    const filteredUpins = selectedUpins.filter(upin => upin !== upinToRemove);
    setSelectedUpins(filteredUpins);
    setFormData(prev => ({ ...prev, upin: filteredUpins }));
    
    // Clear selected shed if UPIN is removed and we're in Shed Land mode
    if (filteredUpins.length === 0 && formData.agreement_type === "Shed Land") {
      setLocalSelectedShedId("");
      setFormData(prev => ({ ...prev, ownership_type: "" }));
    }
  };

  // ---------- Agreement Type Change ----------
  const handleAgreementTypeChange = (e) => {
    const newType = e.target.value;
    const newFormData = getInitialFormData(newType);
    setFormData(newFormData);
    setSelectedPark(null);
    setSelectedUpins([]);
    setParcelInPark([]);
    setShedInPark([]);
    setLocalSelectedShedId("");
    setShedLandStep(0);
    setResidentialStep(0);
    setCommercialStep(0);
    setRoomDialogOpen(false);
    setShopDialogOpen(false);
    if (newType === "Residential") {
      setResidentialCurrency("usd");
    }
    if (newType === "Commercial") {
      setCommercialCurrency("usd");
    }
  };

  // ---------- Generic Field Change ----------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // ---------- Calculate Contract Period ----------
  const getMonthsBetween = (date1, date2) => {
    if (!date1 || !date2) return 0;
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    let months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    if (d2.getDate() < d1.getDate()) months--;
    return months <= 0 ? 0 : months;
  };

  // ---------- Handle Contract Issue Date Change ----------
  const handleIssueDateChange = (date) => {
    setFormData(prev => ({ ...prev, contract_issue: date }));
    
    if (formData.agreement_type === "Shed Land" || formData.agreement_type === "Leased Land") {
      if (!formData.grace_period_ending_date) {
        const gracePeriodMonths = formData.agreement_type === "Shed Land" ? 3 : 18;
        const graceDate = new Date(date);
        graceDate.setMonth(graceDate.getMonth() + gracePeriodMonths);
        setFormData(prev => ({ 
          ...prev, 
          contract_issue: date,
          grace_period_ending_date: graceDate.toISOString().split('T')[0]
        }));
      }
    }
  };

  // ---------- Handle Renewal Date Change ----------
  const handleRenewalDateChange = (date) => {
    setFormData(prev => ({ ...prev, contract_renewal: date }));
    if (formData.contract_issue && (formData.agreement_type === "Shed Land" || formData.agreement_type === "Leased Land")) {
      const period = getMonthsBetween(formData.contract_issue, date);
      setFormData(prev => ({ ...prev, contract_period: period }));
    }
  };

  // ---------- RESIDENTIAL: Add/Edit Room ----------
  const handleAddRoom = () => {
    const totalArea = newRoom.count * newRoom.area;
    const monthlyRent = totalArea * newRoom.pricePerSqm;
    
    const roomToAdd = {
      type: newRoom.type,
      count: newRoom.count,
      area: newRoom.area,
      pricePerSqm: newRoom.pricePerSqm,
      room_number: newRoom.room_number,
      totalArea,
      monthlyRent,
      id_pk: newRoom.id_pk || Date.now(),
      currency: residentialCurrency
    };
    
    let updatedRooms;
    if (editingRoomIndex !== null) {
      updatedRooms = [...formData.room_details];
      updatedRooms[editingRoomIndex] = roomToAdd;
      setEditingRoomIndex(null);
    } else {
      updatedRooms = [...(formData.room_details || []), roomToAdd];
    }
    
    const totalMonthlyRent = updatedRooms.reduce((sum, room) => sum + room.monthlyRent, 0);
    const advancePaymentTotal = totalMonthlyRent * (formData.advance_months || 3);
    
    setFormData(prev => ({
      ...prev,
      room_details: updatedRooms,
      monthly_rent: totalMonthlyRent,
      advance_payment: advancePaymentTotal,
      payment_mode: residentialCurrency
    }));
    
    setRoomDialogOpen(false);
    setRoomNumberError(false);
    setNewRoom({
      type: "family",
      count: 1,
      area: 73.44,
      pricePerSqm: 14.24,
      room_number: ""
    });
  };

  // ---------- RESIDENTIAL: Edit Room ----------
  const handleEditRoom = (index) => {
    const room = formData.room_details[index];
    setNewRoom({
      type: room.type,
      count: room.count,
      area: room.area,
      pricePerSqm: room.pricePerSqm,
      room_number: room.room_number,
      id_pk: room.id_pk
    });
    setEditingRoomIndex(index);
    setRoomDialogOpen(true);
  };

  // ---------- RESIDENTIAL: Remove Room ----------
  const handleRemoveRoom = (index) => {
    const updatedRooms = [...formData.room_details];
    updatedRooms.splice(index, 1);
    const totalMonthlyRent = updatedRooms.reduce((sum, room) => sum + room.monthlyRent, 0);
    const advancePaymentTotal = totalMonthlyRent * (formData.advance_months || 3);
    setFormData(prev => ({
      ...prev,
      room_details: updatedRooms,
      monthly_rent: totalMonthlyRent,
      advance_payment: advancePaymentTotal
    }));
  };

  // ---------- RESIDENTIAL: Update Advance Months ----------
  const handleAdvanceMonthsChange = (e) => {
    const months = parseInt(e.target.value) || 3;
    const advanceTotal = (formData.monthly_rent || 0) * months;
    setFormData(prev => ({
      ...prev,
      advance_months: months,
      advance_payment: advanceTotal
    }));
  };

  // ---------- COMMERCIAL: Add/Edit Shop ----------
  const handleAddShop = () => {
    const errors = {
      building_number: !newShop.building_number || newShop.building_number.trim() === "",
      shop_number: !newShop.shop_number || newShop.shop_number.trim() === "",
      area_sqm: !newShop.area_sqm || newShop.area_sqm <= 0,
      monthly_rent: !newShop.monthly_rent || newShop.monthly_rent <= 0
    };
    
    setShopErrors(errors);
    
    if (errors.building_number || errors.shop_number || errors.area_sqm || errors.monthly_rent) {
      showToast("Please fill all required fields correctly", "warning");
      return;
    }
    
    const shopToAdd = {
      ...newShop,
      id_pk: newShop.id_pk || Date.now(),
      monthly_rent: parseFloat(newShop.monthly_rent) || 0,
      area_sqm: parseFloat(newShop.area_sqm) || 0,
      currency: commercialCurrency
    };
    
    let updatedShops;
    if (editingShopIndex !== null) {
      updatedShops = [...formData.shop_details];
      updatedShops[editingShopIndex] = shopToAdd;
      setEditingShopIndex(null);
    } else {
      updatedShops = [...(formData.shop_details || []), shopToAdd];
    }
    
    const totalMonthlyRent = updatedShops.reduce((sum, shop) => sum + (shop.monthly_rent || 0), 0);
    const totalArea = updatedShops.reduce((sum, shop) => sum + (shop.area_sqm || 0), 0);
    
    setFormData(prev => ({
      ...prev,
      shop_details: updatedShops,
      monthly_rent: totalMonthlyRent,
      total_area_sqm: totalArea,
      payment_mode: commercialCurrency
    }));
    
    setShopDialogOpen(false);
    setShopErrors({
      building_number: false,
      shop_number: false,
      area_sqm: false,
      monthly_rent: false
    });
    setNewShop({
      building_number: "",
      shop_number: "",
      area_sqm: 0,
      monthly_rent: 0,
      description: ""
    });
  };

  // ---------- COMMERCIAL: Edit Shop ----------
  const handleEditShop = (index) => {
    const shop = formData.shop_details[index];
    setNewShop({
      building_number: shop.building_number,
      shop_number: shop.shop_number,
      area_sqm: shop.area_sqm,
      monthly_rent: shop.monthly_rent,
      description: shop.description || "",
      id_pk: shop.id_pk
    });
    setEditingShopIndex(index);
    setShopDialogOpen(true);
  };

  // ---------- COMMERCIAL: Remove Shop ----------
  const handleRemoveShop = (index) => {
    const updatedShops = [...formData.shop_details];
    updatedShops.splice(index, 1);
    const totalMonthlyRent = updatedShops.reduce((sum, shop) => sum + (shop.monthly_rent || 0), 0);
    const totalArea = updatedShops.reduce((sum, shop) => sum + (shop.area_sqm || 0), 0);
    setFormData(prev => ({
      ...prev,
      shop_details: updatedShops,
      monthly_rent: totalMonthlyRent,
      total_area_sqm: totalArea
    }));
  };

  // ---------- Handle File Attachment ----------
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({ ...prev, mou_attachment: file }));
    }
  };

  const handleRemoveFile = () => {
    setFormData(prev => ({ 
      ...prev, 
      mou_attachment: null,
      mou_attachment_existing: null
    }));
  };
//***************************other Invetment typing textbox handler function*/
const handleOtherInvestmentChange = (e) => {
  const value = e.target.value;
  setOtherInvestmentValue(value);
  // Don't update formData.investment_type - keep it as "Other"
};

const handleInvestmentTypeChange = (e) => {
  const value = e.target.value;
  if (value === "Other") {
    setShowOtherInvestment(true);
    setFormData(prev => ({ ...prev, investment_type: "Other" }));
  } else {
    setShowOtherInvestment(false);
    setOtherInvestmentValue("");
    setFormData(prev => ({ ...prev, investment_type: value }));
  }
};
//***************************** */
  // ---------- Wizard Navigation ----------
  const handleShedLandNextStep = () => {
    if (validateShedLandStep(shedLandStep)) {
      setShedLandStep(prev => prev + 1);
    } else {
      showToast("Please fill all required fields before proceeding. RRRRRRR", "warning");
    }
  };

  const handleShedLandPrevStep = () => {
    setShedLandStep(prev => prev - 1);
  };

  const handleResidentialNextStep = () => {
    if (validateResidentialStep(residentialStep)) {
      setResidentialStep(prev => prev + 1);
    } else {
      showToast("Please fill all required fields before proceeding.SSSSSSSS", "warning");
    }
  };

  const handleResidentialPrevStep = () => {
    setResidentialStep(prev => prev - 1);
  };

  const handleCommercialNextStep = () => {
    if (validateCommercialStep(commercialStep)) {
      setCommercialStep(prev => prev + 1);
    } else {
      showToast("Please fill all required fields before proceeding.", "warning");
    }
  };

  const handleCommercialPrevStep = () => {
    setCommercialStep(prev => prev - 1);
  };

  // ---------- Validate Steps ----------
  const validateShedLandStep = (step) => {
    switch(step) {
      case 0: 
        const hasValidSelection = selectedUpins.length > 0;
        return formData.park_id && formData.tenant_id && hasValidSelection;
      case 1: return formData.investment_type && formData.contract_issue && formData.contract_renewal;
      case 2: return formData.production_capacity && formData.export_capacity && formData.employee_capacity;
      case 3: return formData.market_destination && formData.disposal_method;
      // case 4: return formData.monthly_rent && formData.area_as_per_contract_in_m2 && formData.security;
      default: return true;
    }
  };

  const validateResidentialStep = (step) => {
    switch(step) {
      case 0: return formData.park_id && formData.tenant_id;
      case 1: return formData.room_details && formData.room_details.length > 0;
      default: return true;
    }
  };

  const validateCommercialStep = (step) => {
    switch(step) {
      case 0: return formData.park_id && formData.tenant_id && formData.service_type && formData.shop_details && formData.shop_details.length > 0;
      case 1: return formData.contract_issue && formData.contract_renewal;
      default: return true;
    }
  };

  // ---------- Reset Form ----------
  const resetForm = () => {
    setFormData(getInitialFormData("Shed Land"));
    setSelectedPark(null);
    setSelectedUpins([]);
    setShedInPark([]);
    setLocalSelectedShedId("");
    setShedLandStep(0);
    setResidentialStep(0);
    setCommercialStep(0);
    setIsEditMode(false);
    setEditingAgreementId(null);
    setEditingRoomIndex(null);
    setEditingShopIndex(null);
    setResidentialCurrency("usd");
    setCommercialCurrency("usd");
  };

  // ---------- Fetch Agreements List ----------
  const fetchAgreements = async () => {
    setLoadingAgreements(true);
    try {
      const data = await GetDataFromApiWithParams("agreements");
      setAgreements(data || []);
    } catch (error) {
      console.error("Failed to fetch agreements", error);
      showToast("Failed to fetch agreements", "error");
      setAgreements([]);
    } finally {
      setLoadingAgreements(false);
    }
  };

  // ---------- Fetch Agreements for Expert Edit ----------
  const fetchAgreementsForExpertEdit = async () => {
    setLoadingExpertEdit(true);
    try {
      const data = await GetDataFromApiWithParams("agreements/agreements_for_edit_by_expert");
      console.log("Expert edit agreements response:", data);
      setExpertEditAgreements(data || []);
    } catch (error) {
      console.error("Failed to fetch agreements for expert edit", error);
      showToast("Failed to fetch agreements for expert edit", "error");
      setExpertEditAgreements([]);
    } finally {
      setLoadingExpertEdit(false);
    }
  };

  // ---------- Fetch Rejected Agreements ----------
  const fetchRejectedAgreements = async () => {
    setLoadingRejected(true);
    try {
      const data = await GetDataFromApiWithParams("agreements/rejected");
      console.log("Rejected agreements:", data);
      setRejectedAgreements(data || []);
    } catch (error) {
      console.error("Failed to fetch rejected agreements", error);
      showToast("Failed to fetch rejected agreements", "error");
      setRejectedAgreements([]);
    } finally {
      setLoadingRejected(false);
    }
  };

  // ---------- Handle View Mode Change ----------
  const handleViewModeChange = (event) => {
    const newMode = event.target.value;
    setFilterType(newMode);
    setPage(0);
    
    if (newMode === "expert_edit") {
      fetchAgreementsForExpertEdit();
    }
  };

  // ---------- Load Agreement Data into Form for Editing ----------
  const handleEditClick = async (agreement) => {
    console.log("=== EDIT CLICK DEBUG ===");
    console.log("Agreement:", agreement);
    
    // Determine agreement type
    let agreementTypeValue = agreement.agreement_type;
    if (!agreementTypeValue) {
      if (agreement.ownership_type === 'Shed Rent') agreementTypeValue = 'Shed Land';
      else if (agreement.ownership_type === 'Land Leased') agreementTypeValue = 'Leased Land';
      else if (agreement.ownership_type === 'Residential') agreementTypeValue = 'Residential';
      else if (agreement.ownership_type === 'Commercial') agreementTypeValue = 'Commercial';
      else agreementTypeValue = 'Shed Land';
    }
    
    // Parse upin
    let parsedUpin = [];
    if (agreement.upin) {
      if (Array.isArray(agreement.upin)) {
        parsedUpin = agreement.upin.filter(u => u && u !== 'N/A' && u !== 'NULL');
      } else if (typeof agreement.upin === 'string') {
        if (agreement.upin !== 'N/A' && agreement.upin !== 'NULL') {
          parsedUpin = [agreement.upin];
        }
      }
    }
    
    const editFormData = {
      ...getInitialFormData(agreementTypeValue),
      agreement_id: agreement.agreement_id || agreement.id,
      tenant_id: agreement.tenant_id,
      investor_name: agreement.investor_name,
      park_id: agreement.park_id,
      park_name: agreement.park_name,
      upin: parsedUpin,
      contract_issue: formatDateForInput(agreement.contract_issued_on),
      contract_renewal: formatDateForInput(agreement.contract_renewal_date),
      handover_date: formatDateForInput(agreement.handover_date),
      mou_signed: formatDateForInput(agreement.moe_signed_on),
      grace_period_ending_date: formatDateForInput(agreement.grace_period_ending_date),
      production_commencement_date: formatDateForInput(agreement.production_commencement_date),
      rehandover_date: formatDateForInput(agreement.rehandover_date),
      description: agreement.description || "",
      ownership_type: agreement.ownership_type,
      investment_type: agreement.investment_type,
      contract_period: agreement.contract_period_in_months || "",
      production_capacity: agreement.production_capacity || "",
      export_capacity: agreement.export_capacity || "",
      employee_capacity: agreement.employee_capacity || "",
      market_destination: agreement.market_destination || "",
      intl_brands_link: agreement.intl_brands_link || "",
      disposal_method: agreement.disposal_method || "",
      monthly_rent: agreement.monthly_rent || 0,
      annual_lease_rate: agreement.annual_lease_rate || 0,
      area_as_per_contract_in_m2: agreement.area_as_per_contract_in_m2 || agreement.area_for_calculation || "",
      security: agreement.security || 0,
      advance_payment: agreement.advance_payment || 0,
      annual_mngmnt_service_fee: agreement.annual_mngmnt_service_fee || 0,
      payment_mode: agreement.payment_mode || "usd",
      late_charge_fee: agreement.late_charge_fee || 5,
      penality_rate: "%",
      current_status: agreement.status || agreement.current_status || "ACTIVE",
      room_details: agreement.room_details || [],
      building_number: agreement.building_number || "",
      building_name: agreement.building_name || "",
      floor_number: agreement.floor_number || "",
      advance_months: agreement.advance_months || 3,
      shop_details: agreement.shop_details || [],
      service_type: agreement.service_type || "",
      total_area_sqm: agreement.total_area_sqm || "",
      mou_attachment: agreement.mou_attachment || null,
      mou_attachment_existing: agreement.mou_attachment || null,
    };
    
    setFormData(editFormData);
    setIsEditMode(true);
    setEditingAgreementId(agreement.id || agreement.agreement_id);
    
    if (agreement.park_id) {
      const park = parks.find(p => p.id === agreement.park_id);
      setSelectedPark(park);
      await fetchAvailableParcels(agreement.park_id);
      if (agreementTypeValue === "Shed Land") {
        await fetchShedInPark(agreement.park_id);
      }
    }
    
    setSelectedUpins(parsedUpin);
    
    setShedLandStep(0);
    setResidentialStep(0);
    setCommercialStep(0);
    setMainTabValue(0);
    
    if (agreementTypeValue === "Residential" && agreement.payment_mode) {
      setResidentialCurrency(agreement.payment_mode);
    } else if (agreementTypeValue === "Residential") {
      setResidentialCurrency("usd");
    }
    
    if (agreementTypeValue === "Commercial" && agreement.payment_mode) {
      setCommercialCurrency(agreement.payment_mode);
    } else if (agreementTypeValue === "Commercial") {
      setCommercialCurrency("usd");
    }
    
    showToast(`Editing agreement: ${agreement.agreement_id || agreement.id}`, "info");
  };

  // ---------- Cancel Edit ----------
  const handleCancelEdit = () => {
    resetForm();
    setMainTabValue(1);
    showToast("Edit cancelled", "info");
  };

  // ---------- View Details ----------
  const handleViewDetails = (agreement) => {
    setViewingAgreement(agreement);
    setViewDialogOpen(true);
  };

  // ---------- Filter change handler ----------
  const handleFilterTypeChange = (event) => {
    setFilterType(event.target.value);
    setPage(0);
  };

  // ---------- Save Agreement ----------
  const handleSaveAgreement = async () => {
    if (!formData.park_id) {
      showToast("Please select a park", "error");
      return;
    }
    if (!formData.tenant_id) {
      showToast("Please select an investor", "error");
      return;
    }

    if (formData.agreement_type === "Shed Land" || formData.agreement_type === "Leased Land") {
      if (selectedUpins.length === 0) {
        showToast("Please select a shed or parcel", "error");
        return;
      }
      if (shedLandStep < 5) {
        showToast("Please complete all steps before saving", "warning");
        setShedLandStep(5);
        return;
      }
    }

    if (formData.agreement_type === "Residential") {
      if (!formData.room_details || formData.room_details.length === 0) {
        showToast("Please add at least one room", "error");
        return;
      }
      if (residentialStep < 1) {
        showToast("Please complete all steps before saving", "warning");
        setResidentialStep(1);
        return;
      }
    }

    if (formData.agreement_type === "Commercial") {
      if (!formData.service_type) {
        showToast("Please select service type", "error");
        return;
      }
      if (!formData.shop_details || formData.shop_details.length === 0) {
        showToast("Please add at least one shop/room", "error");
        return;
      }
      if (commercialStep < 1) {
        showToast("Please complete all steps before saving", "warning");
        setCommercialStep(1);
        return;
      }
    }

    setIsLoading(true);
    try {
      if (isEditMode && editingAgreementId) {
        const formatDateForUpdate = (dateValue) => {
          if (!dateValue || dateValue === "" || dateValue === "Not Set" || dateValue === "1900-01-01") {
            return null;
          }
          return dateValue;
        };
        
        const safeParseFloat = (value) => {
          if (value === "" || value === null || value === undefined) return 0;
          return parseFloat(value) || 0;
        };
        
        const safeParseInt = (value) => {
          if (value === "" || value === null || value === undefined) return 0;
          return parseInt(value) || 0;
        };
        
        let upinString = selectedUpins.length > 0 ? selectedUpins.join(',') : 'N/A';
        
        const marketDestinationArray = formData.market_destination 
          ? (Array.isArray(formData.market_destination) 
              ? formData.market_destination 
              : [formData.market_destination])
          : [];
        
        const intlBrandsLinkArray = formData.intl_brands_link 
          ? (Array.isArray(formData.intl_brands_link) 
              ? formData.intl_brands_link 
              : [formData.intl_brands_link])
          : [];
        
        const lateChargeJson = JSON.stringify({
          fee: safeParseFloat(formData.late_charge_fee),
          rate_type: formData.penality_rate || '%',
          currency: formData.payment_mode || 'usd'
        });
        
        let mouAttachmentValue = null;
        if (formData.mou_attachment) {
          if (formData.mou_attachment instanceof File) {
            mouAttachmentValue = formData.mou_attachment_existing || null;
          } else if (typeof formData.mou_attachment === 'string') {
            mouAttachmentValue = formData.mou_attachment;
          }
        }
        
        const updatePayload = {
          tenant_id: formData.tenant_id || "",
          upin: upinString,
          ownership_type: formData.ownership_type || "",
          // investment_type: formData.investment_type || "",
          //****************the following is to handle other investment types ********* */
                investment_type: (formData.investment_type === "Other" && otherInvestmentValue) 
                ? otherInvestmentValue 
                : formData.investment_type || "",
          //************************ */
          contract_issued_on: formatDateForUpdate(formData.contract_issue),
          contract_renewal_date: formatDateForUpdate(formData.contract_renewal),
          moe_signed_on: formatDateForUpdate(formData.mou_signed),
          production_capacity: safeParseFloat(formData.production_capacity),
          handover_date: formatDateForUpdate(formData.handover_date),
          rehandover_date: formatDateForUpdate(formData.rehandover_date),
          production_commencement_date: formatDateForUpdate(formData.production_commencement_date),
          market_destination: marketDestinationArray,
          intl_brands_link: intlBrandsLinkArray,
          disposal_method: formData.disposal_method || null,
          export_capacity: safeParseFloat(formData.export_capacity),
          employee_capacity: safeParseInt(formData.employee_capacity),
          monthly_rent: safeParseFloat(formData.monthly_rent || formData.annual_lease_rate),
          grace_period_ending_date: formatDateForUpdate(formData.grace_period_ending_date),
          security: safeParseFloat(formData.security),
          advance_payment: safeParseFloat(formData.advance_payment),
          annual_mngmnt_service_fee: safeParseFloat(formData.annual_mngmnt_service_fee),
          payment_mode: (formData.payment_mode || "usd").toUpperCase(),
          late_charge_fee: lateChargeJson,
          contract_period_in_months: safeParseInt(formData.contract_period),
          description: formData.description || "",
          park_id: formData.park_id || null,
          status: "Requested",
          service_type: formData.service_type || null,
          total_area_sqm: safeParseFloat(formData.total_area_sqm),
          building_number: formData.building_number || null,
          building_name: formData.building_name || null,
          floor_number: formData.floor_number || null,
          advance_months: safeParseInt(formData.advance_months),
          room_details: formData.room_details || [],
          shop_details: formData.shop_details || [],
          area_for_calculation: safeParseFloat(formData.area_as_per_contract_in_m2 || formData.total_area_sqm),
          mou_attachment: mouAttachmentValue,
        };
        
        console.log("Update payload:", updatePayload);
        
        await UpdateAndGetResponse(`agreements/${editingAgreementId}`, updatePayload);
        
        showToast("Agreement updated successfully", "success");
        setIsEditMode(false);
        setEditingAgreementId(null);
        
        if (filterType === "expert_edit") {
          fetchAgreementsForExpertEdit();
        } else {
          fetchAgreements();
        }
        
        fetchRejectedAgreements();
        
      } else {
        const payload = { 
          ...formData, 
          upin: selectedUpins,
          recorded_by: userValuesArray[1],
          current_status: "ACTIVE"
        };
        await ExecutePostWithParams("agreements", payload);
        showToast("Agreement saved successfully", "success");
        await fetchAgreements();
      }
      
      resetForm();
      setMainTabValue(1);
      
    } catch (error) {
      console.error("Error saving agreement:", error);
      const errorMessage = error.response?.data?.message || 
                           error.response?.data?.error || 
                           error.message || 
                           "Database error occurred";
      showToast(`Failed to ${isEditMode ? 'update' : 'save'} agreement: ${errorMessage}`, "error");
    } finally {
      setIsLoading(false);
    }
  };

  // ---------- Load initial data ----------
  useEffect(() => {
    fetchParks();
    fetchInvestors();
    fetchAgreementsForExpertEdit();
    fetchRejectedAgreements();
  }, []);

  // ---------- Sync ownership_type when agreement_type changes ----------
  useEffect(() => {
    if (formData.agreement_type) {
      let newOwnershipType = formData.ownership_type;
      if (formData.agreement_type === "Shed Land") newOwnershipType = "Shed Rent";
      else if (formData.agreement_type === "Leased Land") newOwnershipType = "Land Leased";
      else if (formData.agreement_type === "Commercial") newOwnershipType = "Commercial";
      else if (formData.agreement_type === "Residential") newOwnershipType = "Residential";
      if (newOwnershipType !== formData.ownership_type) {
        setFormData(prev => ({ ...prev, ownership_type: newOwnershipType }));
      }
    }
  }, [formData.agreement_type]);


  //**********************for Other investment tying
  useEffect(() => {
    // Only show/hide based on whether "Other" is selected
    if (formData.investment_type === "Other") {
      setShowOtherInvestment(true);
    } else {
      // Only hide if we're not editing and the value is not "Other"
      setShowOtherInvestment(false);
      // Clear the custom value when switching away from "Other"
      if (formData.investment_type !== "Other") {
        setOtherInvestmentValue("");
      }
    }
  }, [formData.investment_type]);
  //********************** */
  // ========== RENDER COMMON COMPONENTS ==========
  
  const renderAgreementTypeSelector = () => (
    <FormControl fullWidth sx={{ mb: 3 }}>
      <InputLabel id="agreement-type-label">Agreement Type</InputLabel>
      <Select
        labelId="agreement-type-label"
        name="agreement_type"
        value={formData.agreement_type || "Shed Land"}
        onChange={handleAgreementTypeChange}
        label="Agreement Type"
        disabled={isEditMode}
      >
        {agreementTypes.map(type => (
          <MenuItem key={type.id} value={type.id}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {type.icon} {type.label}
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );

  const renderParkSelector = () => (
    <FormControl fullWidth required>
      <InputLabel id="park-select-label">Select Industrial Park</InputLabel>
      <Select
        labelId="park-select-label"
        name="park_id"
        value={formData.park_id || ""}
        onChange={handleParkChange}
        label="Select Industrial Park"
        disabled={isEditMode}
      >
        <MenuItem value="">Select Park</MenuItem>
        {parks.map((park) => (
          <MenuItem key={park.id} value={park.id}>
            {park.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );

  const renderInvestorSelector = () => (
    <Grid container spacing={2}>
      <Grid item xs={9}>
        <FormControl fullWidth required>
          <InputLabel id="investor-select-label">Select Investor/Tenant</InputLabel>
          <Select
            labelId="investor-select-label"
            name="tenant_id"
            value={formData.tenant_id || ""}
            onChange={handleInvestorChange}
            label="Select Investor/Tenant"
          >
            <MenuItem value="">Select Investor</MenuItem>
            {investors.map((investor) => (
              <MenuItem key={investor.id} value={investor.id}>
                {investor.company_name || investor.name} - {investor.tin_no || ""}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={3} display="flex" alignItems="center">
        <Button 
          variant="outlined" 
          component={Link} 
          to="/registerInvestor" 
          startIcon={<AddIcon />}
          fullWidth
        >
          Register New
        </Button>
      </Grid>
    </Grid>
  );

  // ========== SHED/LAND STEP 1 ==========
  const renderShedLandStep1 = () => {
    const isShedRent = formData.agreement_type === "Shed Land";
    const isLeasedLand = formData.agreement_type === "Leased Land";
    {console.log("LANDDDDDDDDDDD", parcelInPark)}
    return (
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
                <BusinessIcon /> Step 1: Basic Information
              </Typography>
              
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  {renderParkSelector()}
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Agreement ID"
                    name="agreement_id"
                    value={formData?.agreement_id || ""}
                    onChange={handleChange}
                    InputProps={{ readOnly: true }}
                    helperText={selectedPark ? "Auto-generated" : "Select park first"}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ color: '#1976d2' }}>
                Investor Information
              </Typography>
              {renderInvestorSelector()}
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ color: '#1976d2' }}>
                {isShedRent ? "Shed Selection" : "Parcel Selection"}
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  {isShedRent ? (
                    // Shed Selection Dropdown for Shed Rent
                    // <FormControl fullWidth disabled={!selectedPark || isEditMode}>
                    //   <InputLabel id="shed-select-label">Select Shed Number</InputLabel>
                    //   <Select
                    //     labelId="shed-select-label"
                    //     value={localSelectedShedId}
                    //     onChange={(e) => handleShedSelection(e.target.value)}
                    //     label="Select Shed Number"
                    //     disabled={!selectedPark || isEditMode}
                    //   >
                    //     {shedInPark && shedInPark.length > 0 ? (
                    //       [
                    //         <MenuItem key="default" value="">-- Select Shed --</MenuItem>,
                    //         ...shedInPark.map((shed) => (
                    //           <MenuItem key={shed.shed_id} value={shed.shed_id}>
                    //             {shed.shed_number || shed.shed_id} - {shed.shed_size || 0} m²
                    //           </MenuItem>
                    //         ))
                    //       ]
                    //     ) : (
                    //       <MenuItem disabled value="no-sheds">
                    //         {selectedPark ? "No sheds available in this park" : "Select a park first"}
                    //       </MenuItem>
                    //     )}
                    //   </Select>
                    // </FormControl>
                    //*************************** */
                    // Shed Selection Dropdown for Shed Rent - MULTI SELECT
<FormControl fullWidth disabled={!selectedPark || isEditMode}>
  <InputLabel id="shed-select-label">Select Shed Number</InputLabel>
  <Select
    labelId="shed-select-label"
    multiple  // <-- ADD THIS
    value={localSelectedShedId ? [localSelectedShedId] : []}  // Convert string to array
    onChange={(e) => {
      // Get the selected values (array)
      const selectedValues = e.target.value;
      // Take only the last selected one to keep compatibility with existing code
      const lastSelected = Array.isArray(selectedValues) && selectedValues.length > 0 
        ? selectedValues[selectedValues.length - 1] 
        : "";
      handleShedSelection(lastSelected);
    }}
    label="Select Shed Number"
    disabled={!selectedPark || isEditMode}
    renderValue={(selected) => {
      // Show selected sheds as chips
      const selectedArray = Array.isArray(selected) ? selected : [selected];
      return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
          {selectedArray.filter(id => id).map((value) => {
            const shed = shedInPark?.find(s => s.shed_id === value);
            return (
              <Chip 
                key={value} 
                label={shed ? `${shed.shed_number || shed.shed_id}` : value} 
                size="small"
                onDelete={() => {
                  // Remove this shed from selection
                  const newSelected = selectedArray.filter(id => id !== value);
                  const lastRemaining = newSelected.length > 0 ? newSelected[newSelected.length - 1] : "";
                  handleShedSelection(lastRemaining);
                }}
              />
            );
          })}
        </Box>
      );
    }}
  >
    {shedInPark && shedInPark.length > 0 ? (
      shedInPark.map((shed) => (
        <MenuItem key={shed.shed_id} value={shed.shed_id}>
          {shed.shed_number || shed.shed_id} - {shed.shed_size || 0} m²
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled value="no-sheds">
        {selectedPark ? "No sheds available in this park" : "Select a park first"}
      </MenuItem>
    )}
  </Select>
</FormControl>
                  ) : (
                    // Parcel Selection Dropdown for Leased Land
                    
                  

                  <FormControl fullWidth disabled={!selectedPark || isEditMode}>
                    <InputLabel id="upin-select-label">Select Parcel (UPIN)</InputLabel>
                    <Select
                      labelId="upin-select-label"
                      value=""
                      onChange={(e) => handleParcelSelection(e.target.value)}
                      label="Select Parcel (UPIN)"
                      disabled={!selectedPark || isEditMode}
                    >
                      {parcelInPark.length > 0 ? (
                        [
                          <MenuItem key="default" value="">-- Select Parcel --</MenuItem>,
                          ...parcelInPark
                            // FILTER OUT parcels that are in the shed list
                            .filter(parcel => {
                              // Check if this parcel's upin exists in shedInPark
                              const isInShedList = shedInPark?.some(shed => shed.upin === parcel.upin);
                              return !isInShedList; // Only keep parcels NOT in shed list
                            })
                            .map((parcel) => (
                              <MenuItem key={parcel?.upin} value={parcel?.upin}>
                                {parcel?.upin}
                              </MenuItem>
                            ))
                        ]
                      ) : (
                        <MenuItem disabled value="no-parcels">
                          {selectedPark ? "No land parcels available in this park" : "Select a park first"}
                        </MenuItem>
                      )}
                    </Select>
                  </FormControl>
                  )}
                </Grid>

                <Grid item xs={12} md={6}>
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selectedUpins?.length > 0 ? (
                      selectedUpins.map(upin => (
                        <Chip
                          key={upin}
                          label={`${isShedRent ? 'UPIN: ' : ''}${upin}`}
                          onDelete={!isEditMode ? () => handleRemoveUpin(upin) : undefined}
                          color="primary"
                          variant="outlined"
                          deleteIcon={!isEditMode ? <DeleteIcon /> : undefined}
                        />
                      ))
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        {isShedRent ? "No shed selected" : "No parcels selected"}
                      </Typography>
                    )}
                  </Box>
                </Grid>
              </Grid>
              
              <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 2 }}>
                {isShedRent 
                  ? "* Select a shed to automatically assign its UPIN. Tenure Type will be set to 'Shed Rent'."
                  : "* Select land parcels to assign their UPINs. Tenure Type will be set to 'Land Leased'."}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  };

  // ========== SHED/LAND STEP 2 ==========
  // const renderShedLandStep2 = () => (
  //   <Grid container spacing={3}>
  //     <Grid item xs={12}>
  //       <Card variant="outlined">
  //         <CardContent>
  //           <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
  //             <DescriptionIcon /> Step 2: Investment & Contract Details
  //           </Typography>
            
  //           <Grid container spacing={2}>
  //             <Grid item xs={12}>
  //               <FormControl fullWidth>
  //                 <InputLabel id="investment-type-label">Investment Type</InputLabel>
  //                 <Select
  //                   labelId="investment-type-label"
  //                   name="investment_type"
  //                   value={formData.investment_type || ""}
  //                   onChange={handleChange}
  //                   label="Investment Type"
  //                 >
  //                   <MenuItem value="">Select Investment Type</MenuItem>
  //                   {investmentOptions.map(option => (
  //                     <MenuItem key={option} value={option}>{option}</MenuItem>
  //                   ))}
  //                 </Select>
  //               </FormControl>
  //             </Grid>
              
  //             <Grid item xs={12} md={6}>
  //               <TextField
  //                 fullWidth
  //                 type="date"
  //                 label="Contract Issue Date"
  //                 name="contract_issue"
  //                 value={formatDateForInput(formData.contract_issue)}
  //                 onChange={(e) => handleIssueDateChange(e.target.value)}
  //                 InputLabelProps={{ shrink: true }}
  //                 required
  //               />
  //             </Grid>
              
  //             <Grid item xs={12} md={6}>
  //               <TextField
  //                 fullWidth
  //                 type="date"
  //                 label="Contract Renewal Date"
  //                 name="contract_renewal"
  //                 value={formatDateForInput(formData.contract_renewal)}
  //                 onChange={(e) => handleRenewalDateChange(e.target.value)}
  //                 InputLabelProps={{ shrink: true }}
  //                 required
  //               />
  //             </Grid>
              
  //             <Grid item xs={12} md={6}>
  //               <TextField
  //                 fullWidth
  //                 type="number"
  //                 label="Contract Period (Months)"
  //                 name="contract_period"
  //                 value={formData.contract_period}
  //                 onChange={handleChange}
  //                 InputProps={{ readOnly: true }}
  //               />
  //             </Grid>
              
  //             <Grid item xs={12} md={6}>
  //               <TextField
  //                 fullWidth
  //                 type="date"
  //                 label="Expected Handover Date"
  //                 name="handover_date"
  //                 value={formatDateForInput(formData.handover_date)}
  //                 onChange={handleChange}
  //                 InputLabelProps={{ shrink: true }}
  //               />
  //             </Grid>
              
  //             <Grid item xs={12} md={6}>
  //               <TextField
  //                 fullWidth
  //                 type="date"
  //                 label="Expected Production Commencement Date"
  //                 name="production_commencement_date"
  //                 value={formatDateForInput(formData.production_commencement_date)}
  //                 onChange={handleChange}
  //                 InputLabelProps={{ shrink: true }}
  //               />
  //             </Grid>
  //           </Grid>
  //         </CardContent>
  //       </Card>
  //     </Grid>
  //   </Grid>
  // );
//
//***************** */ SHED/LAND STEP 2 
const renderShedLandStep2 = () => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card variant="outlined">
          <CardContent>
            <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
              <DescriptionIcon /> Step 2: Investment & Contract Details
            </Typography>
            
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={showOtherInvestment ? 6 : 12}>
                    <FormControl fullWidth>
                      <InputLabel id="investment-type-label">Investment Type</InputLabel>
                      <Select
                        labelId="investment-type-label"
                        name="investment_type"
                        value={formData.investment_type || ""}
                        onChange={handleInvestmentTypeChange}
                        label="Investment Type"
                      >
                        <MenuItem value="">Select Investment Type</MenuItem>
                        {investmentOptions.map(option => (
                          <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  {showOtherInvestment && (
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="Specify Other Investment"
                        value={otherInvestmentValue}
                        onChange={handleOtherInvestmentChange}
                        placeholder="Enter investment type..."
                        required
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  type="date"
                  label="Contract Issue Date"
                  name="contract_issue"
                  value={formatDateForInput(formData.contract_issue)}
                  onChange={(e) => handleIssueDateChange(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  required
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  type="date"
                  label="Contract Renewal Date"
                  name="contract_renewal"
                  value={formatDateForInput(formData.contract_renewal)}
                  onChange={(e) => handleRenewalDateChange(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  required
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  type="number"
                  label="Contract Period (Months)"
                  name="contract_period"
                  value={formData.contract_period}
                  onChange={handleChange}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  type="date"
                  label="Expected Handover Date"
                  name="handover_date"
                  value={formatDateForInput(formData.handover_date)}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  type="date"
                  label="Expected Production Commencement Date"
                  name="production_commencement_date"
                  value={formatDateForInput(formData.production_commencement_date)}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};
//********************************************** */
  // ========== SHED/LAND STEP 3 ==========
  const renderShedLandStep3 = () => (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card variant="outlined">
          <CardContent>
            <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
              <FactoryIcon /> Step 3: Production, Conditions and Capacity
            </Typography>
            
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  type="number"
                  label="Production Capacity (units/year)"
                  name="production_capacity"
                  value={formData.production_capacity}
                  onChange={handleChange}
                  required
                />
              </Grid>
              
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  type="number"
                  label="Export Capacity (%)"
                  name="export_capacity"
                  value={formData.export_capacity}
                  onChange={handleChange}
                  required
                />
              </Grid>
              
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  type="number"
                  label="Employment Capacity"
                  name="employee_capacity"
                  value={formData.employee_capacity}
                  onChange={handleChange}
                  required
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );

  // ========== SHED/LAND STEP 4 ==========
  const renderShedLandStep4 = () => (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card variant="outlined">
          <CardContent>
            <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
              <StoreIcon /> Step 4: Market & Disposal
            </Typography>
            
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Market Destination"
                  name="market_destination"
                  value={formData.market_destination}
                  onChange={handleChange}
                  placeholder="e.g., Domestic, Export, Europe, USA, etc."
                  required
                />
              </Grid>
              
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Link to International Brands"
                  name="intl_brands_link"
                  value={formData.intl_brands_link}
                  onChange={handleChange}
                  placeholder="e.g., Nike, Adidas, H&M, etc."
                />
              </Grid>
              
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Waste Disposal Method"
                  name="disposal_method"
                  value={formData.disposal_method}
                  onChange={handleChange}
                  placeholder="e.g., Treatment plant, Recycling, External contractor, etc."
                  required
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );

  // ========== SHED/LAND STEP 5 ==========
  const renderShedLandStep5 = () => (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card variant="outlined">
          <CardContent>
            <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
              <MoneyIcon /> Step 5: Financial & Contractual Details
            </Typography>
            
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  type="date"
                  label="Grace Period Ending Date (Rent/Lease start date)"
                  name="grace_period_ending_date"
                  value={formatDateForInput(formData.grace_period_ending_date)}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  required
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel id="payment-mode-label">Payment Method</InputLabel>
                  <Select
                    labelId="payment-mode-label"
                    name="payment_mode"
                    value={formData.payment_mode || "usd"}
                    onChange={handleChange}
                    label="Payment Method"
                  >
                    {paymentModes.map(mode => (
                      <MenuItem key={mode.id} value={mode.id}>{mode.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  type="number"
                  label={formData.agreement_type === "Shed Land" ? "Monthly Rent " : "Annual Lease Rate (USD)"}
                  name={formData.agreement_type === "Shed Land" ? "monthly_rent" : "annual_lease_rate"}
                  value={formData[formData.agreement_type === "Shed Land" ? "monthly_rent" : "annual_lease_rate"]}
                  onChange={handleChange}
                  required
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  type="number"
                  label="Area as per Contract (m²)"
                  name="area_as_per_contract_in_m2"
                  value={formData.area_as_per_contract_in_m2}
                  onChange={handleChange}
                  required
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  type="number"
                  label="Security Deposit"
                  name="security"
                  value={formData.security}
                  onChange={handleChange}
                  required
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  type="number"
                  label={formData.agreement_type === "Leased Land" ? "Advance Payment" : "Down Payment"}
                  name="advance_payment"
                  value={formData.advance_payment}
                  onChange={handleChange}
                  required
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  type="number"
                  label="Annual Management Service Fee / m²"
                  name="annual_mngmnt_service_fee"
                  value={formData.annual_mngmnt_service_fee}
                  onChange={handleChange}
                  required
                />
              </Grid>
              
              <Grid item xs={9}>
                <TextField
                  fullWidth
                  type="number"
                  label="Late Charge Fee"
                  name="late_charge_fee"
                  value={formData.late_charge_fee}
                  onChange={handleChange}
                  required
                />
              </Grid>
              
              <Grid item xs={3}>
                <FormControl fullWidth>
                  <InputLabel id="penality-rate-label">Rate</InputLabel>
                  <Select
                    labelId="penality-rate-label"
                    name="penality_rate"
                    value={formData.penality_rate || "%"}
                    onChange={handleChange}
                    label="Rate"
                  >
                    <MenuItem value="%">%</MenuItem>
                    <MenuItem value="value">Fixed</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );

  // ========== SHED/LAND STEP 6 ==========
  const renderShedLandStep6 = () => {
    const monthlyRent = parseFloat(formData.monthly_rent || formData.annual_lease_rate || 0);
    const area = parseFloat(formData.area_as_per_contract_in_m2 || 0);
    const managementFee = parseFloat(formData.annual_mngmnt_service_fee || 0);
    const annualManagementTotal = area * managementFee;
    const securityDeposit = parseFloat(formData.security || 0);
    const advancePayment = parseFloat(formData.advance_payment || 0);
    
    const getUpinDisplay = () => {
      if (Array.isArray(selectedUpins)) {
        return selectedUpins.join(', ');
      }
      return 'N/A';
    };
    
    return (
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
                <DescriptionIcon /> Step 6: Summary & Description
              </Typography>
              
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Card variant="outlined" sx={{ backgroundColor: '#f8f9fa' }}>
                    <CardContent>
                      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1976d2', mb: 2 }}>
                        Agreement Summary
                      </Typography>
                      <Table size="small">
                        <TableBody>
                          <TableRow>
                            <TableCell sx={{ border: 'none', fontWeight: 'bold' }}>Agreement ID:</TableCell>
                            <TableCell sx={{ border: 'none' }}>{formData.agreement_id || 'N/A'}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{ border: 'none', fontWeight: 'bold' }}>Park:</TableCell>
                            <TableCell sx={{ border: 'none' }}>{formData.park_name || formData.park_id}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{ border: 'none', fontWeight: 'bold' }}>Investor:</TableCell>
                            <TableCell sx={{ border: 'none' }}>{formData.investor_name || formData.tenant_id}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{ border: 'none', fontWeight: 'bold' }}>Parcel(s):</TableCell>
                            <TableCell sx={{ border: 'none' }}>{getUpinDisplay()}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{ border: 'none', fontWeight: 'bold' }}>Tenure Type:</TableCell>
                            <TableCell sx={{ border: 'none' }}>{formData.ownership_type === 'Shed Rent' ? 'Shed Rent' : 'Land Lease'}</TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </CardContent>
                  </Card>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Card variant="outlined" sx={{ backgroundColor: '#f8f9fa' }}>
                    <CardContent>
                      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1976d2', mb: 2 }}>
                        Financial Summary
                      </Typography>
                      <Table size="small">
                        <TableBody>
                          <TableRow>
                            <TableCell sx={{ border: 'none', fontWeight: 'bold' }}>
                              {formData.agreement_type === 'Shed Land' ? 'Monthly Rent:' : 'Annual Lease:'}
                            </TableCell>
                            <TableCell sx={{ border: 'none' }}>${safeToFixed(monthlyRent, 2)}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{ border: 'none', fontWeight: 'bold' }}>Area (m²):</TableCell>
                            <TableCell sx={{ border: 'none' }}>{safeToFixed(area, 2)}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{ border: 'none', fontWeight: 'bold' }}>Annual Management Fee:</TableCell>
                            <TableCell sx={{ border: 'none' }}>${safeToFixed(annualManagementTotal, 2)}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{ border: 'none', fontWeight: 'bold' }}>Security Deposit:</TableCell>
                            <TableCell sx={{ border: 'none' }}>${safeToFixed(securityDeposit, 2)}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{ border: 'none', fontWeight: 'bold' }}>Advance Payment:</TableCell>
                            <TableCell sx={{ border: 'none' }}>${safeToFixed(advancePayment, 2)}</TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </CardContent>
                  </Card>
                </Grid>
                
                <Grid item xs={12}>
                  <Card variant="outlined" sx={{ backgroundColor: '#f8f9fa' }}>
                    <CardContent>
                      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1976d2', mb: 2 }}>
                        Contract Dates
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={3}>
                          <Typography variant="caption" color="textSecondary">Issue Date</Typography>
                          <Typography variant="body2">{formData.contract_issue || 'N/A'}</Typography>
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Typography variant="caption" color="textSecondary">Renewal Date</Typography>
                          <Typography variant="body2">{formData.contract_renewal || 'N/A'}</Typography>
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Typography variant="caption" color="textSecondary">Handover Date</Typography>
                          <Typography variant="body2">{formData.handover_date || 'N/A'}</Typography>
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Typography variant="caption" color="textSecondary">Production Start</Typography>
                          <Typography variant="body2">{formData.production_commencement_date || 'N/A'}</Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Description / Notes"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    multiline
                    rows={3}
                    placeholder="Enter any additional notes or description for this agreement..."
                  />
                </Grid>
                
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    type="date"
                    label="MOU Signed On"
                    name="mou_signed"
                    value={formatDateForInput(formData.mou_signed)}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                
                <Grid item xs={12} md={8}>
                  <Box>
                    <Button variant="outlined" component="label" startIcon={<UploadIcon />}>
                      {formData.mou_attachment ? "Change File" : "Upload MOU Attachment"}
                      <input type="file" hidden onChange={handleFileChange} />
                    </Button>
                    {formData.mou_attachment && (
                      <Chip 
                        label={typeof formData.mou_attachment === 'string' ? formData.mou_attachment.split('/').pop() : formData.mou_attachment.name || "Attachment"}
                        sx={{ ml: 2 }} 
                        onDelete={handleRemoveFile}
                        deleteIcon={<CloseIcon />}
                      />
                    )}
                  </Box>
                  {formData.mou_attachment && typeof formData.mou_attachment === 'string' && (
                    <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 1 }}>
                      Current file: {formData.mou_attachment.split('/').pop()}
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  };

  // ========== RENDER SHED/LAND WIZARD ==========
  const renderShedLandWizard = () => {
    const steps = shedLandSteps;
    
    return (
      <Box sx={{ width: '100%' }}>
        <Stepper activeStep={shedLandStep} alternativeLabel sx={{ mb: 4 }}>
          {steps.map((label, index) => (
            <Step key={index}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        
        <Card variant="outlined" sx={{ p: 3, mb: 3 }}>
          {shedLandStep === 0 && renderShedLandStep1()}
          {shedLandStep === 1 && renderShedLandStep2()}
          {shedLandStep === 2 && renderShedLandStep3()}
          {shedLandStep === 3 && renderShedLandStep4()}
          {shedLandStep === 4 && renderShedLandStep5()}
          {shedLandStep === 5 && renderShedLandStep6()}
          
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
            <Button
              variant="contained"
              onClick={handleShedLandPrevStep}
              disabled={shedLandStep === 0}
            >
              Previous
            </Button>
            
            {shedLandStep === steps.length - 1 ? (
              <Button
                variant="contained"
                color="primary"
                onClick={handleSaveAgreement}
                disabled={isLoading}
                startIcon={<SaveIcon />}
              >
                {isLoading ? <CircularProgress size={24} /> : (isEditMode ? 'Update Agreement' : 'Save Agreement')}
              </Button>
            ) : (
              <Button
                variant="contained"
                onClick={handleShedLandNextStep}
              >
                Next
              </Button>
            )}
          </Box>
        </Card>
      </Box>
    );
  };

  // ========== RESIDENTIAL STEP 1 ==========
  const renderResidentialStep1 = () => {
    const currencySymbol = residentialCurrency === "usd" ? "$" : "ETB";
    
    return (
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
                <ApartmentIcon /> Step 1: Location & Room Information
              </Typography>
              
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  {renderParkSelector()}
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Agreement ID"
                    name="agreement_id"
                    value={formData.agreement_id}
                    onChange={handleChange}
                    InputProps={{ readOnly: true }}
                    helperText={selectedPark ? "Auto-generated" : "Select park first"}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ color: '#1976d2' }}>
                Investor / Tenant Information
              </Typography>
              {renderInvestorSelector()}
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
                <MeetingRoomIcon /> Room Configuration
              </Typography>
              
              {/* Currency Selection */}
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <InputLabel id="residential-currency-label">Payment Currency</InputLabel>
                    <Select
                      labelId="residential-currency-label"
                      value={residentialCurrency}
                      onChange={(e) => {
                        const newCurrency = e.target.value;
                        setResidentialCurrency(newCurrency);
                        setFormData(prev => ({ ...prev, payment_mode: newCurrency }));
                      }}
                      label="Payment Currency"
                    >
                      {currencyTypes.map(currency => (
                        <MenuItem key={currency.id} value={currency.id}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            {currency.symbol} {currency.label}
                          </Box>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              
              <TableContainer component={Paper} sx={{ mb: 2 }}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                      <TableCell>Room Type</TableCell>
                      <TableCell align="center">Room Number</TableCell>
                      <TableCell align="center">No. of Rooms</TableCell>
                      <TableCell align="center">Area (m²)</TableCell>
                      <TableCell align="center">Total m²</TableCell>
                      <TableCell align="center">
                        Price/m² ({currencySymbol})
                      </TableCell>
                      <TableCell align="center">
                        Monthly Rent ({currencySymbol})
                      </TableCell>
                      <TableCell align="center">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {formData.room_details?.length > 0 ? (
                      formData.room_details.map((room, idx) => (
                        <TableRow key={idx}>
                          <TableCell>{room.type}</TableCell>
                          <TableCell align="center">{room.room_number || '-'}</TableCell>
                          <TableCell align="center">{room.count}</TableCell>
                          <TableCell align="center">{safeToFixed(room.area, 2)}</TableCell>
                          <TableCell align="center">{safeToFixed(room.totalArea, 2)}</TableCell>
                          <TableCell align="center">
                            {currencySymbol}{safeToFixed(room.pricePerSqm, 2)}
                          </TableCell>
                          <TableCell align="center">
                            {currencySymbol}{safeToFixed(room.monthlyRent, 2)}
                          </TableCell>
                          <TableCell align="center">
                            <IconButton size="small" onClick={() => handleEditRoom(idx)} color="primary">
                              <EditIcon />
                            </IconButton>
                            <IconButton size="small" onClick={() => handleRemoveRoom(idx)} color="error">
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={8} align="center" sx={{ py: 3 }}>
                          <Typography color="textSecondary">No rooms added. Click "Add Room" to configure.</Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={() => {
                  setEditingRoomIndex(null);
                  setNewRoom({
                    type: "family",
                    count: 1,
                    area: 73.44,
                    pricePerSqm: 14.24,
                    room_number: ""
                  });
                  setRoomDialogOpen(true);
                }}
                sx={{ mb: 2 }}
              >
                Add Room
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  };

  // ========== RESIDENTIAL STEP 2 ==========
  const renderResidentialStep2 = () => {
    const currencySymbol = residentialCurrency === "usd" ? "$" : "ETB";
    
    return (
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
                <MoneyIcon /> Step 2: Financial Details
              </Typography>
              
              <Paper sx={{ p: 2, backgroundColor: '#e3f2fd', mb: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2" color="textSecondary">
                      Total Monthly Rent ({currencySymbol})
                    </Typography>
                    <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                      {currencySymbol}{safeToFixed(formData.monthly_rent || 0, 2)}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      type="number"
                      label="Advance Months"
                      name="advance_months"
                      value={formData.advance_months || 3}
                      onChange={handleAdvanceMonthsChange}
                      size="small"
                      InputProps={{ inputProps: { min: 1, max: 12 } }}
                      sx={{ width: '100%' }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2" color="textSecondary">
                      Advance Payment Total ({currencySymbol})
                    </Typography>
                    <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                      {currencySymbol}{safeToFixed(formData.advance_payment || 0, 2)}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      {formData.advance_months || 3} months advance
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>

              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    type="number"
                    label={`Security Deposit (${currencySymbol})`}
                    name="security"
                    value={formData.security || 0}
                    onChange={handleChange}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ color: '#1976d2' }}>
                Contract Dates
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    type="date"
                    label="Contract Start Date"
                    name="contract_issue"
                    value={formatDateForInput(formData.contract_issue)}
                    onChange={(e) => handleIssueDateChange(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    type="date"
                    label="Contract End Date"
                    name="contract_renewal"
                    value={formatDateForInput(formData.contract_renewal)}
                    onChange={(e) => handleRenewalDateChange(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    type="date"
                    label="Handover Date"
                    name="handover_date"
                    value={formatDateForInput(formData.handover_date)}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ color: '#1976d2' }}>
                Additional Information
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Button variant="outlined" component="label" startIcon={<UploadIcon />}>
                    {formData.mou_attachment ? "Change File" : "Upload Attachment"}
                    <input type="file" hidden onChange={handleFileChange} />
                  </Button>
                  {formData.mou_attachment && (
                    <Chip 
                      label={typeof formData.mou_attachment === 'string' ? formData.mou_attachment.split('/').pop() : formData.mou_attachment.name || "Attachment"}
                      sx={{ ml: 2 }} 
                      onDelete={handleRemoveFile}
                      deleteIcon={<CloseIcon />}
                    />
                  )}
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Description / Notes"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    multiline
                    rows={2}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  };

  // ========== RENDER RESIDENTIAL WIZARD ==========
  const renderResidentialWizard = () => {
    const steps = residentialSteps;
    
    return (
      <Box sx={{ width: '100%' }}>
        <Stepper activeStep={residentialStep} alternativeLabel sx={{ mb: 4 }}>
          {steps.map((label, index) => (
            <Step key={index}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        
        <Card variant="outlined" sx={{ p: 3, mb: 3 }}>
          {residentialStep === 0 && renderResidentialStep1()}
          {residentialStep === 1 && renderResidentialStep2()}
          
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
            <Button
              variant="contained"
              onClick={handleResidentialPrevStep}
              disabled={residentialStep === 0}
            >
              Previous
            </Button>
            
            {residentialStep === steps.length - 1 ? (
              <Button
                variant="contained"
                color="primary"
                onClick={handleSaveAgreement}
                disabled={isLoading}
                startIcon={<SaveIcon />}
              >
                {isLoading ? <CircularProgress size={24} /> : (isEditMode ? 'Update Agreement' : 'Save Agreement')}
              </Button>
            ) : (
              <Button
                variant="contained"
                onClick={handleResidentialNextStep}
              >
                Next
              </Button>
            )}
          </Box>
        </Card>
      </Box>
    );
  };

  // ========== COMMERCIAL STEP 1 ==========
  const renderCommercialStep1 = () => {
    const currencySymbol = commercialCurrency === "usd" ? "$" : "ETB";
    
    return (
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
                <StoreIcon /> Step 1: Service & Location Information
              </Typography>
              
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  {renderParkSelector()}
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Agreement ID"
                    name="agreement_id"
                    value={formData.agreement_id}
                    onChange={handleChange}
                    InputProps={{ readOnly: true }}
                    helperText={selectedPark ? "Auto-generated" : "Select park first"}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ color: '#1976d2' }}>
                Investor / Tenant Information
              </Typography>
              {renderInvestorSelector()}
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ color: '#1976d2' }}>
                Service Details
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl fullWidth required>
                    <InputLabel id="service-type-label">Service Type</InputLabel>
                    <Select
                      labelId="service-type-label"
                      name="service_type"
                      value={formData.service_type || ""}
                      onChange={handleChange}
                      label="Service Type"
                    >
                      <MenuItem value="">Select Service Type</MenuItem>
                      {serviceTypes.map(type => (
                        <MenuItem key={type} value={type}>{type}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
                <ShopIcon /> Shop/Room Configuration
              </Typography>
              
              {/* Currency Selection for Commercial */}
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <InputLabel id="commercial-currency-label">Payment Currency</InputLabel>
                    <Select
                      labelId="commercial-currency-label"
                      value={commercialCurrency}
                      onChange={(e) => {
                        const newCurrency = e.target.value;
                        setCommercialCurrency(newCurrency);
                        setFormData(prev => ({ ...prev, payment_mode: newCurrency }));
                      }}
                      label="Payment Currency"
                    >
                      {currencyTypes.map(currency => (
                        <MenuItem key={currency.id} value={currency.id}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            {currency.symbol} {currency.label}
                          </Box>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              
              <TableContainer component={Paper} sx={{ mb: 2 }}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                      <TableCell>Building No.</TableCell>
                      <TableCell>Shop/Room No.</TableCell>
                      <TableCell align="center">Area (m²)</TableCell>
                      <TableCell align="center">Monthly Rent ({currencySymbol})</TableCell>
                      <TableCell>Description</TableCell>
                      <TableCell align="center">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {formData.shop_details && formData.shop_details.length > 0 ? (
                      formData.shop_details.map((shop, idx) => {
                        const areaSqm = typeof shop.area_sqm === 'number' ? shop.area_sqm : parseFloat(shop.area_sqm) || 0;
                        const monthlyRent = typeof shop.monthly_rent === 'number' ? shop.monthly_rent : parseFloat(shop.monthly_rent) || 0;
                        const buildingNumber = shop.building_number || '';
                        const shopNumber = shop.shop_number || '';
                        const description = shop.description || '';
                        
                        return (
                          <TableRow key={idx}>
                            <TableCell>{buildingNumber || '-'}</TableCell>
                            <TableCell>{shopNumber || '-'}</TableCell>
                            <TableCell align="center">{safeToFixed(areaSqm, 2)}</TableCell>
                            <TableCell align="center">{currencySymbol}{safeToFixed(monthlyRent, 2)}</TableCell>
                            <TableCell>{description || '-'}</TableCell>
                            <TableCell align="center">
                              <IconButton size="small" onClick={() => handleEditShop(idx)} color="primary">
                                <EditIcon />
                              </IconButton>
                              <IconButton size="small" onClick={() => handleRemoveShop(idx)} color="error">
                                <DeleteIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      })
                    ) : (
                      <TableRow>
                        <TableCell colSpan={6} align="center" sx={{ py: 3 }}>
                          <Typography color="textSecondary">No shops/rooms added. Click "Add Shop/Room" to configure.</Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={() => {
                  setEditingShopIndex(null);
                  setNewShop({
                    building_number: "",
                    shop_number: "",
                    area_sqm: 0,
                    monthly_rent: 0,
                    description: ""
                  });
                  setShopDialogOpen(true);
                }}
                sx={{ mb: 2 }}
              >
                Add Shop/Room
              </Button>

              {formData.shop_details && formData.shop_details.length > 0 && (
                <Paper sx={{ p: 2, backgroundColor: '#e3f2fd', mt: 2 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" color="textSecondary">
                        Total Monthly Rent ({currencySymbol})
                      </Typography>
                      <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                        {currencySymbol}{safeToFixed(formData.monthly_rent || 0, 2)}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" color="textSecondary">
                        Total Area
                      </Typography>
                      <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                        {safeToFixed(formData.total_area_sqm || 0, 2)} m²
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  };

  // ========== COMMERCIAL STEP 2 ==========
  const renderCommercialStep2 = () => {
    const currencySymbol = commercialCurrency === "usd" ? "$" : "ETB";
    const totalMonthlyRent = parseFloat(formData.monthly_rent) || 0;
    const totalArea = parseFloat(formData.total_area_sqm) || 0;
    const averageRate = totalArea > 0 ? totalMonthlyRent / totalArea : 0;
    
    return (
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', display: 'flex', alignItems: 'center', gap: 1 }}>
                <MoneyIcon /> Step 2: Financial Details
              </Typography>
              
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    type="number"
                    label={`Monthly Rent (${currencySymbol})`}
                    name="monthly_rent"
                    value={formData.monthly_rent || 0}
                    InputProps={{ readOnly: true }}
                    helperText="Auto-calculated from shop/room totals"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    type="number"
                    label={`Security Deposit (${currencySymbol})`}
                    name="security"
                    value={formData.security || 0}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    type="number"
                    label={`Advance Payment (${currencySymbol})`}
                    name="advance_payment"
                    value={formData.advance_payment || 0}
                    onChange={handleChange}
                  />
                </Grid>
              </Grid>

              <Paper sx={{ p: 2, backgroundColor: '#e3f2fd', mt: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2" color="textSecondary">
                      Total Monthly Rent ({currencySymbol})
                    </Typography>
                    <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                      {currencySymbol}{safeToFixed(totalMonthlyRent, 2)}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2" color="textSecondary">
                      Total Area
                    </Typography>
                    <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                      {safeToFixed(totalArea, 2)} m²
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2" color="textSecondary">
                      Average Rate per m² ({currencySymbol})
                    </Typography>
                    <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                      {currencySymbol}{safeToFixed(averageRate, 2)} / m²
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ color: '#1976d2' }}>
                Contract Dates
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    type="date"
                    label="Contract Start Date"
                    name="contract_issue"
                    value={formatDateForInput(formData.contract_issue)}
                    onChange={(e) => handleIssueDateChange(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    required
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    type="date"
                    label="Contract End Date"
                    name="contract_renewal"
                    value={formatDateForInput(formData.contract_renewal)}
                    onChange={(e) => handleRenewalDateChange(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    required
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    type="date"
                    label="Handover Date"
                    name="handover_date"
                    value={formatDateForInput(formData.handover_date)}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ color: '#1976d2' }}>
                Additional Information
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Button variant="outlined" component="label" startIcon={<UploadIcon />}>
                    {formData.mou_attachment ? "Change File" : "Upload Attachment"}
                    <input type="file" hidden onChange={handleFileChange} />
                  </Button>
                  {formData.mou_attachment && (
                    <Chip 
                      label={typeof formData.mou_attachment === 'string' ? formData.mou_attachment.split('/').pop() : formData.mou_attachment.name || "Attachment"}
                      sx={{ ml: 2 }} 
                      onDelete={handleRemoveFile}
                      deleteIcon={<CloseIcon />}
                    />
                  )}
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Description / Notes"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    multiline
                    rows={2}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  };

  // ========== RENDER COMMERCIAL WIZARD ==========
  const renderCommercialWizard = () => {
    const steps = commercialSteps;
    
    return (
      <Box sx={{ width: '100%' }}>
        <Stepper activeStep={commercialStep} alternativeLabel sx={{ mb: 4 }}>
          {steps.map((label, index) => (
            <Step key={index}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        
        <Card variant="outlined" sx={{ p: 3, mb: 3 }}>
          {commercialStep === 0 && renderCommercialStep1()}
          {commercialStep === 1 && renderCommercialStep2()}
          
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
            <Button
              variant="contained"
              onClick={handleCommercialPrevStep}
              disabled={commercialStep === 0}
            >
              Previous
            </Button>
            
            {commercialStep === steps.length - 1 ? (
              <Button
                variant="contained"
                color="primary"
                onClick={handleSaveAgreement}
                disabled={isLoading}
                startIcon={<SaveIcon />}
              >
                {isLoading ? <CircularProgress size={24} /> : (isEditMode ? 'Update Agreement' : 'Save Agreement')}
              </Button>
            ) : (
              <Button
                variant="contained"
                onClick={handleCommercialNextStep}
              >
                Next
              </Button>
            )}
          </Box>
        </Card>
      </Box>
    );
  };

  // ========== ROOM DIALOG ==========
  const renderRoomDialog = () => {
    const currencySymbol = residentialCurrency === "usd" ? "$" : "ETB";
    
    const validateAndAddRoom = () => {
      if (!newRoom.room_number || newRoom.room_number.trim() === "") {
        setRoomNumberError(true);
        showToast("Please enter room number", "warning");
        return;
      }
      handleAddRoom();
      setRoomNumberError(false);
    };
    
    return (
      <Dialog open={roomDialogOpen} onClose={() => {
        setRoomDialogOpen(false);
        setRoomNumberError(false);
        setEditingRoomIndex(null);
      }} maxWidth="sm" fullWidth>
        <DialogTitle>{editingRoomIndex !== null ? "Edit Room Configuration" : "Add Room Configuration"}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Room Type</InputLabel>
                <Select
                  value={newRoom.type}
                  onChange={(e) => {
                    const type = e.target.value;
                    const roomType = roomTypes.find(r => r.id === type);
                    setNewRoom({
                      ...newRoom,
                      type: type,
                      area: roomType?.defaultArea || 0,
                      pricePerSqm: roomType?.defaultPrice || 14.24
                    });
                  }}
                  label="Room Type"
                >
                  {roomTypes.map(room => (
                    <MenuItem key={room.id} value={room.id}>{room.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                required
                label="Room Number"
                value={newRoom.room_number}
                onChange={(e) => {
                  setNewRoom({...newRoom, room_number: e.target.value});
                  setRoomNumberError(false);
                }}
                error={roomNumberError}
                helperText={roomNumberError ? "Room number is required" : "Enter room number (e.g., 101, 102)"}
                placeholder="e.g. 101"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                type="number"
                label="Number of Rooms"
                value={newRoom.count}
                onChange={(e) => setNewRoom({...newRoom, count: parseInt(e.target.value) || 1})}
                inputProps={{ min: 1 }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                type="number"
                label="Area per Room (m²)"
                value={newRoom.area}
                onChange={(e) => setNewRoom({...newRoom, area: parseFloat(e.target.value) || 0})}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                type="number"
                label={`Price per m² (${currencySymbol})`}
                value={newRoom.pricePerSqm}
                onChange={(e) => setNewRoom({...newRoom, pricePerSqm: parseFloat(e.target.value) || 0})}
                InputProps={{ startAdornment: currencySymbol }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Paper sx={{ p: 2, backgroundColor: '#e3f2fd', height: '100%' }}>
                <Typography variant="subtitle2" color="textSecondary">
                  Monthly Rent ({currencySymbol})
                </Typography>
                <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                  {currencySymbol}{safeToFixed(((newRoom.count || 0) * (newRoom.area || 0) * (newRoom.pricePerSqm || 0)), 2)}
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setRoomDialogOpen(false);
            setRoomNumberError(false);
            setEditingRoomIndex(null);
          }}>Cancel</Button>
          <Button onClick={validateAndAddRoom} variant="contained">
            {editingRoomIndex !== null ? "Update Room" : "Add Room"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  // ========== SHOP DIALOG ==========
  const renderShopDialog = () => {
    const currencySymbol = commercialCurrency === "usd" ? "$" : "ETB";
    
    const validateAndAddShop = () => {
      const errors = {
        building_number: !newShop.building_number || newShop.building_number.trim() === "",
        shop_number: !newShop.shop_number || newShop.shop_number.trim() === "",
        area_sqm: !newShop.area_sqm || newShop.area_sqm <= 0,
        monthly_rent: !newShop.monthly_rent || newShop.monthly_rent <= 0
      };
      
      setShopErrors(errors);
      
      if (errors.building_number || errors.shop_number || errors.area_sqm || errors.monthly_rent) {
        showToast("Please fill all required fields correctly", "warning");
        return;
      }
      
      handleAddShop();
    };
    
    return (
      <Dialog open={shopDialogOpen} onClose={() => {
        setShopDialogOpen(false);
        setShopErrors({
          building_number: false,
          shop_number: false,
          area_sqm: false,
          monthly_rent: false
        });
        setEditingShopIndex(null);
      }} maxWidth="sm" fullWidth>
        <DialogTitle>{editingShopIndex !== null ? "Edit Shop/Room" : "Add Shop/Room"}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                label="Building Number"
                value={newShop.building_number}
                onChange={(e) => {
                  setNewShop({...newShop, building_number: e.target.value});
                  setShopErrors({...shopErrors, building_number: false});
                }}
                error={shopErrors.building_number}
                helperText={shopErrors.building_number ? "Building number is required" : ""}
                placeholder="e.g., BLD-001"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                label="Shop/Room Number"
                value={newShop.shop_number}
                onChange={(e) => {
                  setNewShop({...newShop, shop_number: e.target.value});
                  setShopErrors({...shopErrors, shop_number: false});
                }}
                error={shopErrors.shop_number}
                helperText={shopErrors.shop_number ? "Shop/Room number is required" : ""}
                placeholder="e.g., SHOP-101"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                type="number"
                label="Area (m²)"
                value={newShop.area_sqm}
                onChange={(e) => {
                  setNewShop({...newShop, area_sqm: parseFloat(e.target.value) || 0});
                  setShopErrors({...shopErrors, area_sqm: false});
                }}
                error={shopErrors.area_sqm}
                helperText={shopErrors.area_sqm ? "Area is required and must be greater than 0" : ""}
                inputProps={{ min: 0.01, step: 0.01 }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                type="number"
                label={`Monthly Rent (${currencySymbol})`}
                value={newShop.monthly_rent}
                onChange={(e) => {
                  setNewShop({...newShop, monthly_rent: parseFloat(e.target.value) || 0});
                  setShopErrors({...shopErrors, monthly_rent: false});
                }}
                error={shopErrors.monthly_rent}
                helperText={shopErrors.monthly_rent ? "Monthly rent is required and must be greater than 0" : ""}
                InputProps={{ startAdornment: currencySymbol }}
                inputProps={{ min: 0.01, step: 0.01 }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Description (Optional)"
                value={newShop.description}
                onChange={(e) => setNewShop({...newShop, description: e.target.value})}
                multiline
                rows={2}
                placeholder="Additional details about this shop/room"
              />
            </Grid>
            {newShop.area_sqm > 0 && newShop.monthly_rent > 0 && (
              <Grid item xs={12}>
                <Paper sx={{ p: 2, backgroundColor: '#e3f2fd' }}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Rate per m² ({currencySymbol})
                  </Typography>
                  <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                    {currencySymbol}{safeToFixed((newShop.monthly_rent / newShop.area_sqm), 2)} / m²
                  </Typography>
                </Paper>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setShopDialogOpen(false);
            setShopErrors({
              building_number: false,
              shop_number: false,
              area_sqm: false,
              monthly_rent: false
            });
            setEditingShopIndex(null);
          }}>Cancel</Button>
          <Button onClick={validateAndAddShop} variant="contained">
            {editingShopIndex !== null ? "Update Shop/Room" : "Add Shop/Room"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  // ========== VIEW DETAILS DIALOG ==========
  const renderViewDetailsDialog = () => {
    if (!viewingAgreement) return null;
    
    return (
      <Dialog open={viewDialogOpen} onClose={() => setViewDialogOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography variant="h6">Agreement Details</Typography>
            <Typography variant="subtitle2" color="textSecondary">ID: {viewingAgreement.agreement_id || viewingAgreement.id}</Typography>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}><Typography variant="subtitle2" color="primary">Agreement ID</Typography><Typography variant="body2">{viewingAgreement.agreement_id || viewingAgreement.id || '-'}</Typography></Grid>
            <Grid item xs={12} md={6}><Typography variant="subtitle2" color="primary">Ownership Type</Typography><Typography variant="body2">{viewingAgreement.ownership_type || '-'}</Typography></Grid>
            <Grid item xs={12} md={6}><Typography variant="subtitle2" color="primary">Investment Type</Typography><Typography variant="body2">{viewingAgreement.investment_type || '-'}</Typography></Grid>
            <Grid item xs={12} md={6}><Typography variant="subtitle2" color="primary">Park ID</Typography><Typography variant="body2">{viewingAgreement.park_id || '-'}</Typography></Grid>
            <Grid item xs={12} md={6}><Typography variant="subtitle2" color="primary">Tenant ID</Typography><Typography variant="body2">{viewingAgreement.tenant_id || '-'}</Typography></Grid>
            <Grid item xs={12}><Typography variant="subtitle2" color="primary">UPIN(s)</Typography><Typography variant="body2">{Array.isArray(viewingAgreement.upin) ? viewingAgreement.upin.join(', ') : viewingAgreement.upin || '-'}</Typography></Grid>
            <Grid item xs={12} md={6}><Typography variant="subtitle2" color="primary">Contract Issued On</Typography><Typography variant="body2">{viewingAgreement.contract_issued_on || viewingAgreement.contract_issue || '-'}</Typography></Grid>
            <Grid item xs={12} md={6}><Typography variant="subtitle2" color="primary">Contract Renewal Date</Typography><Typography variant="body2">{viewingAgreement.contract_renewal_date || viewingAgreement.contract_renewal || '-'}</Typography></Grid>
            <Grid item xs={12} md={6}><Typography variant="subtitle2" color="primary">Contract Period (Months)</Typography><Typography variant="body2">{viewingAgreement.contract_period_in_months || viewingAgreement.contract_period || '-'}</Typography></Grid>
            <Grid item xs={12} md={6}><Typography variant="subtitle2" color="primary">Handover Date</Typography><Typography variant="body2">{viewingAgreement.handover_date || '-'}</Typography></Grid>
            <Grid item xs={12}><Typography variant="subtitle2" color="primary">Market Destination</Typography><Typography variant="body2">{viewingAgreement.market_destination || '-'}</Typography></Grid>
            <Grid item xs={12}><Typography variant="subtitle2" color="primary">International Brands Link</Typography><Typography variant="body2">{viewingAgreement.intl_brands_link || '-'}</Typography></Grid>
            <Grid item xs={12}><Typography variant="subtitle2" color="primary">Disposal Method</Typography><Typography variant="body2">{viewingAgreement.disposal_method || '-'}</Typography></Grid>
            <Grid item xs={12} md={4}><Typography variant="subtitle2" color="primary">Production Capacity</Typography><Typography variant="body2">{viewingAgreement.production_capacity || '-'}</Typography></Grid>
            <Grid item xs={12} md={4}><Typography variant="subtitle2" color="primary">Export Capacity (%)</Typography><Typography variant="body2">{viewingAgreement.export_capacity || '-'}</Typography></Grid>
            <Grid item xs={12} md={4}><Typography variant="subtitle2" color="primary">Employee Capacity</Typography><Typography variant="body2">{viewingAgreement.employee_capacity || '-'}</Typography></Grid>
            <Grid item xs={12} md={4}><Typography variant="subtitle2" color="primary">Monthly Rent</Typography><Typography variant="body2">${safeToFixed(viewingAgreement.monthly_rent || 0, 2)}</Typography></Grid>
            <Grid item xs={12} md={4}><Typography variant="subtitle2" color="primary">Grace Period Ending Date</Typography><Typography variant="body2">{viewingAgreement.grace_period_ending_date || '-'}</Typography></Grid>
            <Grid item xs={12} md={4}><Typography variant="subtitle2" color="primary">Security Deposit</Typography><Typography variant="body2">${safeToFixed(viewingAgreement.security || 0, 2)}</Typography></Grid>
            <Grid item xs={12} md={4}><Typography variant="subtitle2" color="primary">Advance Payment</Typography><Typography variant="body2">${safeToFixed(viewingAgreement.advance_payment || 0, 2)}</Typography></Grid>
            <Grid item xs={12} md={4}><Typography variant="subtitle2" color="primary">Annual Management Service Fee</Typography><Typography variant="body2">${safeToFixed(viewingAgreement.annual_mngmnt_service_fee || 0, 2)}</Typography></Grid>
            <Grid item xs={12} md={4}><Typography variant="subtitle2" color="primary">Payment Mode</Typography><Typography variant="body2">{viewingAgreement.payment_mode || '-'}</Typography></Grid>
            <Grid item xs={12}><Typography variant="subtitle2" color="primary">Description</Typography><Typography variant="body2">{viewingAgreement.description || '-'}</Typography></Grid>
            <Grid item xs={12}><Typography variant="subtitle2" color="primary">Status</Typography><Chip label={viewingAgreement.status || viewingAgreement.current_status || 'PENDING'} color={(viewingAgreement.status === 'active') ? 'success' : 'default'} size="small" /></Grid>
          </Grid>
        </DialogContent>
        <DialogActions><Button onClick={() => setViewDialogOpen(false)} variant="contained">Close</Button></DialogActions>
      </Dialog>
    );
  };

  // ========== TAB 0: EDIT AGREEMENT ==========
  const renderEditTab = () => (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
          {isEditMode ? "Edit Agreement" : "Register New Agreement"}
        </Typography>
        {isEditMode && (
          <Button variant="outlined" color="error" onClick={handleCancelEdit} startIcon={<CancelIcon />}>
            Cancel Edit
          </Button>
        )}
      </Box>

      {renderAgreementTypeSelector()}

      {(formData.agreement_type === "Shed Land" || formData.agreement_type === "Leased Land") && renderShedLandWizard()}
      {formData.agreement_type === "Residential" && renderResidentialWizard()}
      {formData.agreement_type === "Commercial" && renderCommercialWizard()}
    </Box>
  );

  // ========== TAB 1: SEARCH / VIEW ==========
  const renderSearchTab = () => {
    const currentAgreements = filterType === "expert_edit" ? expertEditAgreements : agreements;
    const isLoading = filterType === "expert_edit" ? loadingExpertEdit : loadingAgreements;
    
    const getFilteredAgreements = () => {
      let filtered = [...currentAgreements];
      
      if (filterType === "expert_edit") {
        if (searchQuery) {
          const searchLower = searchQuery.toLowerCase();
          filtered = filtered.filter(agreement =>
            (agreement.agreement_id || agreement.id || "").toLowerCase().includes(searchLower) ||
            (agreement.tenant_id || "").toLowerCase().includes(searchLower) ||
            (agreement.investor_name || "").toLowerCase().includes(searchLower) ||
            (agreement.park_id || "").toLowerCase().includes(searchLower)
          );
        }
        return filtered;
      }
      
      if (filterType !== "all") {
        filtered = filtered.filter(agreement => {
          const agreementType = agreement.agreement_type || agreement.ownership_type;
          
          switch(filterType) {
            case "shed":
              return agreementType === 'Shed Land' || agreementType === 'Shed Rent' || 
                     agreement.ownership_type === 'Shed Rent';
            case "leased":
              return agreementType === 'Leased Land' || agreementType === 'Land Leased' ||
                     agreement.ownership_type === 'Land Leased';
            case "commercial":
              return agreementType === 'Commercial' || agreementType === 'commercial' ||
                     agreement.ownership_type === 'Commercial';
            case "residential":
              return agreementType === 'Residential' || agreementType === 'residential' ||
                     agreement.ownership_type === 'Residential';
            default:
              return true;
          }
        });
      }
      
      if (searchQuery) {
        const searchLower = searchQuery.toLowerCase();
        filtered = filtered.filter(agreement =>
          (agreement.agreement_id || agreement.id || "").toLowerCase().includes(searchLower) ||
          (agreement.tenant_id || "").toLowerCase().includes(searchLower) ||
          (agreement.investor_name || "").toLowerCase().includes(searchLower) ||
          (agreement.park_id || "").toLowerCase().includes(searchLower)
        );
      }
      
      return filtered;
    };
    
    const filteredAgreements = getFilteredAgreements();

    return (
      <Box>
        <Typography variant="h5" sx={{ color: '#1976d2', fontWeight: 'bold', mb: 3 }}>
          Search & View Agreements
        </Typography>
        
        <Paper sx={{ p: 3, mb: 3 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={2}>
              <FormControl fullWidth size="small">
                <InputLabel id="filter-type-label">Agreement Type</InputLabel>
                <Select
                  labelId="filter-type-label"
                  value={filterType}
                  onChange={(e) => {
                    setFilterType(e.target.value);
                    setPage(0);
                    if (e.target.value === "expert_edit") {
                      fetchAgreementsForExpertEdit();
                    }
                  }}
                  label="Agreement Type"
                >
                  <MenuItem value="expert_edit">Pending Verification (Requested/pending_verification)</MenuItem>
                  <MenuItem value="all">All Active Agreements</MenuItem>
                  <MenuItem value="shed">Shed Rental</MenuItem>
                  <MenuItem value="leased">Leased Land</MenuItem>
                  <MenuItem value="commercial">Commercial / One Stop Services</MenuItem>
                  <MenuItem value="residential">Residential</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={8}>
              <TextField
                fullWidth
                size="small"
                label="Search by ID, Tenant, Investor, UPIN, Park"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1, color: 'action.active' }} /> }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Stack direction="row" spacing={1}>
                <Button 
                  fullWidth 
                  variant="contained" 
                  onClick={() => {
                    if (filterType === "expert_edit") {
                      fetchAgreementsForExpertEdit();
                    } else {
                      fetchAgreements();
                    }
                  }}
                  disabled={isLoading}
                >
                  {isLoading ? <CircularProgress size={24} /> : "Search"}
                </Button>
                <Button 
                  variant="outlined" 
                  startIcon={<RefreshIcon />} 
                  onClick={() => { 
                    setSearchQuery(""); 
                    if (filterType === "expert_edit") {
                      fetchAgreementsForExpertEdit();
                    } else {
                      fetchAgreements();
                    }
                  }}
                >
                  Reset
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Paper>

        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="body2" color="textSecondary">
            Total Agreements: {filteredAgreements.length}
          </Typography>
          <Button 
            size="small" 
            startIcon={<RefreshIcon />} 
            onClick={() => {
              if (filterType === "expert_edit") {
                fetchAgreementsForExpertEdit();
              } else {
                fetchAgreements();
              }
            }}
            disabled={isLoading}
          >
            Refresh
          </Button>
        </Box>

        <Paper sx={{ width: '100%', overflow: 'auto' }}>
          <TableContainer sx={{ maxHeight: 600, minWidth: 1200 }}>
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                  <TableCell sx={{ fontWeight: 'bold', minWidth: 120 }}>ID</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Ownership Type</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Park ID</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', minWidth: 150 }}>Investor Name</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Contract Issued</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Contract Renewal</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Monthly Rent</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Status</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', minWidth: 120 }} align="center">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center" sx={{ py: 5 }}>
                      <CircularProgress />
                      <Typography variant="body2" sx={{ mt: 1 }}>Loading...</Typography>
                    </TableCell>
                  </TableRow>
                ) : filteredAgreements.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center" sx={{ py: 5 }}>
                      <Typography color="textSecondary">No agreements found</Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredAgreements
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((agreement) => (
                      <TableRow key={agreement.id || agreement.agreement_id} hover>
                        <TableCell>{agreement.agreement_id || agreement.id || '-'}</TableCell>
                        <TableCell>
                          <span>{agreement.agreement_type || agreement.ownership_type || 'N/A'}</span>
                        </TableCell>
                        <TableCell>{agreement.park_id || '-'}</TableCell>
                        <TableCell>
                          <Tooltip title={agreement.investor_name || '-'}>
                            <Typography noWrap sx={{ maxWidth: 150 }}>
                              {agreement.investor_name || '-'}
                            </Typography>
                          </Tooltip>
                        </TableCell>
                        <TableCell>{agreement.contract_issued_on || agreement.contract_issue || '-'}</TableCell>
                        <TableCell>{agreement.contract_renewal_date || agreement.contract_renewal || '-'}</TableCell>
                        <TableCell>${safeToFixed(agreement.monthly_rent || 0, 2)}</TableCell>
                        <TableCell>
                          <span>{agreement.status || agreement.current_status || 'PENDING'}</span>
                        </TableCell>
                        <TableCell align="center">
                          <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center' }}>
                            <Tooltip title="Edit">
                              <IconButton size="small" onClick={() => handleEditClick(agreement)}>
                                <EditIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="View Details">
                              <IconButton size="small" onClick={() => handleViewDetails(agreement)}>
                                <ViewIcon />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination 
            rowsPerPageOptions={[5, 10, 25, 50, 100]} 
            component="div" 
            count={filteredAgreements.length} 
            rowsPerPage={rowsPerPage} 
            page={page} 
            onPageChange={(e, newPage) => setPage(newPage)} 
            onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }} 
          />
        </Paper>
        
        {renderViewDetailsDialog()}
      </Box>
    );
  };

  // ========== TAB 2: REJECTED AGREEMENTS ==========
  const renderRejectedTab = () => {
    const filteredAgreements = rejectedAgreements.filter(agreement => {
      if (!searchQuery) return true;
      const searchLower = searchQuery.toLowerCase();
      return (agreement.agreement_id || agreement.id || "").toLowerCase().includes(searchLower) ||
             (agreement.tenant_id || "").toLowerCase().includes(searchLower) ||
             (agreement.investor_name || "").toLowerCase().includes(searchLower) ||
             (agreement.park_id || "").toLowerCase().includes(searchLower);
    });

    return (
      <Box>
        <Typography variant="h5" sx={{ color: '#1976d2', fontWeight: 'bold', mb: 3 }}>
           Rejected Agreements
        </Typography>
        
        <Paper sx={{ p: 3, mb: 3 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={10}>
              <TextField
                fullWidth
                size="small"
                label="Search by ID, Tenant, Investor, UPIN, Park"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1, color: 'action.active' }} /> }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Stack direction="row" spacing={1}>
                <Button 
                  fullWidth 
                  variant="contained" 
                  onClick={fetchRejectedAgreements}
                  disabled={loadingRejected}
                >
                  {loadingRejected ? <CircularProgress size={24} /> : "Search"}
                </Button>
                <Button 
                  variant="outlined" 
                  startIcon={<RefreshIcon />} 
                  onClick={() => { 
                    setSearchQuery(""); 
                    fetchRejectedAgreements();
                  }}
                >
                  Reset
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Paper>

        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="body2" color="textSecondary">
            Total Rejected Agreements: {filteredAgreements.length}
          </Typography>
          <Button 
            size="small" 
            startIcon={<RefreshIcon />} 
            onClick={fetchRejectedAgreements}
            disabled={loadingRejected}
          >
            Refresh
          </Button>
        </Box>

        <Paper sx={{ width: '100%', overflow: 'auto' }}>
          <TableContainer sx={{ maxHeight: 600, minWidth: 1400 }}>
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow sx={{ backgroundColor: '#ffebee' }}>
                  <TableCell sx={{ fontWeight: 'bold', minWidth: 120 }}>ID</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Ownership Type</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Park ID</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', minWidth: 150 }}>Investor Name</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Contract Issued</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Contract Renewal</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Monthly Rent</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', minWidth: 250 }}>Description</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', minWidth: 120 }}>Status</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', minWidth: 120 }} align="center">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loadingRejected ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center" sx={{ py: 5 }}>
                      <CircularProgress />
                      <Typography variant="body2" sx={{ mt: 1 }}>Loading rejected agreements...</Typography>
                    </TableCell>
                  </TableRow>
                ) : filteredAgreements.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center" sx={{ py: 5 }}>
                      <Typography color="textSecondary">No rejected agreements found</Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredAgreements
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((agreement) => {
                      const cleanDescription = (() => {
                        const desc = agreement.description || '';
                        const cleanDesc = desc.split(' [REJECTED By Head ON:')[0];
                        return cleanDesc || '-';
                      })();
                      
                      return (
                        <TableRow key={agreement.id || agreement.agreement_id} hover sx={{ backgroundColor: '#fff5f5' }}>
                          <TableCell>{agreement.agreement_id || agreement.id || '-'}</TableCell>
                          <TableCell>
                            <span>{agreement.agreement_type || agreement.ownership_type || 'N/A'}</span>
                          </TableCell>
                          <TableCell>{agreement.park_id || '-'}</TableCell>
                          <TableCell>
                            <Tooltip title={agreement.investor_name || '-'}>
                              <Typography noWrap sx={{ maxWidth: 150 }}>
                                {agreement.investor_name || '-'}
                              </Typography>
                            </Tooltip>
                          </TableCell>
                          <TableCell>{agreement.contract_issued_on || agreement.contract_issue || '-'}</TableCell>
                          <TableCell>{agreement.contract_renewal_date || agreement.contract_renewal || '-'}</TableCell>
                          <TableCell>${safeToFixed(agreement.monthly_rent || 0, 2)}</TableCell>
                          <TableCell>
                            <Typography sx={{ 
                              maxWidth: 250, 
                              whiteSpace: 'normal',
                              wordBreak: 'break-word'
                            }}>
                              {cleanDescription}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <span>{agreement.status || agreement.current_status || 'REJECTED'}</span>
                          </TableCell>
                          <TableCell align="center">
                            <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center' }}>
                              <Tooltip title="View Details">
                                <IconButton size="small" onClick={() => handleViewDetails(agreement)}>
                                  <ViewIcon />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </TableCell>
                        </TableRow>
                      );
                    })
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination 
            rowsPerPageOptions={[5, 10, 25, 50, 100]} 
            component="div" 
            count={filteredAgreements.length} 
            rowsPerPage={rowsPerPage} 
            page={page} 
            onPageChange={(e, newPage) => setPage(newPage)} 
            onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }} 
          />
        </Paper>
        
        {renderViewDetailsDialog()}
      </Box>
    );
  };

  const mainTabs = ["Register / Edit Agreement", "Search & View", "Rejected Agreements"];

  return (
    <Container maxWidth="xl" className="app">
      <Snackbar open={toast.open} autoHideDuration={6000} onClose={handleToastClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert onClose={handleToastClose} severity={toast.severity}>{toast.message}</Alert>
      </Snackbar>

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={mainTabValue} onChange={(e, v) => setMainTabValue(v)} variant="fullWidth">
          {mainTabs.map((label, i) => <Tab key={i} label={label} />)}
        </Tabs>
      </Box>

      <TabPanel value={mainTabValue} index={0}>{renderEditTab()}</TabPanel>
      <TabPanel value={mainTabValue} index={1}>{renderSearchTab()}</TabPanel>
      <TabPanel value={mainTabValue} index={2}>{renderRejectedTab()}</TabPanel>

      {renderRoomDialog()}
      {renderShopDialog()}
    </Container>
  );
}

